/* eslint-disable */
/* 当前文件对应的国际化词库版本号: 9.7.1.202610281555 */
export default {
AbandonPaymentConfirm: "お支払いをキャンセルしてもよろしいですか？",
AboutUs: "会社概要",
AcceptanceScope: "対応範囲",
AccordingTo12306TicketsCanOnlyBePurchasedAfterThePhoneNumberHasBeenVerified: "12306の規定により、携帯電話番号の認証完了後のみ乗車券を購入できます。",
AccordingToDiDiComplianceCarServiceNeedsRedirectToDiDi: "DiDiのコンプライアンス要件に基づき、DiDiプラットフォームへ移動します。",
AccordingToYourCompanysTravelPolicy: "会社の出張規定に基づき、最安運賃のフライトが選択されていません。",
Account: "アカウント",
AccountCancel: "マイアカウントの削除",
AccountCancelAssetRightsReminder: "アカウント削除後、関連する資産および特典はすべて失効します。",
AccountCancelCannotRecoverCaution: "削除したアカウントは復元できません。慎重に操作してください。",
AccountCancelConfirmQuestion: "このアカウントを削除してもよろしいですか？",
AccountCancelConfirmReminder: "お客様の権益保護のため、再度ご確認ください：",
AccountCanceled: "アカウント削除済み",
AccountLogin: "アカウントログイン",
AccountName: "口座名義人",
AccountNotExist: "ユーザー名が存在しません",
AccountNumber: "請求番号",
AccountNumber_1: "アカウント",
AccountOperations: "電話番号の登録、パスワード変更など",
AccountProtocol: "アカウント利用許諾契約",
AccountProtocol_1: "「アカウント利用許諾契約」を読み、同意しました",
AccountProtocol_2: "ご提供いただく氏名、携帯電話番号、身分証番号などの情報は、12306アカウントのパスワード再設定および追加認証サービスのために利用されます。詳細は「アカウント利用許諾契約」をご確認ください。",
AccountProtocol_3: "「鉄道旅客実名制管理規定」に基づき、本サービスで列車チケットおよび関連サービスをご利用いただく際は、有効な本人確認情報の登録が必要です。本情報はチケット購入、乗車、払い戻し・変更、領収書発行などに利用されます。当社は暗号化などの安全対策により個人情報を保護し、必要な取引時のみ関連第三者へ提供します。詳細は「個人情報利用同意書」および「列車チケット予約案内」をご確認ください。",
AccountProtocol_3_key_1: "個人情報利用同意書",
AccountProtocol_3_key_2: "列車チケット予約案内",
AccountSecurity: "アカウントのセキュリティ",
AccountVerification12306: "12306アカウント認証",
AccountVerification12306Desc: "鉄道の実名制要件により、以下の方法で認証を行ってください。",
AccuratelyFillInTheAgeOfEachChildForSpecialOffers: "お子様それぞれの年齢を正確に入力してください。最適なお部屋タイプや特別料金をご案内します。",
AContactAlreadyExistsWithTheSamePhoneNumber: "同じ携帯電話番号の連絡先が既に存在します",
ActivityNotice: "イベント通知",
ActivityNoticeDesc: "キャンペーン通知",
ActualPayment: "支払金額",
Add: "追加",
AddAnotherTrip: "他の列車を追加",
AddBusiness: "追加（出張）",
AddContact: "連絡先を追加",
AddCostCenter: "コストセンターを追加",
AddDesignatedApprover: "指定承認者を追加",
Added: "追加済み",
AddEmergencyContact: "緊急連絡先を追加",
AddEmergencyContactPrompt: "緊急連絡先を追加すると、ワンタップ緊急通報利用時に行程情報がSMSで自動共有されます。",
AddFailed: "追加に失敗しました",
AddFlight: "フライトを追加",
AddFrequentContacts: "よく使う連絡先を追加",
AddFrequentTraveller: "よく利用する搭乗者に追加",
AddInvoiceHeader: "請求書名義を追加",
AdditionalTaxesFees: "別途税・手数料",
AddManually: "手動追加",
AddNewReimbursementInvoiceTitle: "経費精算用請求書宛名を追加",
AddPassenger: "利用者を追加",
AddPersonal: "追加（私用）",
Address: "詳細住所",
AddressDistrict: "エリア",
AddReturnTrip: "復路を追加",
AddRoute: "行程を追加",
AddSecurityExplain: "保障を追加して、ご家族も安心",
AddSecurityExplain_1: "安心の保障で、ご家族も安心",
AddSucceed: "追加しました",
AddTiedList: "連携済み一覧に追加",
AddTravelCard: "マイレージカードを追加",
AddTraveler: "追加 +",
AdministrativeDistrict: "行政区",
AdmissionPolicy: "チェックインポリシー",
Adults: "大人",
AdultsDesc: "12歳以上（含む）",
AfterClickingGoToPay: "「支払いへ」をタップ後、WeChatアプリの「スキャン」を開き、QRコードを読み取ってお支払いください。",
AfterClickingGoToPay_1: "「支払いへ」をタップ後、Alipayアプリの「スキャン」を開き、QRコードを読み取ってお支払いください。",
AfterLanding: "到着後",
AfterSendingTextMessage: "SMS送信後、12306から6桁の認証コードが届きますので、入力してください。",
AgentNoResponse: "AIアシスタントが応答していません。しばらくしてから再度お試しください。",
AggregatedCarService: "配車予約",
Agree: "同意する",
AgreeAndContinue: "同意して続行",
Agreement: "契約条件",
AgreementDesc: "契約内容",
AgreementHotels: "契約ホテル",
AgreementHotelStarRating: "契約ホテル星評価",
AgreementHotelTotal: "契約ホテル総額",
AgreementHotelTotalRoomNight: "契約ホテル総間夜数",
AgreementNight: "契約間夜数",
AIAssistant: "AIアシスタント",
AIAssistantAnswering: "AIアシスタントが回答中です。しばらくしてから再度お試しください",
AIBooking: "AI予約",
AIFillAssistant: "AI申請アシスタント",
AirChinaPassengerBaggageDomesticTransportationGeneralConditions: "中国国際航空 中国国際航空 国内旅客・手荷物運送約款 2017版（中国語版）",
AirfareYouSearchedFor: "最近検索した航空券",
Airline: "航空会社",
AirlineList: "航空会社一覧",
AirlinePassengerMaintenance: "航空会社旅客規則メンテナンス中",
AirLowestFareAcceptance: "最安値航空券予約比率",
Airport: "空港",
AirportDropOff: "空港送迎（送）",
AirportPickup: "空港送迎（迎）",
AirportPickupDropoff: "空港送迎",
AirportStation: "空港・駅",
AirportTerminal: "空港ターミナル",
AirportTransferService: "空港送迎サービス",
AirRouteAnalysis: "路線分析（エコノミークラスのみ）",
AirRouteAndCarrierAnalysis: "路線・航空会社分析",
AirTicketBookingInstructions: "航空券予約案内",
AirTicketConsumptionInDifferentCities: "都市別航空券利用状況",
AirTickets: "航空券料金",
Aisle: "通路",
AIXiaoShun: "Homsom AIアシスタント",
AlarmTripInfoShare: "通報後、行程情報はSMSで緊急連絡先に自動共有されます",
Album: "アルバム",
AliPay: "アリペイ決済",
Alipay: "アリペイ",
AlipayAccount: "Alipayアカウント",
AlipayAccountFormatError: "Alipayアカウントの形式が正しくありません",
AlipayAuthDescription: "アリペイへ遷移し、企業コードの開通認可を行います",
AlipayAuthorization: "アリペイ認可",
All: "すべて",
AllBookings: "予約履歴",
AllCabins: "全ての座席クラス",
AllCollection: "お気に入り一覧",
AllCompanyPayment: "会社負担",
AllLoaded: "すべて読み込み済み",
AllOrdersForRecentOneMonth: "過去6か月の出張申請書を表示しています",
AllOrdersForRecentOneYear: "全ての注文を表示済みです",
AllOrdersForRecentOneYear_1: "過去1年間の全注文を表示しています",
AllOrdersForRecentSixMonths: "過去6か月の全注文を表示しています",
AllowRecordPermission: "マイク権限を許可してください",
AlreadyHave12306Account: "すでに12306アカウントをお持ちですか",
AlreadySetting: "設定済み",
AlsoAvailableBy: "こちらも選択可能",
Amount: "金額",
Amount_1: "金額（税込）",
AmountOfBillForTheCurrentPeriod: "当月請求額",
AmountOfConsumption: "利用金額",
AmountPaidInThisPeriod: "当期支払済額",
AmountPayableInTheCurrentPeriod: "当期支払額",
AndroidPersonalizedRecommendation: "おすすめのカスタマイズ",
AndroidPersonalizedRecommendationDesc: "予約体験向上のため、パーソナライズされたおすすめを提供します",
AndroidSettingPrivacy: "プライバシー設定",
Announcement: "お知らせ",
AnnouncementInformation: "お知らせ詳細",
Any: "指定なし",
AnyCity: "都市指定なし",
Appearance: "表示モード",
Applicant: "申請者",
ApplicantForRefund: "払戻申請者",
Application: "申請",
ApplicationContent: "申請内容",
ApplicationDate: "申請日",
ApplicationForApproval: "承認申請",
ApplicationForBook: "申請書予約",
ApplicationIntlFlight: "国際航空券申請",
ApplicationIntlHotel: "海外ホテル申請",
ApplicationNumber: "申請番号",
ApplicationToReservedNoData: "予約可能な申請書はありません",
Apply: "申請",
ApplyForRefund: "払い戻し",
ApplyRefund: "払い戻し",
ApplyRefundOrder: "払い戻し",
ApplyReschedule_1: "変更",
ApplyTime: "申請時間",
ApplyTravel: "出張申請",
ApplyTravelCitys: "出張先都市",
ApplyTravelConfirm: "出張申請確認",
ApplyTravelNeeds: "出張要件",
ApplyTravelSegment: "旅程情報",
ApplyTravelTime: "出張日程",
ApproachingTakeoff: "離陸間近",
ApprovalExpired: "期限切れ",
ApprovalFail: "承認失敗",
ApprovalFlow: "承認フロー",
ApprovalInformation: "承認情報",
ApprovalInformationDesc: "承認状況通知",
ApprovalProcess: "承認プロセス",
ApprovalRejected: "差戻し",
ApprovalRejection: "却下",
ApprovalRemarks: "承認コメント",
Approvals: "承認",
Approvals_1: "承認一覧",
ApprovalSetting: "承認設定",
ApprovalStatus: "承認状況",
ApprovalSubmitted: "提出済み",
ApprovalTemplate: "承認テンプレート",
ApprovalTemplate_1: "マイテンプレート",
ApprovalTemplateConfig: "承認テンプレート設定",
ApprovalTemplateDetails: "テンプレート詳細",
ApprovalType: "承認方法",
ApprovalType_1: "承認の種類",
ApprovalWhitelist: "承認ホワイトリスト",
Approved: "承認済み",
ApprovedCanceled: "申請取り消し",
ApprovedPass: "承認済み",
Approver: "承認者",
ApproversHaveBeenBound: "指定承認者設定済み",
ApproxPay: "概算",
Area: "面積",
AreYouSureToAddThisAsAFrequentTraveler: "常客（お気に入り旅客）として追加しますか？",
AreYouSureToCancelTheOrder: "この注文をキャンセルしますか？",
AreYouSureToCancelUnableToSave: "変更内容が保存されていません。離れてもよろしいですか？",
AreYouSureToChange: "変更手続き（改札）を進めてもよろしいですか？",
AreYouSureToChangeTheCurrency: "通貨を変更しますか？",
AreYouSureToChangeTheLanguage: "言語を変更しますか？",
AreYouSureToChangeYourFlightToTheCheapestFlight: "最安値のフライトに変更しますか？",
AreYouSureToDelete: "削除してもよろしいですか？",
AreYouSureToDeleteTheApprover: "この承認者を削除しますか？",
AreYouSureToDeleteTheCertificate: "この証明書を削除しますか？",
AreYouSureToDeleteTheEmployeeFromTheWhitelist: "この従業員をホワイトリストから削除しますか？",
AreYouSureToDeleteTheRC: "この理由コード（RC）を削除しますか？",
AreYouSureToDeleteTheSelectedCollection: "選択したお気に入りを削除しますか？",
AreYouSureToDeleteThisCustom: "このカスタム項目を削除しますか？",
AreYouSureToDeleteThisEmployeeFromTheTemplate: "テンプレートからこの従業員を削除しますか？",
AreYouSureToPayForThisOrder: "この注文の支払いを進めますか？",
AreYouSureToRemoveItFromTheCostCenterList: "このコストセンターを削除しますか？",
AreYouSureToRemoveItFromTheDepartmentsList: "この部門を削除しますか？",
AreYouSureToRemoveItFromTheEmployeeList: "従業員リストから削除しますか？",
AreYouSureToRemoveItFromTheFrequentTravelerList_1: "「頻繁な旅行者」リストから削除しますか？（これにより、旅行者が「頻繁な旅行者」リストから削除されるのみです。従業員データは削除されません。従業員データを削除するには、[管理 > 従業員管理] にアクセスするか、専任のビジネス旅行アドバイザーにお問い合わせください。）",
AreYouSureToRemoveItFromTheFrequentTravellerList: "常客（お気に入り旅客）リストから削除しますか？",
AreYouSureToRemoveItFromTheNonEmployeeList: "外部人員リストから削除しますか？",
AreYouSureToRescheduled: "変更手続き（改期）を進めてもよろしいですか？",
AreYouSureToSeat: "座席を確定しますか？",
AreYouSureToSubmit: "送信しますか？",
AreYouSureToSubmitAndPayForTheOrder: "注文の提出と支払いを進めますか？",
AreYouSureToSubmitYourOrder: "注文を提出しますか？",
AreYouSureToTurnOffFaceIDLogin: "Face IDログインを無効にしますか？",
AreYouSureYouWantToDeleteThisAccount: "アカウントを削除しますか？",
AreYouSureYouWantToLogout: "ログアウトしますか？",
AreYouSurYouWantToDeleteThisAccount: "アカウントを削除しますか？",
AreYouSurYouWantToLogout: "ログアウトしますか？",
AreYouSurYouWantToUntieThisAccount: "連携を解除しますか？",
Arrival: "到着",
ArrivalCity: "到着都市",
ArrivalCityAddress: "目的地",
ArrivalCityAddressDesc: "出張の経由地はすべて目的地に追加する必要があります。",
ArrivalCityOptions: "到着都市（任意）",
ArrivalDate: "到着日",
ArrivalEarliest: "到着時刻（早い順）",
ArrivalLatest: "到着時刻（遅い順）",
ArrivalStation: "下車駅",
ArrivalStation_1: "下車駅",
ArrivalTerminal: "到着ターミナル",
ArrivalTime: "到着時間帯",
ArrivalTime_1: "到着時刻",
ArrivalTime_2: "到着駅・時間",
ArrivalTimeDepartureDate: "到着予定時刻／チェックアウト日",
ArrivalTimeIsLocalTime: "到着時刻は現地時間です。",
Arrive: "送り先",
ArriveAddress: "降車場所",
Associated12306Account: "12306アカウント連携",
AtNoonToday: "本日正午",
AttachFile: "添付ファイル",
AttachFileUploadExplain_1: "・最大10ファイルまで、各ファイル8MB以内でアップロード可能です。",
AttachFileUploadExplain_2: "・対応ファイル形式：img、word、ppt、excel、pdf",
AUD: "AUD",
Authentication: "本人確認",
AuthenticationProtocol: "「認証規約」",
AuthenticationProtocol_1: "認証規約を読み、これに同意します",
AuthResultNotFound: "認可結果を取得できませんでした。Alipayで開通済みか確認してください。",
AutoCorrect: "オートコレクト",
AutoCorrectIdentityInfo: "身分証情報をもとに以下の項目を自動補正しました",
Available: "利用可能",
AvailableIntegral: "利用可能ポイント",
AvailableTickets: "空席あり",
AverageBusinessTravelFare: "出張平均運賃",
AverageDiscount: "平均割引率",
AverageDomesticDiscount: "国内線平均割引率（エコノミー）",
AverageHotelPrice: "ホテル平均客室単価",
AverageMileagePrice: "マイル当たり平均単価（エコノミーのみ）",
AverageNumberOfDaysBookedInAdvance: "平均事前予約日数",
AveragePrice: "平均価格",
AveragePriceOfBusinessTravelAgreement: "法人契約平均単価",
AveragePriceOfBusinessTravelMileage: "マイル当たり平均単価",
AverageTicketPrice: "平均運賃",
AverageTrainTicketPrice: "鉄道平均運賃",
AVerificationMessagePleaseEnterTheVerificationCodeYouReceived: "認証コードを送信しました。受信したコードを入力してください。",
AvgTicketPriceOfMileage: "マイル当たり平均単価",
AwaitingConfirmation: "確認待ち",
AwayFrom: "距離",
Baby: "幼児",
BabyDesc: "生後14日以上〜2歳未満",
BabyNonBookable: "幼児予約不可",
BabyNonSupportBookable: "幼児航空券のご予約は、担当のトラベルコンサルタントまでお問い合わせください。",
BabyReQuery: "このフライトは幼児の予約ができません。幼児をお連れの場合は、別のフライトを再検索してください。",
BabyTooSmallNonBookable: "生後14日未満の乳幼児はご予約いただけません。",
BabyWith: "幼児連れ",
BabyYearsOld: "生後14日～2歳",
Back: "戻る",
BackFlight: "復路便",
BackModify: "修正に戻る",
BackToHome: "ホームへ戻る",
BackToHotelList: "ホテル一覧に戻る",
BackToLogin: "ログイン画面に戻る",
Baggage: "手荷物",
BaggageCarousel: "手荷物ターンテーブル",
BaggagePolicy: "手荷物規定",
Balance: "残高",
Bank: "金融機関名",
BankAccount: "口座番号",
BankCardInformation: "クレジットカード情報",
BasicInformation: "基本情報",
BasicInformationIsIncompletePleaseEdit: "基本情報に不備があります。編集してください。",
Batch: "一括管理",
BatchInvoiceIssuing: "一括請求書発行",
BatchPass: "一括承認",
BedType: "ベッドタイプ",
BeforeUsingDiDiPlatformPleaseFillCarBookingOrder: "配車サービスをご利用になる前に、車両予約申請書をご記入ください。",
BeijingTime: "北京時間",
BeingApprovalByTheFlightCompany: "航空会社審査待ち",
BeingVerified: "確認中",
BelongCity: "都市",
BeOverdueByCarPleaseCheckAgain: "車両情報が更新された可能性があります。再検索してください。",
BeOverdueByFlightPleaseCheckAgain: "フライト情報が更新された可能性があります。再検索してください。",
BeOverdueByHotelPleaseCheckAgain: "ホテル情報が更新された可能性があります。再検索してください。",
BeOverdueByTrainPleaseCheckAgain: "列車情報が更新された可能性があります。再検索してください。",
BigBed: "ダブルベッド",
BillEndDate: "請求締め日",
BillGrouping: "請求グループ",
BillingPeriod: "請求サイクル",
BillStartDate: "請求開始日",
Bind: "連携する",
BindFailed: "連携に失敗しました",
Binding: "アカウント連携",
BindingCTrip: "Ctripアカウント連携",
BindingCTripDesc: "ご入力の携帯電話番号でCtrip個人アカウントと連携します。未登録の場合、Homsomが同番号で新規会員登録を行います。",
BindingCTripPrivacy: "Ctripの「利用規約」および「プライバシーポリシー」に同意する",
BindingCustomItems: "カスタム項目の紐付け",
BindingEmployees: "従業員の紐付け",
BindingHuazhu: "華住アカウント連携",
BindingHuazhuDesc: "ご入力の情報で華住（Huazhu）の法人契約と連携します。未登録の場合、Homsomが同情報で新規会員登録を行います。",
BindingHuazhuPrivacy: "華住の「利用規約」および「プライバシーポリシー」に同意する",
BindingLogin: "ワンクリック連携",
BindingMeituan: "美団アカウント連携",
BindingMeituanDesc: "ご入力の情報で美団（Meituan）の法人契約と連携します。未登録の場合、恒順商旅が同情報で新規会員登録を行います。",
BindingMeituanPrivacy: "美団の「利用規約」および「プライバシーポリシー」に同意する",
BindingStatus: "連携ステータス",
BindMailbox: "メールアドレス連携",
BindMembersToEnjoyLowerPrices: "会員連携でさらにお得",
BindSuccessfully: "連携完了",
BindUnbind: "連携/解除",
BlankImport: "空白テンプレート取込",
BoardingGate: "搭乗口",
Book_1: "予約",
Book_2: "今すぐ予約",
Book_3: "予約",
BookableNights: "予約可能宿泊数",
BookableTimes: "予約可能回数",
BookAllStaff: "全従業員予約可能",
BookCar: "車両予約",
BookDesignatedDepart: "指定部署を予約可能",
BookDesignatedStaff: "指定従業員予約可能",
BookDomesticFlights: "国内航空券予約",
BookDomesticHotel: "国内ホテル予約",
Booker: "予約者",
BookFinished: "売り切れ",
BookFlight: "航空券予約",
BookHotel: "ホテル予約",
BookInAdvance: "事前予約",
Booking: "予約",
BookingApprovalFlow: "予約承認フロー",
BookingDaysInAdvance: "事前予約日数",
BookingInformation: "予約情報",
BookingInstructionsAndInstructionsForReturning: "予約・変更取消について",
BookingLevel: "予約レベル",
BookingMail: "予約メール",
BookingMethods: "予約方法",
BookingPwd: "予約パスワード",
BookingRange: "予約範囲",
BookingSMS: "予約SMS",
BookingSource: "予約元",
BookingSucceed: "予約完了",
BookingTheBus: "バス予約",
BookingTheCar: "配車予約",
BookingTheMeals: "食事予約",
BookInternationalFlights: "国際航空券予約",
BookInternationalHotel: "海外ホテル予約",
BookOnlySelf: "本人のみ予約可能",
BookPermissions: "予約権限",
BookPwdAbandon: "キャンセル",
BookPwdContinuePayment: "支払いを続ける",
BookPwdSetPasswordFormatError: "6桁の数字パスワードを入力してください",
BookPwdSetPasswordHint: "6桁の数字を入力してください",
BookTheLowestLogicalFare: "最低運賃を予約",
BookTrain: "鉄道予約",
BookType: "予約タイプ",
Bound: "連携済み",
BoundCustomItems: "連携済みカスタム項目",
BoundEmployees: "連携済み従業員",
Brand: "ブランド",
BrandSlogan: "出張ならHomsom。もっとスムーズ、もっと快適に",
Breakfast: "朝食付き",
Breakfast_1: "朝食",
BrowserOpens: "ブラウザで開く",
Budget: "予算",
BudgetAmount: "予算額",
BudgetColon: "予算：",
BulkRejection: "一括却下",
Business: "業務",
BusinessCenter: "ビジネスセンター",
BusinessClass: "ビジネス",
BusinessConsultant: "ビジネスコンサルタント",
BusinessConsumptionNoPersonalPayment: "Homsomで鉄道チケットを予約して企業支払いを利用するには、アリペイ企業コードの開通が必要です。個人による立て替え払いは不要です",
BusinessDistrict: "ビジネス街",
BusinessDistrictInfrastructureBrandEtc: "商圏／インフラ／ブランドなど",
BusinessReschedule: "出張変更",
BusinessTravel: "出張",
BusinessTravelScale: "企業出張規模（月次）",
BusinessTrip: "出張",
BusinessTripApply: "出張申請",
BusinessTripFormGenerated: "出張申請書が作成されました",
BusinessTripFormTravelInfo: "出張申請書（旅程情報）",
BusinessTripSchedule: "出張スケジュール",
BusinessType: "業務タイプ",
BusinessType_1: "業務",
BusinessUnit: "事業部",
BusOrderConfirmation: "バスチケット注文確認",
BusOrderDetails: "バスチケット詳細",
BusRank: "バス差額基準",
BusRefundOrderConfirm: "バスチケット払戻確認",
BusStation: "バスターミナル",
BusTicket: "バスチケット",
BusTicketOrder: "バスチケット注文",
ByMail: "メールで",
ByPhoneNumber: "携帯番号で",
Cabin: "座席クラス",
CabinInformationHasBeenUpdated: "座席情報が更新されました。注文内容をご確認のうえ、再入力してください。",
CabinLevel: "座席クラス",
CabinType: "座席タイプ",
CAD: "カナダドル",
Calendar: "カレンダー",
CallCar: "配車",
CallCarNow: "今すぐ配車",
CallingCarCancelConfirm: "配車中です。キャンセルしますか？",
CallingForYou: "配車中...",
CallingVehicleForYou: "配車中",
CallPhone: "電話する",
CallTaxiAgain: "再度配車",
CallThePolice: "110番通報",
Camera: "カメラ",
CameraPermissionRetryMessage: "カメラ権限が必要です。再度有効にしますか？",
CameraPermissionSettingsMessage: "カメラ権限が無効です。システム設定より有効にしてください。",
CameraPermissionUsageMessage: "画像情報を取得し、QRコード読み取り、撮影、顔認識などの機能に利用します。",
CameraPermissionUsageTitle: "カメラ権限の利用目的",
Cancel: "キャンセル",
Cancel_1: "今回は見送る",
Cancel_2: "キャンセル管理",
CancelAnyway: "キャンセルを続ける",
Canceled: "キャンセル済み",
CancelFailed: "キャンセル失敗",
CancelFee: "キャンセル料",
CancelForFree: "無料キャンセル",
CancelInformation: "キャンセル情報",
CancelInquiry: "申請をキャンセル",
Cancelling: "キャンセル中...",
CancelOrder: "注文をキャンセル",
CancelReason: "キャンセル理由",
CancelRefund: "払い戻しをキャンセル",
CancelRoomSelectTitle: "キャンセルする部屋を選択",
CancelRules: "キャンセルポリシー",
CancelSucceed: "キャンセル成功",
CannotBeCancelled: "キャンセル不可",
CannotBeConvertToPinyin: "中国語氏名未入力のため、ピンイン変換できません",
CannotOpenAlipayUseQRCode: "アリペイを開けませんか？QRコードを読み取ってお支払いください",
CannotSelectGuestRepeat: "宿泊者を重複して選択できません",
CanNotSupportedFileType: "未対応のファイル形式です",
Car: "配車",
CarAirport: "空港送迎",
CarApplication: "配車申請",
CarbonEmission: "CO₂排出量",
CarbonOffset: "カーボンオフセット",
CardHolder: "カード名義人",
CardholderInformation: "カード名義人情報",
CardNumber: "カード番号",
CardType: "カード種類",
CarFare: "料金",
CarOrder: "配車注文",
CarOrderConfirmation: "配車注文確認",
CarPlatform: "配車プラットフォーム",
CarRank: "配車基準",
Carrier: "運航会社",
Carrier_1: "運航会社",
CarrierAnalysis: "運航会社分析",
CarriersItineraries: "運航会社・路線",
CarScene: "利用シーン",
CarServiceTime: "利用時間",
CarTrain: "駅送迎",
CarType: "車種",
CellphoneNumber: "電話番号",
CertificateInformation: "身分証明書",
Change: "変更",
Change_3: "12306アカウント切替",
ChangeDetails: "変更詳細",
ChangeDetails_1: "変更内容",
ChangeFaceCheck: "顔認証を切り替え",
ChangeFailed_1: "変更失敗",
ChangeFee: "変更手数料",
ChangeFlight: "便を変更",
ChangeFlightSchedule: "変更後の便",
ChangeIDNoVerify: "本人確認番号認証に切替",
ChangeInstructions: "変更条件",
ChangeLoginPwd: "ログインパスワード変更",
ChangeMobileNumber: "携帯電話番号を変更",
ChangeMobileNumber_1: "携帯電話番号を変更",
ChangePassword: "パスワードを変更",
ChangePolicy: "変更条件",
ChangeRate: "変更率",
ChangeSchedule: "旅程を変更",
ChangeSegment: "旅程を変更",
ChangeSegmentDate: "日時変更",
ChangeSmsCheck: "SMS認証を切り替え",
ChangeStation: "到着駅を変更",
ChangeStationTitle: "駅変更のお知らせ",
ChangeSuccessFailed: "変更失敗",
ChangeYourFlightAndContinueDeparting: "別のフライトを選択して、旅を続けましょう。",
Changing: "変更中",
Charge: "料金",
ChargebackDateTime: "払戻申請日時",
ChargebackDetails: "払戻詳細",
ChargebackNumber: "払戻番号",
ChargebackRoom: "キャンセル部屋数",
ChargebackTime: "キャンセル日",
ChargeByAirlineRefundRules: "航空会社の払戻・変更規定に基づき手数料が発生します。",
ChargedAccordingToTheCorrespondingAirlineTicketRegulations: "該当する航空会社の航空券規定（NFD）に基づき手数料が発生します。",
CheapestFlight: "最安値フライト",
CheapFlights: "格安航空券",
Check: "認証",
CheckerInformation: "宿泊者情報",
CheckIn: "チェックイン",
CheckInAppOpenOrDownloadTips: "アプリがインストール済みの場合は「開く」をタップしてください。未インストールの場合は「ダウンロードへ」をタップし、インストール後にチェックイン手続きを行ってください。",
CheckInCity: "宿泊都市",
CheckInCounter: "チェックインカウンター",
CheckInCounterIsClosedNotBookedYet: "チェックインカウンターは終了しました。現在予約できません。",
CheckInDate: "チェックイン日",
CheckInformation: "情報を確認",
CheckingForTheLatestPriceForYou: "最新価格を確認しています。しばらくお待ちください...",
CheckInHotel: "ホテルにチェックイン",
CheckInRules: "チェックインポリシー",
CheckInSeat: "搭乗手続き＆座席選択",
CheckInTime: "チェックイン時間",
CheckInViaAppBelow: "以下のアプリでチェックイン手続きを行えます。",
CheckOrder: "注文を確認",
CheckOut: "チェックアウト",
CheckOutDate: "チェックアウト日",
CheckRemainRoomType: "残りの客室タイプを見る",
CheckTheCancellationRules: "キャンセルポリシーを確認",
CheckTheDifference: "出張規定の詳細を見る",
CHF: "スイスフラン",
ChildOfAge: "子供の年齢",
Children: "子供",
ChildrenAndBabyExplain: "小児・幼児の予約説明",
ChildrenDesc: "2歳以上12歳未満",
ChildrenNonBookable: "小児予約不可",
ChildrenNonSupportBookable: "小児航空券の予約は、出張手配担当者にお問い合わせください。",
ChildrenReQuery: "このフライトでは小児を予約できません。小児予約可能なフライトを再検索してください。",
ChildrenWith: "子連れ",
ChildrenYearsOld: "2～12歳",
China: "国内",
China_1: "中国（香港・マカオ・台湾含む）",
China_3: "中国",
ChinaRegion: "国内（香港・マカオ・台湾含む）",
ChinaSouthernAirlinesNewRegulations: "南方航空のお知らせ：乗客は南方航空アプリまたはWeChatから航空券の変更・払戻が可能で、払戻金を直接受け取れます。乗客が南方航空で直接払戻を行った場合でも、弊社は貴社へ元の航空券代金を全額請求いたします。",
ChineseName: "中国語氏名",
Choose: "選択",
ChooseAirport: "空港を選択",
ChooseBU: "BUを選択",
ChoosePhotos: "写真を選択",
ChooseSnatchSeat_1: "高速鉄道・都市間鉄道の座席を選択",
ChooseSnatchSeat_2: "普通・特急・その他の座席を選択",
ChooseTheLowestPriceToSave: "最安値を選択",
ChooseTheReason: "選択理由",
ChooseTrainStation: "駅を選択",
CICO: "チェックイン/チェックアウト",
CICO_1: "チェックイン/チェックアウト日",
City: "都市",
City_1: "出発・到着都市別",
CityAnalysis: "都市分析",
ClassAnalysis: "キャビン分析",
ClassHotel: "ホテルタイプ",
ClassRoomTypeSeat: "キャビン/部屋タイプ/座席",
Clear: "クリア",
ClearAllChat: "すべてのチャットを削除",
ClearCache: "キャッシュをクリア",
ClearFilters: "フィルターをクリア",
ClearHistory: "履歴を削除",
ClearHistorySearchRecord: "検索履歴を削除",
ClearHistorySearchRecordConfirmTip: "検索履歴は削除後に復元できません。削除しますか？",
ClearSuccess: "削除完了",
ClickLogin: "ログイン",
ClickNextToIndicateThatYouHaveAcceptedAndAreAwareOfTheRefundPolicyForThisTicket: "「次へ」をタップすると、この航空券の払戻・変更規定に同意したものとみなされます。",
ClickOptionToChangeDropOffPoint: "タップして降車場所を変更",
ClickOptionToChangePickUpPoint: "タップして乗車場所を変更",
ClickRefresh: "更新",
ClickShrink: "折りたたむ",
ClickToCopyShareCode: "コードをコピー",
ClickToDownloadApp: "アプリをダウンロード",
ClickToOpen: "タップして開く",
ClickToResend: "再送信",
ClickToSetTheAddress: "タップして住所を設定",
ClickToView: "表示",
Close: "閉じる",
Closed: "クローズ済み",
CloudBill: "クラウド請求",
CloudQuickPay: "銀聯QR決済",
CO2Emissions: "CO₂排出量",
CodeShare: "コードシェア",
Collect: "お気に入り",
ComfortHotel: "コンフォートホテル",
ComfortHotel_1: "コンフォート",
CommentsDetails: "口コミ詳細",
CommodityDetails: "商品詳細",
CommonAddress: "よく使う住所",
CommonOperations: "よく使う操作",
Company: "会社",
CompanyInfo: "会社情報",
CompanyInvoiceHeader: "会社宛名",
CompanyName: "会社名",
CompanyPayment: "法人支払い",
CompanyPaymentPrepay: "法人支払い（前払い）",
CompanyTel: "会社電話番号",
CompleteVerification: "認証を完了する",
ComprehensiveTravelSafety: "出張を総合的にサポート",
Confirm: "確認",
Confirm_1: "確認",
Confirm_2: "選択完了",
Confirm_3: "確認",
ConfirmAndNext: "確認して次へ",
ConfirmationOfFirstTimeBookingInformationForPassenger: "初回予約情報確認",
ConfirmationOfFirstTimeBookingInformationForPassengerDesc: "予約前に旅行者情報をご確認ください。修正が必要な場合は「修正」をタップしてください。",
ConfirmationOfFirstTimeBookingInformationForPassengerVehicle: "初回予約情報確認",
ConfirmationOrder: "確認書",
ConfirmCancel: "キャンセル確認",
ConfirmClearAllChat: "すべての会話を削除しますか？",
ConfirmCopyRedirectLink: "遷移リンクをコピーしますか？",
ConfirmDelete: "削除確認",
ConfirmDeleteInvoiceTitle: "この請求書宛名を削除しますか？",
ConfirmDeparture: "終了確認",
ConfirmDropOffPoint: "降車地点を確認",
Confirmed: "確認済み",
ConfirmedCallCar: "確認済み、今すぐ配車",
ConfirmedCheckInTimeAtTheCounterCanBeBooked: "チェックイン時間確認済み、予約を続けます。",
ConfirmedRedirectToDiDiCarHailing: "確認済み、DiDiへ移動します",
ConfirmImmediately: "今すぐ確認",
Confirming: "確認中",
ConfirmMail: "確認メール",
ConfirmPay: "支払い確認",
ConfirmPickUpPoint: "乗車地点を確認",
ConfirmPoint: "地点を確認",
ConfirmRules: "確認ルール",
ConfirmSelection: "選択を確認",
ConfirmSMS: "確認SMS",
ConfirmStartReserveSeat: "座席確保を開始しますか？",
ConfirmSubmission: "提出確認",
ConfirmThatYourDiDiAccountIsLinked: "DiDiアカウントが連携済みか確認しますか？",
ConfirmTheChanges: "変更を確認",
ConfirmTheChanges_1: "変更を確認",
ConfirmTheNewPassword: "新しいパスワードを確認",
ConfirmTheNewPassword_1: "パスワード確認",
ConfirmTheRemovalOfTheirDocuments: "証明書を削除しますか？",
ConfirmToResendApprovalInformation: "承認情報を再送しますか？",
ConfirmUnbindEnterpriseCode: "連携を解除すると、企業コード決済をご利用いただけなくなります。解除してもよろしいですか？",
ConfirmUnbinding: "リンク解除しますか？",
ConfirmUpdate: "更新確認",
ConfirmVoucherContent: "証憑内容の確認",
ConsistentWithIdPinyin: "証明書記載のピンインと一致",
Consultant: "専属コンサルタント",
ConsumptionOfCarsInDifferentCities: "都市別用車利用額",
ConsumptionOfTrainTicketsInEachCity: "都市別鉄道利用額",
ContactAdministratorToEnable: "管理者に連絡して権限を申請してください～",
ContactCustomerService: "カスタマーサポート",
ContactDetails: "連絡先詳細",
ContactDriver: "ドライバーに連絡",
ContactHotel: "ホテルに連絡",
ContactInfo: "連絡先情報",
ContactInformation: "連絡先情報",
ContactName: "連絡先名",
ContactNumber: "連絡先電話番号",
ContactNumberColon: "電話番号：",
ContactPhoneNumber: "連絡先携帯番号",
ContactPhoneNumberCannotBeDuplicated: "連絡先の携帯番号は重複できません。",
Contacts: "連絡先",
ContactsPermissionRetryMessage: "連絡先権限が必要です。再度有効にしますか？",
ContactsPermissionSettingsMessage: "連絡先権限が無効です。システム設定より有効にしてください。",
ContactsPermissionUsageMessage: "連絡先から選択した相手の情報を取得するために利用します。",
ContactsPermissionUsageTitle: "連絡先権限の利用目的",
ContactUsByPhoneIfFaceRecognitionFails: "顔認証できない場合はお電話ください。",
Content: "内容",
ContentIsEmpty: "内容を入力してください",
Continue: "続行",
ContinueBooking: "予約を続ける",
ContinueBooking_1: "予約を続ける",
ContinueBookingFlightTicket: "フライト予約を続ける",
ContinueBookingHotel: "ホテル予約を続ける",
ContinueBookingTrainTicket: "列車予約を続ける",
ContinueBookingWithoutRescheduling: "日付を変更せず続行",
ContinueFlightTicketInquiry: "航空券見積を続ける",
ContinueInput: "入力を続ける",
ContinueIssuingInvoice: "発票発行を続ける",
ContinueManualChange: "続行",
ContinueManualRefund: "続行",
ContinueReserveCar: "用車予約を続ける",
ContinueRide: "乗車を続ける",
ContinuetoBook: "元のフライト予約を続ける",
ContinueToChange: "変更を続ける",
ConvertToPinyin: "ピンイン変換",
Copy_1: "コピー",
CopyFailed: "コピーに失敗しました",
CopyInvitationInformation: "招待情報をコピー",
CopyInvitationLink: "招待リンクをコピー",
CopyLink: "PDFリンクをコピー",
CopyLinkToBrowserForPay: "決済画面へ正常に遷移しない場合は、下記のリンクをコピーしてSafariまたはブラウザに貼り付けて決済を完了してください。",
CopyLinkToSafariOrBrowser: "リンクをSafariまたはデフォルトブラウザにコピーして開いて支払いを完了してください",
CopyShareCodeToAlipay: "コードをAlipayにコピー",
CopySuccess: "コピーしました",
CopySuccessPasteInAlipay: "コピーしました。Alipayに貼り付けて開いてください。",
CopyTheLink: "リンクをコピー",
CopyToClipboard: "クリップボードにコピー",
CorporateTourism: "法人旅行",
CostCenter: "コストセンター",
CostCenterName: "コストセンター名",
CreationDate: "作成日",
CreationTime: "作成日時",
Credential: "本人確認書類",
CreditCard: "クレジットカード",
CreditCardGuarantee: "クレジットカード保証",
CreditGuarantee: "信用保証",
CrisisPoliceHelp: "緊急時は警察にご連絡ください。",
CrossRegionCarHailing: "跨地域配車",
Currency: "通貨",
CurrencySelectedIncorrectly: "通貨の選択が正しくありません。再度選択してください。",
CurrencySetting: "通貨設定",
Current: "現在",
CurrentAdvancePayment: "現在の前払い金",
CurrentAvailable: "現在利用可能",
CurrentCityNoCarService: "現在、この都市では当該時間帯のサービスをご利用いただけません。",
CurrentFld: "現在利用可能な代金豆",
CurrentIntergral: "現在のポイント",
CurrentLocatedCity: "現在地の都市",
CurrentLocation: "現在地",
CurrentLocationReference: "現在地（参考用）",
CurrentLxd: "現在利用可能なTravel Beans",
CurrentlyBusiness: "現在、出張に関する検索のみご利用いただけます。",
CurrentlyOnlineInsuranceOnlySupportsTheFirstSegment: "オンライン保険は現在、第一区間のみ購入可能です。",
CurrentlyOnlyDomesticAirTickets: "現在、国内航空券のみ利用可能です。",
CurrentlyPrivate: "現在、個人旅行検索のみ利用可能です。",
CurrentMobile: "現在の携帯番号：",
CurrentPageDownload: "現在のページをダウンロード",
CurrentPassword: "現在のパスワード",
CurrentPosition: "現在地（参考用）",
CurrentSelectedLocation: "選択中の位置",
CurrentVersion: "現在のバージョン",
Custom: "カスタム",
CustomerChoosesThePrice: "顧客が価格を選択",
CustomerExperienceFirst: "顧客体験を最優先",
CustomerServiceSupport: "カスタマーサポート",
CustomItems: "カスタム項目",
CustomizationsBound: "カスタム項目を連携済み",
CustomUseFld: "代金豆利用数を指定",
CustomUseLxd: "Travel Travel Beans利用数を指定",
DangerHelp: "危険な場合は警察にご連絡ください。",
Dark: "ダークモード",
DataUpTo: "データ更新日時",
Date: "日付",
DateIsTheLocalDateOfDepartureCity: "選択された日付は出発地の現在日付です。",
DateOfBirth: "生年月日",
DateOptions: "選択可能日",
DeductionLxd: "差引",
DeductionRequired: "控除必要額",
Default: "デフォルト",
Delete: "削除",
Delete_1: "削除",
DeleteFollow: "フォロー解除",
DeleteFrequentFlyer: "マイレージ会員情報を削除",
DeleteLocation: "場所を削除",
DeleteSuccessFailed: "削除に失敗しました",
DeleteSuccessful: "削除完了",
DeleteTrip: "旅程を削除",
DeliveryAddress: "配送先住所",
DeliveryAfterSuccessfulBooking: "予約完了後に進呈",
DeliveryCity: "配送先都市",
DeliveryInfo: "配送情報",
DeliveryMethod: "配送方法",
DepartingColon: "往路：",
DepartingNow: "すぐ出発",
Department: "部署",
DepartmentName: "部署名",
DepartTime: "出発時刻",
Departure: "出発",
Departure_1: "乗車地点",
DepartureCity: "出発都市",
DepartureCityAddress: "出発地",
DepartureCityAndArrivalCityCannotBeSame: "出発地と到着地は同じにできません",
DepartureCityOptions: "選択可能な出発都市",
DepartureDate: "出発日",
DepartureDateLocation: "出発日（現地時間）",
DepartureDateOptions: "選択可能な出発日",
DepartureEarliest: "出発時刻（早い順）",
DepartureEarliest_1: "出発時刻（早い順）",
DepartureLatest: "出発時刻（遅い順）",
DepartureLatest_1: "出発時刻（遅い順）",
DepartureStation: "出発駅",
DepartureTerminal: "出発ターミナル",
DepartureTime: "出発時間帯",
DepartureTime_1: "乗車駅／時間",
DepartureTime_2: "出発時刻",
DepartureTime_3: "出発時間帯",
DepartureTimeCheckInDate: "出発時刻／チェックイン日",
DescribeYourNeeds: "ご要望をお聞かせください",
DesignateApprover: "指定承認者",
DestinationOptions: "選択可能な目的地",
Detail: "詳細",
Details: "詳細",
Details_1: "詳細を見る",
DetectedNewVersion: "新しいバージョンがあります",
DidiDriverIsComing: "ドライバーが向かっています",
DiDiTravel: "DiDi",
DifferentFromTheDepartingAirport: "往路の出発空港と異なります",
DifferentFromTheOriginalScheduledArriveAirport: "元の到着空港と異なります",
DifferentFromTheOriginalScheduledDepartureAirport: "元の旅程の出発空港と異なります",
DifferentFromTheOriginalScheduledDepartureAndrArriveAirport: "元の旅程の出発・到着空港と異なります",
DiffPrice: "差額",
Dimension: "分析軸",
Dimension_1: "多次元分析",
Diner: "利用者",
DinerDetail: "利用者詳細",
DinerInfomation: "利用者情報",
DinerName: "利用者名",
Dingtalk: "DingTalk",
DingTalkByAccount: "DingTalkアカウント",
DingTalkByUser: "DingTalk社員アカウント連携",
Direct: "直行便",
DirectFlightFirst: "直行便優先",
DirectionsForUse: "利用方法",
DirectlyOpenAlipay: "Alipayを開く",
Disagree: "却下",
DiscountDistribution: "割引分布",
DiscountInterval: "割引区間",
DisplayTicketPrice: "運賃を表示",
DistanceLowToHigh: "直線距離（近い順）",
DistanceNearToFar: "距離が近い順",
DocumentDetails: "資料詳細",
DocumentInformationVerificationFailed: "証明書情報の確認に失敗しました",
DocumentSignatory: "発行国・地域",
DomAverageDiscount: "国内線平均割引率（エコノミー）",
DomesticFlights: "国内航空券",
DomesticFlights_1: "国内航空券（香港・マカオ・台湾除く）",
DomesticFlightsApplication: "国内航空券申請",
DomesticFlightsOrderConfirmation: "国内航空券予約確認",
DomesticHotel: "国内ホテル",
DomesticHotel_1: "国内ホテル（香港・マカオ・台湾含む）",
DomesticHotelApplication: "国内ホテル申請",
DomesticHotelOrderConfirmation: "国内ホテル予約確認",
DomesticHotelOrders: "国内ホテル予約",
DomesticServicePhone: "国内サービス窓口",
DomesticTicketChange: "国内航空券変更",
DomesticTicketChangeApplication: "国内航空券変更申請",
DomesticTicketOrder: "国内航空券予約",
DomesticTicketRefundApplication: "国内航空券払戻申請",
DomFullFareTicketRate: "国内正規運賃比率",
DoNotChange: "変更不可",
DoNotChangeBack: "払戻・変更不可",
DoNotChooseForNow: "今回は選択しない",
DoNotUse: "使用しない",
DoNotUseFld: "代金豆を使用しない",
DoNotUseLxd: "Travel Beansを使用しない",
DoubleSIMDeviceTip: "本端末はデュアルSIM対応です。SMS送信時は正しい番号を選択してください。",
Download: "ダウンロード",
DownloadAll: "すべてダウンロード",
Downloaded: "ダウンロード済み",
DownloadFailed: "ダウンロードに失敗しました",
DownloadPolicy: "保険証券をダウンロード",
DownloadSchedule: "明細表をダウンロード",
DownloadTemplate: "テンプレートをダウンロード",
DownloadTheQRcode: "QRコードをダウンロード",
DowntownCenter: "市内中心部",
DoYouWantToLeaveHumanCustomerService: "有人チャットを終了しますか？",
DoYouWantToSwitchToPerson: "個人アカウントに切り替えますか？",
DoYouWantToSwitchToUnit: "法人アカウントに切り替えますか？",
DragMapToSetPoint: "地図をドラッグして地点を選択",
DrillMultipleChoice: "ダイヤレベル（複数選択可）",
DriverArrival: "ドライバー到着済み",
DriverArrivedCancelConfirm: "ドライバーは乗車地点に到着しています。配車をキャンセルしますか？",
DriverArriving: "ドライバーが向かっています…",
DriverComingCancelConfirm: "ドライバーが向かっています。配車をキャンセルしますか？",
DriverPriorityContact: "先にドライバーへ連絡してください",
DropDownToViewHistory: "下に引いて履歴メッセージを表示",
DropOffCity: "降車都市",
Duration: "所要時間",
DutyParagraph: "会社税務番号",
DwellTime: "滞在時間",
Dysfunction: "機能異常",
EarlyThisMorning: "本日未明",
EarlytoLate: "出発時刻：早い順",
EconomicHotel: "エコノミーホテル",
EconomicHotel_1: "エコノミー",
EconomyClass: "エコノミークラス",
Edit: "編集",
EditContact: "連絡先を編集",
EditContactFailed: "連絡先の編集に失敗しました",
EditCostCenter: "コストセンターを編集",
EditDepartment: "部門を編集",
EditFrequentContact: "よく使う連絡先を編集",
EditInvoiceHeader: "請求書宛名を編集",
EditRC: "RCを編集",
Effective: "有効",
EffectiveDate: "証明書の有効期限",
ElectronicInvoice: "電子請求書",
Email: "メール",
EmailAddress: "メールアドレス",
EmailAddress_1: "メール",
EmailApproval: "メール承認",
EmailCannotBeEmpty: "メールアドレスを入力してください",
EmailChineseOrEnglishForFlight: "・中国語／英語の確認メール（中国語／英語の航空券確認書PDF添付）",
EmailChineseOrEnglishForTrain: "・中国語／英語の確認メール（中国語／英語の鉄道チケット確認書PDF添付）",
EmailFormatIsIncorrect: "メールアドレスの形式が正しくありません",
EmergencyContact: "緊急連絡先",
EmergencyContactMobile: "緊急連絡先電話番号",
EmergencyContactName: "緊急連絡先氏名",
EmergencyContactNumber: "緊急連絡先電話番号",
EmergencyHelp: "緊急サポート",
Emission: "排出量（kg）",
EmployeeDetails: "スタッフ詳細",
EmployeeInformation: "スタッフ情報",
EmployeeManagement: "スタッフ管理",
EmployeeNumber: "スタッフ数",
EmployeesCanApply: "スタッフはリンクからチームへの参加申請ができます。",
EmployeesCcanScan: "スタッフはQRコードをスキャンしてチームに参加できます。",
EmptyFileCannotBeUploaded: "空のファイルはアップロードできません。別のファイルを選択してください。",
EnableFingerprintLogin: "指紋認証ログインを有効にする",
End: "終了",
EndDate: "終了日",
EndorseTrain: "列車変更",
EnglishName: "英語名",
EnquiryOrderNumber: "リクエストID",
EnterANewPassword: "新しいパスワード",
EnterflightNoMU5166: "便名（例：MU5166）",
EnteringKefu: "オペレーターに接続中",
EnterMembershipNumber: "会員カード番号",
EnterNewMobile: "新しい電話番号",
EnterPhoneNumber: "電話番号を入力してください",
Enterprise: "企業",
EnterpriseCertification: "企業認証",
EnterpriseCodeBind: "企業コード連携",
EnterpriseCodeDescription: "企業コードとは、Alipayをベースとした企業向けの公用決済機能です。",
EnterpriseCodePay: "企業コード決済",
EnterpriseCooperation: "法人提携",
EnterprisePaymentCompleteTicket: "企業支払いでチケット購入完了",
EnterTheLastFourDigitsOfYourID: "本人確認書類番号の下4桁",
EnterVerificationCode: "認証コード",
EnterVerificationCode_1: "認証コード",
EnterVerificationCodeForThe12306: "12306認証コード",
EnterYourNewPasswordAgain: "新しいパスワードを再入力",
EntryTimes: "入国回数",
EssentialDocuments: "必要書類",
Estimate: "予測",
EstimateMeteredBilling: "概算（メーター料金、実際の料金が適用されます）",
ETA: "到着予定",
Etc: "など",
EUR: "ユーロ",
EvaluateKefu: "今回のサービスを評価してください",
ExactlyLate: "定刻 / 遅延",
ExceedingOrderAmount: "割引上限超過",
Exchange: "交換",
Exchange_1: "今すぐ交換",
ExchangeSerialNumber: "交換番号",
ExchangeSuccessful: "交換完了",
ExcludingFullPriceAverageDiscount: "普通運賃の平均割引を除く",
ExclusiveBrandPrivileges: "ブランド限定特典",
ExecuteAction: "アクション",
ExistingBusinessTravelAccount: "既存のHomsom法人契約企業",
ExistingStaff: "既存スタッフ",
Exit: "非常口",
ExitWarning: "ログアウトすると、このアカウントとWeChatの連携が解除され、このアカウントのWeChat通知を受け取れなくなります。ログアウトしますか？",
ExpandMore: "もっと見る",
ExpectedTravelDate: "出張予定日",
ExpectToAt: "予定",
Expired: "期限切れ",
ExportFormat: "エクスポート形式",
ExportOrder: "注文明細をダウンロード",
Express: "宅配便",
ExpressDelivery: "宅配便配送",
Ext: "内線",
ExtendedInformation: "追加情報",
Face: "顔認証",
FaceGetCameraFailTips: "現在のページではカメラを開けません。カメラ権限が有効になっているかご確認ください。解決しない場合は、リンクをコピーして別のブラウザでお試しください。すでにカメラを許可している場合は、「続行」をタップしてください。",
FaceIDIsNotEnabled: "この端末ではFace IDが有効になっていません",
FaceIDIsOnlyValidForTheMachine: "Face IDはこの端末でのみ有効です",
FaceIDLogin: "Face IDログイン",
FacilitiesDetails: "設備／詳細",
FacilityServices: "設備・サービス",
FailedToAccessTheCamera: "カメラへのアクセスに失敗しました",
FailedToChangePassword: "パスワードの変更に失敗しました",
FailedToGetPleaseTryAgainLater: "取得に失敗しました。後ほど再度お試しください。",
FailedToResetPassword: "パスワードのリセットに失敗しました",
FalseAlarmAccountability: "虚偽通報は法に基づき責任を問われます",
FalseAlarmAccountabilityDesc_1: "ワンタップ緊急通報はプラットフォームのカスタマーサービスにつながります。人身または財産の安全に関わる緊急時は、直接110番にお電話ください。",
FalseAlarmAccountabilityDesc_2: "虚偽通報を行った場合、5日以上10日以下の拘留処分を受ける可能性があります。",
FalseReport: "虚偽通報を行った場合、法的責任を負う可能性があります。",
Favorites: "お気に入り",
FeaturedIntroduction: "特徴紹介",
Feedback: "フィードバック",
Feishu: "Feishu",
FeishuByAccount: "Feishuアカウント",
FeishuByUser: "Feishuスタッフ連携",
File: "ファイル",
FileDownloadFailed: "ファイルの取得に失敗しました",
FillInAccordingToTheActualNumber: "実際の人数に基づいて入力してください",
FillInAccurateAndCompleteUnitInformation: "より良いサービス提供のため、正確で完全な会社情報をご入力ください。",
FillingGuide: "入力ガイド",
FillInTheReason: "理由を入力",
FillInYourBoundEmailAddress: "連携済みメールアドレスを入力してください",
FillTaxNumberIfAvailable: "納税者番号がある場合は必ず入力してください。",
Filter: "絞り込み条件",
Filter_1: "詳細フィルター",
Filters: "フィルター",
FindANewQueryQuote: "新しい見積もりを取得",
FingerprintDoItAgain: "認証に失敗しました。再度お試しください。",
FingerprintTouch: "指紋センサーに軽く触れてください",
FingerprintVerification: "指紋認証",
FingerprintVerificationTooManyTimes: "指紋認証の試行回数が多すぎます。しばらくしてから再度お試しください。",
Finish: "完了",
Finished: "完了",
FirstBusinessClass: "ファースト／ビジネスクラス",
FirstClass: "ファーストクラス",
FirstClassSeat: "一等座席",
FirstNameFormatIsIncorrect: "英字名の形式が正しくありません",
FirstStep: "ステップ1",
FixedPrice: "固定価格",
Fld: "代金豆",
FldDetails: "代金豆の詳細",
FldRules: "代金豆ルール",
FldUsageRules: "代金豆利用ルール",
Flight: "航空券",
FlightBookPermission: "航空券予約権限",
FlightCancellationDelayForMoreThan: "30分以上の欠航・遅延は航空会社の審査結果に準じます。",
FlightConfirmationWarn: "ビザ申請や出入国審査のため、確認書を印刷して旅行中に携帯できます。",
FlightDate: "搭乗日",
FlightDeparturesAreLocalTime: "出発・到着時刻はすべて現地時間です。",
FlightDetails: "フライト詳細",
FlightDynamicsAreForReferenceOnly: "フライト状況は参考情報です。航空会社の発表を基準としてください。",
FlightInformation: "フライト状況",
FlightInformationDesc: "フライト変更などの行程リマインダー",
FlightInfoSync: "時間通りに送迎できるよう、フライト状況がドライバーに共有されます。",
FlightNo: "便名",
FlightNumber: "便名で検索",
FlightNumberHotelTrainNumber: "便名／ホテル／列車番号",
FlightPreference: "フライト希望条件",
FlightPricesChangeFrequently: "航空券価格は頻繁に変動します。ご出発に支障がないよう、お早めにお支払いください。",
FlightRank: "航空券基準",
FlightRefundOrderConfirm: "航空券払い戻し注文確認",
FlightRefundTips: "ご注意：チェックイン済みのお客様は、変更・払い戻しの前にチェックインをキャンセルする必要があります。払い戻しを申請すると座席は直ちにキャンセルされます。内容をよくご確認ください。",
FlightRefundTrip: "払い戻し行程",
FlightRescheduleOrderConfirm: "航空券変更申請確認",
FlightReschedulingOrRefundTips: "ご注意：チェックイン済みのお客様は、変更・払い戻しの前にチェックインをキャンセルする必要があります。",
FlightSeatInfoArrow: "座席指定情報 >",
FlightsRefunds: "国内航空券払い戻し",
FlightTicket: "航空券",
FlightTicketInquiry: "航空券見積もり",
FlightTicketIssuedGetReceiptByEmail: "航空券が発券されました。精算用証憑はメールで取得できます。",
FlightTicketLatitude: "航空券単位",
FlightType: "フライト種別",
FloatingOptionalDate: "選択可能な変動日",
Floor_1: "階",
FollowFromEmployee: "スタッフをフォロー",
FollowTheSystem: "システムに従う",
Foods: "食事",
FoodTotalPrice: "商品合計金額",
ForDomesticTicketsPleaseReturnToTheHomePageAndSelectDomesticTickets: "国内航空券を検索するには、ホームに戻って「国内航空券」を選択してください。",
ForgetPassword: "パスワードをお忘れの方",
ForgetPassword_1: "パスワードをお忘れですか？",
FormatIsIncorrect: "形式が正しくありません",
Founder: "作成者",
Free: "速達配送｜送料無料",
FreeBoardband: "無料インターネット",
FreeParking: "無料駐車場",
FreePickUpService: "無料空港送迎サービス",
FreeWiFi: "無料Wi-Fi",
FrequentContacts: "よく使う連絡先",
FrequentContactsManagement: "連絡先管理",
FrequentTraveler: "常用搭乗者",
FrequentTravelerCardInformation: "マイレージカード",
FrequentTravelerManagement: "常用搭乗者管理",
FriendsareWaiting: "恒順商旅でお友達があなたを待っています。専用リンクからぜひご参加ください。",
Fuel: "燃油料金",
FuelFee: "燃油サーチャージ",
FullPrice: "普通運賃",
FullyBooked: "満席",
FullyCallingTheVehicle: "車両手配",
FunctionIntro: "機能概要",
GBP: "英ポンド",
Gender: "性別",
GeneralAmenities: "アメニティ",
GeneralCarUsage: "タクシー概要",
GeneralConditionsOfTransportation: "運送約款",
GeneralTrainTicket: "鉄道チケット概要",
Generated: "生成",
GenerateTravelReports: "レポート生成",
GenerationFailed: "生成に失敗しました",
GenerationSuccessful: "生成完了",
GetDidiJumpUrlFailed: "Didiのリダイレクトリンクを取得できませんでした",
GetInTheCar: "乗車",
GetSMS: "認証コード取得",
GettingBoardingLocation: "乗車地点を取得中",
GiveLXDAfterBookSuccess: "予約成功後にトラベルビーンズをプレゼント",
GivenNames: "名（ピンイン）",
GivenNamesEg: "例：MEIMEI",
GivenNamesHint: "例：「Wang Dawei」は「DAWEI」と入力してください",
GoAlipayCorpPay: "アリペイ企業支払いへ移動",
GoAndReturn: "往復",
GoApprovals: "承認申請へ",
GoBook: "予約へ",
GoEnquiry: "見積依頼へ",
GoFlight: "出発便",
Going: "往路",
GoingDate: "出発日",
GoingFilter: "出発フィルター",
GoingTo: "まもなく出発",
GoLogin: "ログイン",
GoToAlipayOpenEnterpriseCode: "Alipayで企業コードを開通する",
GoToBind: "連携へ",
GoToChange: "変更へ",
GoToDidiHome: "Didiホーム",
GoToDownload: "ダウンロードへ",
GoToHotel: "ホテルへ",
GoToPay: "支払いへ",
GoToQuery: "検索ページへ",
GoToRefund: "払い戻しへ",
GoToSettings: "設定へ",
GoToShare: "共有",
GoToVerify: "確認へ",
GoToView: "表示",
Greeting: "こんにちは、お会いできて嬉しいです！",
Guarantee: "保証",
Guarantee_1: "保証必要",
GuessYouWantToFindIt: "こちらもおすすめ",
Guests: "定員",
Gym: "ジム",
Handled: "完了",
HasProblem: "支払いに関する問題",
HasQuitHumanCustomerService: "ライブチャットサポートは終了しました",
HaveAgreement: "契約料金",
HaveQuestions: "お問い合わせは以下をクリックしてください。",
HaveRefund: "払い戻し",
HaveRescheduled: "変更あり",
HelpCenter: "ヘルプセンター",
HengshunTravelAPP: "Homsom Business Travel App",
HightoLow: "価格：高い順",
History: "履歴",
HistoryOrder: "過去の注文",
HistoryOrHot: "履歴／人気",
HistoryOrLocation: "現在／履歴",
HistoryRecord: "履歴（過去1年間）",
HKD: "香港ドル",
HoldToSpeak: "押して話してください",
HoldToTalk: "押して話してください",
Home: "ホーム",
HOMSOM: "Homsom",
Homsom: "My Homsom",
HomsomEnterpriseCooperation: "Homsom 法人提携",
HomsomEnterpriseCooperationDesc: "貴社がすでにHomsomと契約済みの場合は、アカウントマネージャーまでログイン情報をご確認ください。重複登録はご遠慮ください。",
HomsomFWXY: "利用規約",
HomsomGuarantee: "Homsom Guarantee",
HomsomLoginPrivacyInfo: "利用規約およびプライバシーポリシーに同意する",
HomsomLoginPrivacyTitle: "利用規約をご確認の上、同意してください。",
HomsomLoginPrivacyValue: "ログイン前に、利用規約およびプライバシーポリシーをご確認の上、同意してください。",
HomsomLxd: "Homsom Travel Beans",
HomsomPrivacyInfo: "利用規約およびプライバシーポリシー",
HOMSOMScanningCodeLoginConfirmation: "Homsom QRログイン確認",
HomsomServiceFee: "恒顺サービス手数料",
HomsomServiceFeeByChange: "Homsom 変更手数料",
HomsomServiceFeeByIssue: "Homsom 発券手数料",
HomsomSuccessDesc: "Homsom Business Travelがお客様に代わって予約を完了しました。",
HomsomTools: "ツール",
HomsomUpdateToExperience: "「Homsom Business Travel」が再びアップデートされました。ぜひ今すぐチェックしてみてください！",
HomsomYSZC: "プライバシーポリシー",
Hot: "人気",
Hot_1: "人気の特典",
HotChina: "中国で人気",
Hotel: "ホテル",
HotelAddress: "ホテル住所",
HotelBedNeeds: "ベッドタイプ希望",
HotelBookPermission: "ホテル予約権限",
HotelBookWarn: "ご注文前に「Homsomホテル予約規約」「個人情報利用同意書」「サプライヤー予約規約」をご確認ください。",
HotelBookWarn_1: "「Homsomホテル予約規約」「個人情報利用同意書」「サプライヤー予約規約」",
HotelChargeback: "ホテル返金",
HotelCheckInInfo: "チェックイン情報",
HotelConfirmEmailChineseOrEnglish: "・確認メール（中国語/英語、チェックインバウチャーPDF添付）",
HotelConfirmNumber: "予約確認番号",
HotelConfirmSMSChineseOrEnglish: "・確認SMS（中国語/英語）",
HotelConsumptionInEachCity: "都市別ホテル支出",
HotelContactMobile: "連絡先携帯",
HotelContactMobilePlaceholder: "通知受信用",
HotelDetails: "ホテル詳細",
HotelDimension: "ホテル軸",
HotelEnglishFirstNameHint: "名（例：San）",
HotelEnglishFirstNameRequired: "名（ピンインまたは英語）を入力してください",
HotelEnglishLastNameHint: "姓（例：Zhang）",
HotelEnglishLastNameRequired: "姓（ピンインまたは英語）を入力してください",
HotelFeature: "ホテルの魅力",
HotelGeneral: "ホテル概要",
HotelGroupMembership: "ホテルグループ",
HotelGroupMembershipCard: "グループ会員カード",
HotelGroupMembershipCard_1: "ホテルグループ会員カード",
HotelGroupMembershipCardBind: "会員連携",
HotelGroupMembershipCardDetails: "会員カード詳細",
HotelGroupMembershipCardInfo: "会員カード情報",
HotelGuestName: "宿泊者名",
HotelGuestNameInvalid: "宿泊者名の形式が不正です",
HotelGuestNamePlaceholder: "宿泊者名を入力してください",
HotelIntroduction: "ホテル概要",
HotelInvoiceExplain: "【注意】宿泊費の請求書はホテルが発行します。フロントでお受け取りください。",
HotelIsSendRefundEmail: "返金完了メールを送信",
HotelIsSendRefundSms: "返金完了SMSを送信",
HotelLatestRoomPrice: "最新のホテル料金を取得しました",
HotelMemberCardDesc: "会員限定特典",
HotelMoreGuests: "その他宿泊者",
HotelName: "ホテル名",
HotelNight: "総宿泊間夜数",
HotelOtherNeeds: "その他の要望",
HotelPayInStore: "現地払い",
HotelPriorityContact: "ホテル優先連絡先",
HotelPromptIsMorning: "本日チェックインは午前6時まで。",
HotelQuickConvertPinyin: "ピンイン一括変換",
HotelQuickSelectGuest: "宿泊者を選択",
HotelRank: "ホテル差旅基準",
HotelRating: "ホテルランク",
HotelRC: "Hotel RC",
HotelReasonCodeDistribution: "ホテルReasonCode分布",
HotelRefundGuestTitle: "返金対象宿泊者",
HotelRefundInformation: "返金情報",
HotelReservationAuthority: "国内ホテル差旅基準",
HotelRestaurant: "ホテルレストラン",
HotelRoomNumber: "部屋数",
HotelRoomRemarkInputTip: "その他のご要望をご入力ください。ホテルが可能な限り対応いたします。",
Hotels: "ホテル",
HotelSelectChargebackGuest: "返金対象宿泊者を選択",
HotelService: "ホテルサービス",
HotelServicePreferences: "サービス・好み",
HotelServicePreferences_1: "サービス設定",
HotelSpecialNeeds: "特別リクエスト",
HotelSpecialNeedsEditHint: "ご要望をご入力ください。ホテルが可能な限り対応いたします。",
HotelSpecialNeedsExplain: "ご要望はホテルへ共有されますが、対応を保証するものではありません。特別なご要望はホテルへ直接お問い合わせください。",
HotelTotalAmount: "ホテル総額",
HowSoonWillYouNeedTheCarAfterLanding: "到着後の利用時間",
HowToUseTip: "使い方がわからない場合",
HsTravelerExplainContext: "恒順商旅に登録された渡航者情報は、航空券や鉄道チケットなど実名認証が必要なサービスに利用されます。情報が正確かつ有効であることをご確認ください。恒順商旅は暗号化などにより情報を保護し、取引に必要な場合のみ関連第三者へ提供します。",
HsTravelerExplainTitle: "以下の内容を読み同意する",
IAm: "私は",
ID: "証明書番号",
IDCard: "身分証番号",
IDCardFormatIsIncorrect: "身分証番号の形式が正しくありません。",
IdNameMatchTip: "身分証明書の氏名と一致してください",
IDNoVerify: "証明書番号確認",
IDNumber: "証明書番号",
IDType: "証明書種類",
IfTheApproverIsInconsistent: "承認者が異なる場合は分けて予約してください。",
IfTheRemainingSeats: "ご希望の座席を確保できない場合、自動で座席を割り当てます。",
IfTheTicketHasBeenIssuedTheLossMustBeBorneByTheOwner: "2. 発券後の変更・払い戻し費用はお客様負担となります。",
IfYouCheckThisOption: "このオプションを選択すると、以降の行程は個人利用として扱われます。",
IfYouHaveAnyQuestions: "ご不明点は恒順商旅カスタマーサポート（4006-123-123）までご連絡ください。",
IfYouHaveAnyQuestionsPleaseContactYourBusinessConsultant: "ご不明点は担当営業までお問い合わせください。",
IfYouNeedToNarrowTheScopePleaseEnterMoreConditions: "絞り込むには条件を追加してください。",
IGotIt: "了解しました",
IHaveReadAndAgree: "内容を読み同意しました",
ImageAndFileCannotSelectTogether: "画像とファイルは同時に選択できません。",
Import: "インポート",
Import_1: "導入",
ImportBusiness: "インポート（出張）",
ImportFailed: "インポートに失敗しました",
ImportFromFrequentTraveler: "従業員からインポート",
ImportSuccess: "インポート成功",
IncludingHongKongMacauAndTaiwan: "香港・マカオ・台湾を含む",
Income: "収入",
IncomeExpenditure: "収支明細",
InconsistentPasswordEnteredTwice: "入力したパスワードが一致しません。",
IncorrectFormatOfContactMobileNumber: "連絡先電話番号の形式が正しくありません。",
Indexs: "アルファベット索引",
IndividualOrNonEnterprise: "個人／非法人",
InformationDescription: "説明",
InformationIsIncomplete: "情報が不足しています",
InformationVerification: "情報確認",
Infrastructure: "インフラ",
Initiated: "申請済み",
InitiativeEnthusiasmEfficientMeticulousSpecialty: "より積極的に、より丁寧に、より効率的に、より専門的に",
InnovativeService: "革新的なサービス",
InPersonRequired: "本人来場",
InputBookingPassword: "予約パスワードを入力してください",
InputBookingPwdTip: "企業口座よりお支払いが発生します。予約パスワードを入力してください",
InputConfirmPassword: "確認用パスワードを入力してください",
InputHint: "ご要望をお聞かせください、全力でサポートいたします～",
InputInformation: "情報入力",
InputQuestionHint: "質問を入力してください",
InquiryInformationIsInvalid: "照会情報の有効期限が切れました",
Install: "今すぐインストール",
Instructions: "ご案内",
InsufficientRemainingTicketsChooseOtherFlight: "空席不足のため、別のクラスを選択してください。",
InsuranceNotice: "保険加入に関するご案内",
Insurers: "保険",
Integral: "ポイント",
Integral_1: "商品ポイント",
IntegralByHomsom: "恒順商旅ポイント",
IntegralMall: "ポイント交換",
IntercityCarHailing: "都市間配車",
IntergralDescription: "ポイントについて",
IntergralRules: "ポイントルール",
InternalProcurement: "社内調達",
International: "海外",
InternationalHotel_1: "海外ホテル（香港・マカオ・台湾除く）",
InternationalHotelOrderConfirmation: "海外ホテル予約確認書",
InternationalHotelOrders: "海外ホテル予約",
InternationalRegion: "国際 / 香港・マカオ・台湾",
InternationalRegion_1: "国際線・香港・マカオ・台湾",
Internet: "インターネット",
InTheLocation: "位置情報取得中",
InTheTicket: "発券中",
Intl_1: "国際",
IntlDestination: "海外目的地",
IntlFlightEnquiry: "国際航空券リクエスト",
IntlFlightEnquiryService: "国際線航空券見積サービス",
IntlFlightEnquiryServiceDesc: "手動見積で簡単予約",
IntlFlightOrder: "国際線航空券予約",
IntlFlightRank: "国際航空券差旅基準",
IntlFlights: "国際線航空券",
IntlFlights_1: "国際線（香港・マカオ・台湾含む）",
IntlFlightsChange: "国際航空券変更",
IntlFlightsOrderConfirmation: "国際線予約確認書",
IntlFlightsRefund: "国際航空券払い戻し",
IntlHotel: "海外ホテル",
IntlHotelReservationAuthority: "海外ホテル差旅基準",
InTrainTransfer: "車内乗換",
InTravel: "移動中",
Invalid: "無効",
InvitationOtherType: "その他の招待方法",
InvitationStaff: "従業員を招待",
Invitee: "招待者",
InviteEmployeesToJoin: "以下の方法で従業員を招待できます。管理者承認後、SMS通知が送信されます。",
Invoice: "請求書",
InvoiceAmount: "発行金額",
InvoiceAmount_1: "請求書金額",
InvoiceCheckGuide: "こちらで確認するか、「未発行請求書」一覧で続けて発行してください。",
InvoiceContent: "請求書内容",
InvoiceDetais: "請求書詳細",
InvoiceFilling: "請求書入力",
InvoiceFinished: "発行済み",
InvoiceHeader: "請求書宛名",
InvoiceHeaderName: "宛名",
InvoiceHeaderType: "宛名タイプ",
InvoiceInformation: "請求情報",
InvoiceInst: "請求書説明",
InvoiceIssuingMustRead: "開票前必読",
InvoiceOperating: "発行中",
InvoiceParagraph: "請求書用納税者番号",
InvoicePreview: "請求書プレビュー",
InvoiceRemarks: "請求書備考",
InvoiceTitleCannotBeAllNumbers: "請求書宛名は数字のみでは設定できません",
InvoiceTitleCannotEdit: "保存済みの請求書宛名は編集できません。削除後に再追加してください。",
InvoiceTitleFillReminder: "請求書情報を正確にご入力ください。入力内容に誤りがある場合、発行・ダウンロード・精算ができないことがあります。",
InvoiceTitleManagement: "請求書宛名管理",
InvoiceType: "請求書タイプ",
InvoicingStatus: "開票ステータス",
InvoluntaryRefund: "非自発的払戻し",
InvoluntaryRefundDesc: "非自発的払戻し（欠航・30分以上の遅延時、航空会社審査基準に準ずる）",
InvoluntaryRefundExplain: "非自発的払戻し説明",
InvoluntaryReschedule: "非自発的変更",
InvoluntaryRescheduleDesc: "非自発的変更（欠航・30分以上の遅延時、航空会社審査基準に準ずる）",
InvoluntaryRescheduleExplain: "非自発的変更説明",
IsLoggedIn: "ログイン済み",
IsSendReceiveEmail: "受注メール",
IsSendReceiveSms: "受注SMS",
IssuedAmount: "発行済み金額",
IssueElectronicInvoice: "電子請求書を発行",
IssueInvoice: "請求書発行",
Issuing: "発行中",
JobDescription: "差旅基準説明",
JoinedEnterpriseGetResult: "企業に加入済み。認可結果を取得しています",
JPY: "日本円",
JuHeYongCheNotIncludeDiDiTravel: "配車サービス統合にはDiDiは含まれません",
JumpToDidi: "DiDiで確認",
JustLookAtTheHighSpeedTrain: "高速鉄道・新幹線のみ",
JustTime: "たった今",
KeyBusinessTripInfo: "会社規定により追加情報の入力が必要です",
KeyMoreCarTypes: "その他の車種",
KeyMoreSelectionFaster: "多く選択すると配車が速くなります",
KeySwipeUpMoreCars: "上にスワイプしてさらに表示",
KeyTaxiMeterPricing: "タクシー料金はメーター制です。実際の料金が適用されます",
Keywords: "キーワード",
KeywordSearch: "キーワード検索（ホテル名）",
KeywordSearch_1: "エリア／ブランド／ホテル名",
KPIAnalysis: "航空券KPI分析",
KRW: "韓国ウォン",
LackOfIntegral: "ポイント不足",
Landing: "到着",
Language: "地域と言語",
LanguageBeingSet: "言語を設定中...",
LanguageCH: "中国語",
LanguageDefault: "デフォルト言語",
LanguageEN: "英語",
LanguageSetting: "言語設定",
LastNameFormatIsIncorrect: "姓の形式が正しくありません",
LatestArrivalDate: "最終到着日",
LateToEarly: "出発時間：夜～朝",
Latitude: "多次元分析",
LearnAbout: "ご案内",
LearnMore: "詳細を見る",
LessThan10People: "10名以下",
LetYourFriendsAlsoDownloadHengshunTravelAPP: "お友達にもHomsomアプリをおすすめしましょう",
Light: "ライトモード",
LinkYourCellphone: "携帯番号を連携",
List: "リスト",
Loading: "読み込み中...",
Loading_1: "更新中...",
LoadMoreTransit: "乗換列車をもっと見る",
LocacleHotHotelRecommend: "人気の現地ホテル",
LocalTax: "現地税",
LocalTime: "現地時間",
LocalTimeOfTheDepartureCity: "出発地の現地時間",
Location: "現在地",
Location_1: "位置情報",
Location_2: "距離",
LocationFailed: "現在地を取得できませんでした",
LocationNotTurnOn: "位置情報が無効です",
LocationOfTheUnit: "会社所在地",
LocationPermissionClosed: "位置情報の権限がオフです。設定から有効にしてください。",
LocationPermissionNotEnabled: "位置情報の権限が無効です",
LocationPermissionRequest: "位置情報の許可申請",
LocationPermissionRetryMessage: "位置情報権限が必要です。再度有効にしますか？",
LocationPermissionSettingsMessage: "位置情報権限が無効です。システム設定より有効にしてください。",
LocationPermissionUsageMessage: "現在位置を取得し、位置関連サービスを提供するために利用します。",
LocationPermissionUsageTitle: "位置情報権限の利用目的",
Login: "ログイン",
Login12306: "12306にログイン",
Login12306Account: "12306アカウントにログイン",
Login12306AccountDesc_1: "乗車券購入には実名認証が必要です",
Login12306AccountDesc_2: "12306アカウントで予約・変更・払い戻しを行ってください",
Login12306AccountEnjoyExtremeReversionMemberPoints: "ログインして柔軟な変更・払い戻し・会員ポイントを利用",
Login12306FaceToBeCompleted: "顔認証が必要です",
Login_1: "ログイン",
LoginByAccountPassword: "パスワードログイン",
LoginByVerificationCode: "認証コードログイン",
LoginByVerificationCodeEmail: "メール認証コードログイン",
LoginByVerificationCodeSMS: "SMS認証コードログイン",
LoginConfirm: "ログイン確認",
LoginExpired: "ログインの有効期限が切れました。再度ログインしてください。",
LoginName: "ログインアカウント",
LoginOut: "ログアウト",
LoginSuccessful: "ログインしました",
LoginSuccessful12306: "12306にログインしました",
LoginTo12306ToImproveTheSuccessRateOfTicketIssuance: "12306にログインして発券成功率を向上",
LogisticsCompany: "物流会社",
Logout: "ログアウト",
LongPressSaveTheQRcode: "長押ししてQRコードを保存",
LookAtThePriceExcludingTax: "価格（税別）",
LookCertificate: "証明書を表示",
LookChargebackOrder: "払戻を確認",
LooOriginOrder: "元の注文を表示",
Loss: "損失",
LossAnalysis: "損失分析",
LossPercentage: "損失率",
LowCarbonHomsomPlantingHomsomForestTogether: "低炭素恒順、共に恒順の森を育てよう",
LowestPrice: "最安値",
LowestPrice_1: "最安値",
LowestPriceDetails: "最安値の詳細",
LowestTicketPrice: "最安航空券",
LowPriceFlightRecommendation: "おすすめの格安航空券",
LowtoHigh: "価格：安い順",
LowVersionTip: "アプリのバージョンが古いため、最新版にアップデートしてください",
LuggageStorage: "手荷物預かり",
LuxuryHotel: "ラグジュアリーホテル",
LuxuryHotel_1: "ラグジュアリー",
Lxd: "旅行豆",
LxdDetails: "旅行豆詳細",
LxdReward: "旅行豆特典",
LxdRewardCompleteTheOrderToObtain: "注文完了後に獲得",
LxdRules: "旅行豆ルール",
LxdUsageRules: "旅行豆利用ルール",
MailSent: "メール送信済み",
MainFlight: "メインフライト",
MainRoomer: "代表宿泊者",
MainRoomerRequired: "代表宿泊者（必須）",
MakeInvoice: "請求書発行",
MakeSureToClearCache: "キャッシュを削除しますか？",
MakeSureToFingerprintLoginClose: "指紋認証ログインを無効化しますか？",
MakeSureToLeaveYourCurrentAccount: "現在のアカウントからログアウトしますか？",
Manage: "管理",
Manager: "担当者",
ManualApproval: "手動承認",
ManualChange: "手動変更",
ManuallyImport: "手動インポート",
ManuallyPassed: "手動承認済み",
ManualModification: "手動編集",
ManualRefund: "手動払戻",
Map: "地図",
MapNavigation: "地図ナビゲーション",
MapPointSelection: "地図で選択",
MapSelection: "地図選択",
MapSurroundings: "地図/周辺",
MarkAllMessagesAsRead: "すべてのメッセージを読み済みとしてマークしますか？",
MatchingTheBestDriverForYou: "最適なドライバーをご提案",
MaximumFaceValue: "最大額面",
MayBeAt: "対応可能場所：",
Meals: "食事",
MealsGoods: "食事",
MealsOrder: "食事の注文",
MealsOrderConfirm: "食事注文の確認",
MealsRank: "食事基準",
MealsRemarks: "食事メモ",
MeetingRoom: "会議室",
MembershipCardNumber: "会員番号",
MembershipNumber: "会員番号：",
MergeIssueReimbursableAmount: "合算発行可能精算額",
Message: "メッセージ",
MessageCenter: "メッセージセンター",
MessageFailedToSend: "メッセージの送信に失敗しました。再度お試しください。",
MessageSendSuccessfully: "メッセージ送信成功",
MethodOne: "方法1",
MethodThree: "方法3",
MethodTwo: "方法2",
MicrophoneIsRequiredForCurrentService: "このサービスを利用するにはマイクへのアクセスが必要です。設定で有効にしてください。",
Mileage: "マイレージ",
MiniProgramDoesNotSupportDiDiPleaseUseHomsomApp: "ミニプログラムではDiDiの配車サービスをご利用いただけません。DiDiをご利用になる場合は、Homsomアプリをダウンロードしてご利用ください。",
Minute: "分",
MissedSavingAnalysis: "最安値未予約による損失",
MixedPayment: "超標自己負担",
MixedPaymentDesc: "高級ホテルの超過分は自己負担となります。",
MixedPaymentOpen: "貴社は超標自己負担をご利用いただけます",
MixedPaymentOpenDesc: "差額支払いによる客室アップグレード",
MixedPaymentSelfPayment: "超過分は自己負担",
MnlyOneMembershipCardCanBeAddedToTheSameHotel: "同じホテルには会員カードを1枚のみ追加できます。",
MobileCode: "国番号",
MobileInvitationCode: "モバイル招待コード",
MobileInvitationCodeShare: "QRコード画像を社内グループチャットで共有すると、同僚がスキャンして申請できます。",
MobileLinked: "電話番号連携済み",
MobilePhoneNumberVerification: "携帯番号認証",
MobileUnlinked: "電話番号未連携",
ModifiedSuccess: "変更完了",
ModifiedSuccessfully: "更新に成功しました。新しい電話番号：",
Modify: "変更",
ModifyTheBoundPhone: "登録済み電話番号を変更",
Moments: "タイムライン",
MonthApr: "4月",
MonthAug: "8月",
MonthDeb: "2月",
MonthDec: "12月",
MonthJan: "1月",
MonthJul: "7月",
MonthJun: "6月",
Monthly: "月次",
MonthlyExpense: "月間支出",
MonthlyKPI: "月次KPI",
MonthlySummary: "月次サマリー",
MonthMar: "3月",
MonthMay: "5月",
MonthNov: "11月",
MonthOct: "10月",
MonthOnMonth: "前月比",
MonthSep: "9月",
More_1: "もっと見る",
More_2: "もっと見る",
More_3: "もっと見る",
MoreCabinsNoResult: "これ以上空席はありません",
MoreConsultation: "さらに詳しく",
MoreDate: "その他の日付",
MoreDateB: "その他の日付",
MoreDiner: "他の利用者",
MoreFilterCriteria: "その他の条件",
MorePassengerFlight: "他の搭乗者",
MorePassengerRoomer: "他の宿泊者",
MorePassengerVehicle: "他の乗車者",
MorePrice: "その他の価格",
MoreSorting: "その他の並び順",
MoreThan100People: "100名以上",
MoreThanThePurchaseLimitCanNotBuy: "購入上限を超えています",
MoreTraveler: "他の旅行者",
Morning: "早朝",
MorningCall: "モーニングコール",
MultipleAccountsHaveBeenBound: "この電話番号は複数のアカウントに連携されています。別のログイン方法をお試しください。",
MultipleChoice: "複数選択",
MultipleChoiceSuccessRate: "複数選択で成功率アップ",
MultiTierReschedulingNotSupported: "複数行程の変更には対応していません",
MustBeAccompaniedByAnAdultOnBoard: "お子様・幼児は大人の同伴が必要です",
MyAdvancePayment: "前払金",
MyApplyTravel: "出張申請",
MyApprovals: "承認待ち",
MyBalance: "残高",
MyCollection: "お気に入り",
MyCustomerService: "カスタマーサポート",
MyFld: "マイ代金豆",
MyInitiations: "申請一覧",
MyIntergral: "マイポイント",
MyLxd: "マイ旅行豆",
MyTrip: "マイトリップ",
Name: "氏名",
NameFillingInstructions: "氏名入力ガイド",
Nation: "国・地域",
NationalityOfThePerson: "宿泊者の国・地域",
NationalServicePhone: "全国サービスホットライン",
NavigateToHotel: "ホテルまでナビ",
Near: "周辺",
NearExpiration: "まもなく期限切れ",
NearlyOneMonthApply: "過去1か月の申請",
NearlyOneMonthOrder: "過去1か月の注文",
NearlyOneYear: "過去1年",
NearlyOneYearOrder: "過去1年の注文",
NetList: "オンライン予約",
NetTransactionPrice: "正味価格",
Network: "ネットワーク",
NetworkRequestConnectionFailed: "ネットワーク接続に失敗しました",
NetworkRequestFailed: "通信に失敗しました",
New: "追加",
New_1: "追加",
NewCertificate: "身分証明書を追加",
NewContactSuccessFailed: "連絡先の追加に失敗しました",
NewContactSuccessFul: "連絡先を追加しました",
NewDepartment: "部門を追加",
NewDialogAlready: "既に新しい対話が開始されています。",
NewDiner: "利用客を追加",
NewFlightDate: "変更後のフライト日",
NewFrequentTravelCard: "マイレージカードを追加",
NewFrequentTravelCard_1: "マイレージカードを追加",
NewHotelGroupMembershipCard: "ホテル会員カードを追加",
NewMobile: "新しい携帯電話番号",
NewPassenger: "乗客を追加",
NewPassengerFlight: "搭乗者を追加",
NewPassengerVehicle: "乗車人を追加",
NewRC: "RCを追加",
NewRoomer: "宿泊者を追加",
NewTraveler: "旅行者を追加",
NewVersion: "新版を使用",
NewVersionFound: "新バージョンが見つかりました",
NextStep: "次へ",
NextStep_1: "次へ",
NickName: "ニックネーム",
NoApply: "申請データがありません",
NoApprovalRequired: "承認不要",
NoAvailableApply: "該当する申請が見つかりませんでした",
NoAvailableCabin: "空席なし",
NoAvailableFlight: "該当するフライトがありません",
NoAvailableFlightDesc: "条件に一致するフライトがありません。検索条件を変更してください。",
NoAvailableHotel: "該当するホテルがありません",
NoAvailableHotelTip: "条件に一致するホテルがありません。検索条件を変更してください。",
NoAvailableOrder: "該当する注文が見つかりませんでした",
NoAvailableTrain: "該当する列車がありません",
NoAvailableTrainTip: "条件に一致する列車がありません。検索条件を変更してください。",
NoAvailableVouchersForUse: "利用可能なクーポンはありません",
NoBindPhoneTip: "携帯電話番号が未連携です。設定画面にて電話番号を連携してください",
NoBreakfast: "食事なし",
NoChangeablePassengers: "変更可能な乗客がいません",
NoChildUnderDepartmentsAtPresent: "現在、下位部門はありません",
NoCollection: "お気に入りはまだありません",
NoData: "結果がありません",
NoData_1: "データがありません",
NoDataBySearch: "検索結果が見つかりませんでした",
NoDataContent: "コンテンツがありません",
NoDataTravelStandard: "出張規定情報がありません",
NoEnterpriseCodePayOrder: "企業コード決済番号を取得できませんでした",
NoIncludedChangeFeeTag: "（変更手数料は含まれません）",
NoItinerary: "予定された日程はありません",
NoMeal: "食事なし",
NoMore: "これ以上データはありません",
NoMoreCredential: "これ以上身分証明書はありません",
NonBookable: "予約不可",
NoNet: "ネットワーク未接続",
NoNewNotice: "新しい通知はありません",
NoNews: "メッセージはありません",
NonStaff: "社外人員",
NonStaffDetail: "社外人員詳細",
NonStaffManagement: "社外人員管理",
Noon: "正午",
NoOrder: "注文履歴はありません",
NoOrderEnquiry: "要請書はありません",
NoPermission: "権限がありません",
NoPermissions: "権限がありません",
NoPermissionToAccess: "アクセス権限がありません",
NoPlatformAvailablePleaseContactYourTravelConsultant: "利用可能なプラットフォームがありません。差旅担当者にお問い合わせください。",
NoRecordDevice: "録音デバイスがありません",
NoRemainingTickets: "満席・予約不可",
NoReschedulingReeIsIncluded: "変更手数料別",
NoReservationOrders: "予約履歴はありません",
NoResult: "検索結果がありません",
NormalSeat: "ビジネス席",
NoStay: "未チェックイン",
NotAuthorizedForNow: "今は許可しない",
NotBook: "予約不可",
NotBooking_1: "予約不可",
NotCertificateInfo: "身分証明書情報なし",
NotCompletedTheIdentityVerificationFor12306: "12306本人確認が未完了ですか？",
NotCompletedTheIdentityVerificationFor12306_1: "お使いの12306アカウントは認証が必要です。認証を実施してください。",
NotCompletedTheVerificationInOrder: "本人確認が必要な乗客がいます",
NotesOnRefundAndChangeOfVisa: "変更・払い戻しの注意事項",
Nothing: "なし",
Notice: "通知",
NoticeCanceled: "取消通知",
NoTicket: "チケットなし",
NotInitiated: "未申請",
NotNecessaryChoose: "任意",
NotNecessaryFill: "任意",
NotNecessaryFillPleaseFillOrChoose: "入力または選択してください",
NotNeedDepartPassenger: "出発する乗客はいません",
NoTravelCard: "マイレージカード情報なし",
NoTravelStandard: "出張規定なし",
NotRefundable: "払い戻し不可",
NoTrip: "出張予定はありません",
NotSelectable: "選択不可",
NotSendEmptyInfo: "空のメッセージは送信できません",
NotSet: "未設定",
NotSupportOnlineInvoice: "オンライン領収書発行は未対応です",
NotUsed: "未使用",
NoVisaProductsAvailable: "該当するビザ商品はありません",
Now: "現在",
Number: "人数",
Number_1: "数量",
NumberOfAdult: "大人人数",
NumberOfChild: "子供人数",
NumberOfCustomItems: "カスタム項目数",
NumberOfFullPriceTickets: "大人運賃チケット数",
NumberOfGuestsPerRoom: "1室あたりの大人人数",
NumberOfRoom: "部屋数",
NumberOfRooms: "客室数",
NumberOfRoomsAndOccupancy: "客室数・定員",
NumberOfRoomsAndPeople: "客室数 / 宿泊者数",
NumberOfRoomsBooked: "予約部屋数",
NumberOfSheets: "枚数",
NumberOfTrainTickets: "列車チケット枚数",
NumberOfWorkers: "従業員数",
NumberProtecting: "番号保護中",
NZD: "NZD",
OccupySeatOverCountRemindContent: "1日以内に発券成功した注文を3回キャンセルした場合（「座席なし」またはご希望の寝台条件に合わないためのキャンセルは5回で1回分としてカウント）、当日は12306でのチケット購入ができなくなります。",
OffAndBelow: "割引以下",
OfficialOrderNo: "公式サイト注文番号",
OfflineReservation: "オフライン予約",
OK: "了解しました",
OldAndNewPasswordsMustNotBeTheSame: "新しいパスワードは現在のパスワードと異なる必要があります。",
OldVersion: "旧バージョンを使用",
OneAirlineCanOnlyAddOneFrequentTravelCard: "同一の航空会社で登録できるマイレージカードは1枚のみです。",
OneClickFill: "ワンクリック記入",
OneKeyAlarm: "緊急通報",
OneKeyAlarmTripShare: "緊急通報を行うと、旅程情報が緊急連絡先へ自動的に共有されます。",
OneWay: "片道",
OnlineChangeNotSupported: "オンライン変更不可",
OnlineCheckIn: "オンラインチェックイン",
OnlineCheckInUnavailable: "オンラインチェックインには対応しておりません。スムーズに手続きを行うため、航旅横断Appのダウンロードを推奨します。",
OnlineCheckInViaUmetrip: "現在、オンラインチェックインには対応しておりません。「航旅纵横（Umetrip）」アプリでチェックイン手続きを行ってください。",
OnlineFlight: "チェックイン",
OnlineFlight_1: "チェックイン",
OnlineFlightWarn: "オンラインチェックインは航空会社より提供されます。手続きに関する問題は直接航空会社へお問い合わせください。",
OnlinePayment: "オンライン決済",
OnlinePayment_1: "オンライン決済",
OnlineReport: "オンラインレポート",
OnlineSeatSelection: "オンライン座席指定",
OnlineService: "オンラインサポート",
OnlyAdultTicketBookingsAreSupported: "大人用チケットのみ予約可能",
OnlyDirectFly: "直行便のみ",
OnlyMe: "自分のみ",
OnlySeeSelected: "選択済みのみ",
OnlySupportsQueriesForDateRangesWithinOneYear: "1年以内の日付範囲のみ検索可能です。",
Open: "開通",
Open_1: "有効にする",
Open_2: "開く",
OpenEnterpriseCode: "企業コードを開通する",
OpenEnterpriseCodeStepTip: "以下の手順で企業コードを開通してください（所要時間：約1分）",
OpenHengshunTraveMobilelEditionForBetterExperience: "Homsomモバイル版を開くと、より快適にご利用いただけます",
OpenSafari: "Safariで開く",
OpenSuccess: "有効化が完了しました",
OpenYears: "開業年",
OperatedBy: "運航会社",
Operating: "処理中",
Operation: "操作",
Operator: "処理者",
Optional: "任意",
OptionalCities: "選択可能都市",
OptionalDocuments: "任意の提出書類",
OptionalInParentheses: "（任意）",
OptionalInput: "任意",
OptionalInput_1: "(任意)",
OptionalReturnDate: "復路日を選択",
OrCopyLinkToBrowserPay: "または、リンクをSafariまたはデフォルトブラウザにコピーして開いて支払いを完了してください",
Order: "予約",
Order_1: "予約",
Order_2: "予約に関する問題",
OrderCancelFailed: "キャンセル失敗",
OrderCancelled: "キャンセル済み",
OrderCompleted: "完了",
OrderDate: "予約日",
OrderDateBookTime: "予約日時",
OrderDetails: "予約詳細",
OrderFilling: "予約情報入力",
OrderInformation: "予約情報",
OrderInformationForChange: "変更の予約詳細",
OrderInformationForRefund: "払戻の予約詳細",
OrderInformationRefund: "払戻の予約情報",
OrderIntergral: "獲得ポイント",
OrderNo: "予約番号",
OrderNo_1: "バウチャーコード",
OrderNoCannotBeEmpty: "予約番号を入力してください",
OrderNotice: "通知設定",
OrderNoticeDesc: "発券状況や予約ステータスの通知を受け取る",
OrderNumber: "予約番号",
OrderNumber_1: "番号",
OrderPaid: "支払い済み",
OrderStatus: "ステータス",
OrderStatusHasChangedPleaseReOperate: "予約ステータスが変更されました。もう一度操作してください。",
OrderSubmissionSuccessFailed: "送信失敗",
OrderSubmissionSuccessful: "送信完了",
OrderSynTime: "同期時間",
OrderTime: "予約日時",
OrderType: "予約種別",
OrganizationalStructure: "組織構造",
OriginalPrice: "通常価格",
OriginalSchedule: "元の行程",
OriginFlightOrderNo: "元のフライト予約番号",
OriginFlights: "元のフライト",
OriginOrderNumber: "元の予約番号",
OriginTrip: "元の行程",
OriginTripOrderNo: "元の列車予約番号",
OrTryOurAppForMoreAccurateAndFasterFaceRecognition: "またはアプリをご利用ください。顔認証がより早く正確に行えます。",
Other: "その他",
OtherConsult: "その他のお問い合わせ",
OtherInfo: "その他の情報",
OtherLoginMethods: "他のログイン方法",
OtherPolicy: "その他の規定",
OtherReasons: "その他の理由",
OtherWaysOpenInBrowser: "その他の方法：スマホブラウザで支払いリンクを開く",
OurAgreedAveragePrice: "自社契約平均単価",
OurCompany: "当社",
OurExclusiveConsultantWillContactYouAsSoonAsPossible: "専任コンサルタントよりまもなくご連絡いたします。",
OverseasMultiCity: "複数都市",
OverseasServicePhone: "海外サービスホットライン",
Overview: "概要",
OverviewOfTickets: "フライト概要",
PackUp: "折りたたむ",
PaidBoardband: "有料ブロードバンド",
PaidParking: "有料駐車場",
PaidPickUpService: "有料空港送迎",
PaidWiFi: "有料Wi-Fi",
PartialChange: "一部改期",
PartialRefund: "一部払い戻し",
Pass: "承認",
Passenger: "乗客",
PassengerDetails: "乗客詳細",
PassengerFlight: "搭乗者",
PassengerFlightDetails: "搭乗者詳細",
PassengerFlightName: "搭乗者名",
PassengerInformation: "乗客情報",
PassengerList12306: "12306乗客名簿",
PassengerName: "乗客名",
PassengersWhoNeedToRefund: "退票対象の搭乗者",
PassengersWhoNeedToReschedule: "改期対象の搭乗者",
PassengersWithoutRefundableTickets: "退票不可の乗客",
PassengerType: "乗客タイプ",
PassengerVehicle: "乗客",
PassengerVehicleDetails: "乗客詳細",
PassengerVehicleForChange: "改签対象の乗客",
PassengerVehicleForRefund: "退票対象の乗客",
PassengerVehicleInfo: "乗客情報",
PassengerVehicleName: "乗客氏名",
PassengerVehicleWhoNeedToRefund: "退票対象の乗客",
PassengerVehicleWhoNeedToReschedule: "改签対象の乗客",
Password: "パスワード",
Password12306: "12306のパスワードはHomsomアカウントのパスワードとは異なります。",
PasswordCanBeResetViaEmail: "連携済みのメールアドレスからパスワードを再設定できます",
PasswordCanBeResetViaPhone: "連携済みの携帯電話番号＋SMS認証コードでパスワードを再設定できます",
PasswordMustBeNoLessThanEightDigitsInLength: "パスワードは8文字以上で入力してください",
PasswordMustBeNoLessThanSixDigitsInLength: "パスワードは6文字以上で入力してください",
PasswordRuleDescription: "パスワードは英大文字・小文字、数字を含む8文字以上を推奨します",
PasswordsMustContainLettersAndNumbers: "パスワードには英字と数字の両方を含める必要があります",
PasswordUpdateSuccessful: "パスワードを変更しました",
Pay: "支払う",
PayAgain: "再支払い",
PayAtTheStore: "現地決済",
PayAtTheStoreAbout: "現地決済 約",
PayBackTips: "支払いが完了していません。戻ると支払いが破棄されます。注文履歴から支払いを再開できます。",
PayInformation: "お支払い情報",
PayInformationDetails: "お支払い詳細",
Paying: "お支払い処理中...",
PayingEnterpriseLabel: "支払代行企業",
PayingOrQrExpired: "お支払い中、またはQRコードの有効期限切れ",
PaymentCompleted: "支払い完了",
PaymentFailed: "決済に失敗しました",
PaymentOnBehalfShareDesc: "他の人に支払いを依頼する",
PaymentPermission: "決済権限",
PaymentSerialNumber: "決済取引番号",
PaymentSuccessful: "お支払いが完了しました",
PaymentSuccessfulContinueToPayTheNextOrder: "お支払いが完了しました。続けて次の注文を支払います。",
PaymentTime: "支払い日時",
PaymentWay: "お支払い方法",
PayNow: "今すぐ支払う",
PayOrder: "注文を支払う",
PayResultTimeout: "決済結果の確認がタイムアウトしました。後ほど注文履歴よりご確認ください。",
PayType: "支払い種別",
PayTypeCompanyDesc: "法人アカウントから支払い",
PayTypeMixedDesc: "規定を超える費用は個人負担となります",
PayTypePersonalDesc: "個人による支払いが必要",
PdfDownload: "PDFをダウンロード",
PdfPreview: "PDFプレビュー",
PendForOperating: "保留中",
Pending: "承認待ち",
Pending_1: "申請提出済み（承認待ち）",
Pending_2: "予約完了（承認待ち）",
Pending_3: "申請提出済み",
Pending_4: "審査待ち",
People10: "10～20名",
People20: "20～40名",
People40: "40～100名",
PeoplePerRoom: "1部屋あたりの宿泊人数",
PercentageOfPotentialSavings: "潜在的な節約割合",
PercentageOfRoomNights: "宿泊日数割合",
PercentageOfSavings: "節約割合",
PercentageOfSheets: "発券枚数割合",
PermanentResidence: "長期居住地",
PermissionDisabledTitle: "権限が有効になっていません",
PermissionRetryTitle: "権限申請",
PermissionsRange: "権限範囲",
Person: "個人",
PersonAccount: "個人アカウント",
Personal: "個人",
PersonalInformation: "個人情報",
PersonalPayment: "個人支払い",
PersonalPermissions: "個人権限",
PersonalReschedule: "個人変更",
PersonalRescheduleTip1: "1. 「自主都合による変更」にチェックを入れると、元の出張注文は変更されず、新しく提出された変更申請のみが「個人旅行」として処理されます。",
PersonalRescheduleTip2: "2. すべての費用（運賃差額や航空会社の手数料など）は自己負担となり、承認ワークフローや出張規定のチェックは行われません。",
PersonalRescheduleTip3: "3. 変更注文が「個人旅行」として発券された後は、ビジネス注文に戻すことはできません。",
PersonalTools: "個人用ツール",
PersonalTravelInformation: "個人出張情報",
PersonalTrip: "個人旅行",
PersonalTrip_1: "個人旅行",
PersonalWallet: "個人ウォレット",
PersonalWorkbench: "個人顧客",
PersonEntry: "マイページ",
PhoneNumberFormatIsIncorrect: "電話番号の形式が正しくありません。",
PhoneNumberFormatIsIncorrect_1: "携帯電話番号の形式が正しくありません。",
PhoneNumberOrEmailFormatIsIncorrect: "携帯番号またはメールアドレスの形式が正しくありません。",
Photo: "写真",
PhotoOrFile: "写真/ファイル",
PickUpCity: "乗車都市",
PickUpUseCarTimeTenMinute: "着陸10分後",
PickUpUserCarTimeFiftyMinute: "着陸50分後",
PickUpUserCarTimeFourtyMinute: "着陸40分後（受託手荷物ありに推奨）",
PickUpUserCarTimeSixtyMinute: "着陸60分後",
PickUpUserCarTimeThirtyMinute: "着陸30分後（受託手荷物なしに推奨）",
PickUpUserCarTimeTwentyMinute: "着陸20分後",
Picture: "画像",
PlaceOfDeparture: "出発地",
PlaceOfService: "目的場所",
Plan: "当初の予定",
Plane: "機材",
PlaneBookNoticeCopyTips: "リンクをコピーしました。ミニプログラム内ではプレビューできません。ブラウザで開いてください。",
PlaneConstruction: "空港税",
PlaneConstructionFee: "空港建設費",
PlaneConstructionFuel: "空港税/燃油サーチャージ",
PleaseAddARoomer: "宿泊者を追加してください",
PleaseAddContact: "連絡先を追加してください",
PleaseCancelRoomSelectTitle: "キャンセルする客室を選択してください",
PleaseCheckInAccordingToTheActualFlight: "実際の搭乗便に合わせてチェックインを行ってください。",
PleaseCheckTheBoxToAgreeAfterReadingTheRelevantTermsAndConditions: "規約をご確認の上、同意チェックボックスにチェックを入れてください。",
PleaseCheckUserCancelAgreement: "アカウント削除規約に同意してください",
PleaseChoose: "選択してください",
PleaseChooseAPlaceOfArrival: "目的地を選択してください",
PleaseChooseAPlaceOfDeparture: "出発地を選択してください",
PleaseChooseASeat: "座席指定",
PleaseChooseCarType: "車両タイプを選択してください",
PleaseChooseContacts: "連絡先を選択してください",
PleaseChooseIDType: "身分証明書の種類を選択してください",
PleaseChoosePayWay: "お支払い方法を選択してください",
PleaseChoosesCabinLevel: "座席クラスを選択してください",
PleaseChooseTheAirClub: "マイレージプログラムを選択してください",
PleaseChooseTheDocumentSignatory: "発行国/地域を選択してください",
PleaseChooseTheHotelGroupMembership: "ホテル会員プログラムを選択してください",
PleaseChooseTheReason: "理由を選択してください",
PleaseChooseTheReason_1: "理由を選択してください：",
PleaseChooseTheValidityPeriodOfTheCertificate: "有効期限を選択してください",
PleaseChooseWhenToUseTheCar: "乗車日時を選択してください",
PleaseChooseYourNationality: "国籍を選択してください",
PleaseCompleteTheReceiptInformation: "お届け先情報を入力してください",
PleaseCompleteTheVerificationAsSoonAsPossible: "発券手続きへの影響を防ぐため、速やかに確認を完了してください。",
PleaseCompleteYourGivenNames: "名（パスポート表記通り）を入力してください",
PleaseCompleteYourNameInformation: "お名前を入力してください",
PleaseCompleteYourSegments: "ルート情報を入力してください",
PleaseCompleteYourSurname: "姓（パスポート表記通り）を入力してください",
PleaseConfigureTheExaminerInTheBackground: "管理者へ連絡し、バックエンドで承認者を設定してください。",
PleaseConfirmIfWeChatPaymentHasBeenCompleted: "WeChat Payの支払いが完了したか確認してください",
PleaseConfirmPassengerInfo: "乗客情報を確認してください",
PleaseConfirmTheNewPassword: "新しいパスワードをもう一度入力してください",
PleaseContactTheAccountNumber12306: "12306アカウントを連携してください",
PleaseDoNotRefreshThisPagePromptOperation: "画面を更新せず、携帯電話の指示に従って操作してください",
PleaseEnableLocationPermissionOfCurrentApp: "アプリの位置情報権限をオンにしてください",
PleaseEnter: "入力してください",
PleaseEnter_1: "検索キーワードを入力してください",
PleaseEnterAccurateAndCompleteUnitInformation: "正確かつ完全な会社情報を入力してください",
PleaseEnterAComment: "備考を入力してください",
PleaseEnterACostCenterName: "コストセンターを入力してください",
PleaseEnterAddress: "詳細な住所を入力してください",
PleaseEnterAddress_1: "住所を入力してください",
PleaseEnterAlipayAccount: "Alipayアカウントを入力してください",
PleaseEnterANewPassword: "新しいパスワードを入力してください",
PleaseEnterASuggestionOfNoLessThanEightWords: "8文字以上の提案を入力してください",
PleaseEnterAUsername: "ログインIDを入力してください",
PleaseEnterAuthorizationCode: "認可コードを入力してください",
PleaseEnterBindingCredentialName: "連携する身分証明書番号を入力してください",
PleaseEnterBindingCredentialType: "連携する身分証明書の種類を選択してください",
PleaseEnterBindingMobile: "連携する携帯電話番号を入力してください",
PleaseEnterBindingUserName: "連携するお名前を入力してください",
PleaseEnterCompnayInfo: "企業名を入力してください",
PleaseEnterContactName: "連絡先氏名を入力してください",
PleaseEnterCorrectEmail: "有効なメールアドレスを入力してください",
PleaseEnterCorrectMobile: "有効な携帯電話番号を入力してください",
PleaseEnterDestination: "目的地を入力してください",
PleaseEnterEheCorrectFormatOfValidityPeriod: "正しい有効期限の形式（MM/YYYY）を入力してください",
PleaseEnterInformation: "情報を入力してください",
PleaseEnterKey: "検索キーワードを入力してください",
PleaseEnterMobileVerification: "認証コードを入力してください",
PleaseEnterPhone: "受信者の携帯電話番号を入力してください",
PleaseEnterPhoneNumberOrEmail: "携帯電話番号/メールアドレスを入力してください",
PleaseEnterRealName: "本名を入力してください",
PleaseEnterRecipient: "受信者名を入力してください",
PleaseEnterRegisterInfo: "登録情報を入力してください",
PleaseEnterSMSCode: "SMS認証コードを入力してください",
PleaseEnterStartPoint: "出発地を入力してください",
PleaseEnterTheAccountForRetrievePassword: "パスワードを再設定するアカウントを入力してください",
PleaseEnterTheAccountInformationYouNeedToRetrieveYourLoginPassword: "ログインパスワード再設定のアカウント情報を入力してください",
PleaseEnterTheAirport: "検索する空港を入力してください",
PleaseEnterTheArriveAddress: "降車場所を入力してください",
PleaseEnterTheBindingEmail: "連携済みメールアドレス",
PleaseEnterTheBindingPhone: "連携済み携帯電話番号",
PleaseEnterTheBindingPhoneNumberEmail: "連携済みの携帯電話番号/メールアドレスを入力してください",
PleaseEnterTheBindingPhoneNumberEmail_1: "連携済みの携帯電話番号/メールアドレス",
PleaseEnterTheCardNumber: "カード番号を入力してください",
PleaseEnterTheCardNumberOrUsername: "カード番号またはユーザー名を入力してください",
PleaseEnterTheCarRank: "検索する車両出張規定を入力してください",
PleaseEnterTheCity: "検索する都市を入力してください",
PleaseEnterTheCityNameToSearch: "検索する都市名を入力してください",
PleaseEnterTheCompanyAddress: "会社住所を入力してください",
PleaseEnterTheCorrectAccountPassword: "正しいユーザー名とパスワードを入力してください",
PleaseEnterTheCorrectCreditCardNumber: "正しいクレジットカード番号を入力してください",
PleaseEnterTheCorrectMobilePhoneNumberEmail: "正しい携帯電話番号/メールアドレスを入力してください",
PleaseEnterTheCorrectVerificationCode: "正しい認証コードを入力してください",
PleaseEnterTheCostCenter: "検索するコストセンターを入力してください",
PleaseEnterTheCountry: "検索する国・地域を入力してください",
PleaseEnterTheCurrentPassword: "現在のパスワードを入力してください",
PleaseEnterTheCustomItems: "検索するカスタム項目を入力してください",
PleaseEnterTheDepartAddress: "乗车場所を入力してください",
PleaseEnterTheDepartment: "検索する部門を入力してください",
PleaseEnterTheFlightBookPermission: "検索する航空券予約権限を入力してください",
PleaseEnterTheHomeAddress: "自宅住所を入力してください",
PleaseEnterTheHotelBookPermission: "検索するホテル予約権限を入力してください",
PleaseEnterTheHotelCity: "都市 / ランドマーク / ホテル名",
PleaseEnterTheIntlHotelCity: "都市 / ホテル名",
PleaseEnterTheLastThreeDigitsOfTheCVVSecurityCode: "CVVセキュリティコードの後ろ3桁を入力してください",
PleaseEnterTheName: "検索する氏名を入力してください",
PleaseEnterTheNameOfThePerson: "宿泊者氏名または注文番号を入力してください",
PleaseEnterTheNameOfThePerson_1: "宿泊者氏名、注文番号、またはホテル名",
PleaseEnterTheNameOfTheRank: "検索する出張規定名を入力してください",
PleaseEnterTheNameOfTheRole: "検索する役割名を入力してください",
PleaseEnterTheNewPassword: "8〜20桁の英数字で入力してください",
PleaseEnterTheOldPassword: "現在のパスワードを入力してください",
PleaseEnterThePassengerName: "搭乗者氏名または注文番号を入力してください",
PleaseEnterThePassword: "ログインパスワードを入力してください",
PleaseEnterTheReason: "理由をご入力ください（任意）",
PleaseEnterTheSystemRole: "検索するシステムロールをご入力ください",
PleaseEnterTheTemplate: "検索する承認テンプレート名をご入力ください",
PleaseEnterTheTrainAccountNewPassword: "6～20文字（英数字）",
PleaseEnterTheTrainAccountNewPassword_1: "6文字以上でご入力ください",
PleaseEnterTheTrainBookPermission: "検索する列車チケット予約権限をご入力ください",
PleaseEnterTheTrainStation: "検索する駅名をご入力ください",
PleaseEnterTheTraveler: "検索する名前/メールアドレス/電話番号/社員番号をご入力ください",
PleaseEnterTheTraveler_1: "名前/メールアドレス/電話番号/社員番号/ニックネームで検索",
PleaseEnterTheTraveler_2: "名前/電話番号/身分証明書番号で検索",
PleaseEnterTheUnitCodeOrUnitShortName: "組織ID/略称/正式名称をご入力ください",
PleaseEnterTheValidityPeriodOfTheCreditCard: "クレジットカードの有効期限（月/年）をご入力ください",
PleaseEnterYourAccountInformation: "アカウント情報をご入力ください",
PleaseEnterYourChineseNameOrEnglishName: "中国語氏名または英語氏名をご記入ください",
PleaseEnterYourExceedReason: "規定超過の理由をご記入ください",
PleaseEnterYourNewPasswordAgain: "新しいパスワードをもう一度ご入力ください",
PleaseEnterYourNewPasswordAgain_1: "パスワードをご確認ください",
PleaseFill: "ご記入ください",
PleaseFillBudget: "予算をご記入ください",
PleaseFillIn: "新しい電話番号をご記入ください",
PleaseFillInAlipayAccount: "Alipayアカウントを入力してください",
PleaseFillInCardNumber: "カード番号をご記入ください",
PleaseFillInCostCenterName: "コストセンターをご入力ください",
PleaseFillInDepartmentName: "部署名をご入力ください",
PleaseFillInDiner: "利用者の氏名をご記入ください",
PleaseFillInFirstName: "名をご記入ください",
PleaseFillInGuestName: "宿泊者の氏名をご記入ください",
PleaseFillInIDNumber: "身分証明書番号をご記入ください",
PleaseFillInLastName: "姓をご記入ください",
PleaseFillInName: "お名前をご記入ください",
PleaseFillInNewPhoneCurrentPhone: "新しい電話番号をご記入ください。現在の電話番号：",
PleaseFillInOrderNumber: "注文番号をご記入ください",
PleaseFillInPassengerName: "搭乗者氏名をご記入ください",
PleaseFillInPhoneNumber: "電話番号をご記入ください",
PleaseFillInPhoneOrEmail: "電話番号またはメールアドレスを入力してください",
PleaseFillInRC: "理由コード（RC）をご入力ください",
PleaseFillInSendingEmail: "メールアドレスをご記入ください",
PleaseFillInTheContactMobilePhoneNumber: "連絡先電話番号をご記入ください",
PleaseFillInTheReasonForRefund: "払い戻しの理由をご記入ください",
PleaseFillInTheReasonForRescheduling: "変更の理由をご記入ください",
PleaseFillInTheShippingAddress: "配送先住所をご記入ください",
PleaseFillInVerificationCode: "確認コードをご記入ください",
PleaseFillTheReason: "理由をご記入ください（任意）",
PleaseFillTotalBudget: "総予算をご記入ください",
PleaseFirstGoToLinkYourDidiAccount: "先にDiDiアカウントとの連携を行ってください。",
PleaseGetTheVerificationCode: "先に認証コードを取得してください。",
PleaseHoldDownTheSliderAndDrag: "スライダーを押したまま一番右までドラッグしてください",
PleaseHoldThePhoneVertically: "スマートフォンを垂直に持ってください。",
PleaseInputCreditCardNumber: "クレジットカード番号をご入力ください",
PleaseInputYourDestination: "目的地をご入力ください",
PleaseMakeSureYouHaveEnoughTimeToCheckIn: "1. ご購入の前に、発券後も搭乗手続きの時間が十分にあるかチェックインカウンターでご確認ください。",
pleaseOpenScanOnAlipayScanQRCodeToPay: "Alipayを開き、「スキャン」でQRコードを読み取って支払いを完了してください。",
pleaseOpenScanOnWeChatScanQRCodeToPay: "WeChatの「スキャン」を開き、QRコードを読み取ってお支払いください。",
PleasePressBackOnceToExit: "もう一度戻ると終了します",
PleaseReadAndAgreeTo: "「アカウント権限同意書」をご一読いただき、同意してください",
PleaseReadAndTickTheAgreementFirst: "規約をご確認の上、チェックを入れてください",
PleaseReselectYourCheckInDate: "チェックイン日を再選択してください",
PleaseScreenshotSaveQRCode: "スクリーンショットを撮ってQRコードを保存してください",
PleaseSelectADepartureDate: "出発日を選択してください",
PleaseSelectADestination: "目的地を選択してください",
PleaseSelectAirport: "空港を選択してください",
PleaseSelectApprover: "承認者を選択してください",
PleaseSelectArea: "地域を選択してください",
PleaseSelectArrival: "到着地を選択してください",
PleaseSelectArrivalAirport: "到着空港を選択してください",
PleaseSelectArrivalCity: "到着都市を選択してください",
PleaseSelectArrivalTrainStation: "到着駅を選択してください",
PleaseSelectAtLeastOneCityOverseas: "国際・海外都市を少なくとも1つ選択してください",
PleaseSelectAtLeastOneOccupant: "宿泊者を少なくとも1名選択してください",
PleaseSelectBackDate: "復路日を選択してください",
PleaseSelectBusinessTravelScale: "月間出張規模を選択してください",
PleaseSelectCertificate: "身分証明書の種類を選択してください",
PleaseSelectCertificateNo: "身分証明書番号を入力してください",
PleaseSelectCostCenter: "コストセンターを選択してください",
PleaseSelectDepartment: "部署を選択してください",
PleaseSelectDeparture: "出発地を選択してください",
PleaseSelectDepartureAirport: "出発空港を選択してください",
PleaseSelectDepartureTrainStation: "出発駅を選択してください",
PleaseSelectDestination: "都市を選択してください",
PleaseSelectDiner: "利用客を選択してください",
PleaseSelectedTheCheckInDate: "チェックイン日を選択してください",
PleaseSelectFlightChangeDate: "変更日を選択してください",
PleaseSelectFlightDate: "搭乗日を選択してください",
PleaseSelectFlightNumber: "便名を入力してください",
PleaseSelectGuest: "宿泊者を選択してください",
PleaseSelectGuestLeastOne: "各客室に少なくとも1名の宿泊者を入力してください",
PleaseSelectHotelArrivalTime: "到着予定時刻を選択してください",
PleaseSelectLoginTypeWitchAnytime: "ログイン方法を選択してください",
PleaseSelectOrder: "注文を選択してください",
PleaseSelectOrFillInMealsRemarks: "食事の備考を選択または入力してください",
PleaseSelectOrFillInPurpose: "出張目的を選択または入力してください",
PleaseSelectOrFillInTheReasonForCancelReason: "キャンセル理由を選択または入力してください",
PleaseSelectOrFillInTheReasonForExceedingTheStandard: "規程超過の理由を選択または入力してください",
PleaseSelectOrFillInTheReasonForRefundReason: "払戻理由を選択または入力してください",
PleaseSelectOrFillInTheReasonForReschedulingReason: "変更理由を選択または入力してください",
PleaseSelectOrFillInTheReasonForViolatingTheTravelRank: "出張規程超過の理由を選択または入力してください",
PleaseSelectOrFillInTheReasonOrPleaseSelectTheMixedPayment: "規程超過の理由を選択・入力するか、自己負担（混合決済）を選択してください",
PleaseSelectPassenger: "搭乗者を選択してください",
PleaseSelectPassengersFirst: "先に搭乗者を選択してください",
PleaseSelectPaymentWay: "お支払い方法を選択してください",
PleaseSelectPermanentResidence: "常住地を選択してください",
PleaseSelectPurpose: "出張目的を選択してください",
PleaseSelectSeats: "座席を選択してください",
PleaseSelectTheCardExpirationMonth: "月を選択してください",
PleaseSelectTheCardExpirationYear: "年を選択してください",
PleaseSelectTheCheckOutDate: "チェックアウト日を選択してください",
PleaseSelectTheDateOfBirth: "生年月日を選択してください",
PleaseSelectTheDepartureCity: "出発地を選択してください",
PleaseSelectTheEndDate: "終了日を選択してください",
PleaseSelectTheFavoriteToDeleteFirst: "削除するお気に入りを選択してください",
PleaseSelectTheFirstSeat: "最初の区間の座席を選択してください",
PleaseSelectTheFollowingMethodsForVerification: "検証方法を選択してください",
PleaseSelectTheItineraryToBeRescheduled: "変更対象の旅程を選択してください",
PleaseSelectTheMixedPayment: "規定超過分の支払い（超標付）を選択して予約を続行してください",
PleaseSelectThePassengerWhoNeedsToChange: "変更する搭乗者を選択してください",
PleaseSelectThePassengerWhoNeedsToRefund: "払い戻し対象乗客を選択してください",
PleaseSelectThePassengerWhoNeedsToReschedule: "日程変更する旅程を選択してください",
PleaseSelectTheRoomAndRoomer: "客室と宿泊者の選択",
PleaseSelectTheSecondSeat: "2区間の座席を選択してください",
PleaseSelectTheShippingAddress: "配送先住所を選択してください",
PleaseSelectTheStationWhereYouWillBePickedUp: "乗車駅を選択してください",
PleaseSelectTheTravelApplication: "出張申請を選択してください",
PleaseSelectTheTypeOfQuestion: "質問の種類を選択してください",
PleaseSelectTrainStation: "駅を選択してください",
PleaseSelectTraveler: "旅行者を選択してください",
PleaseSendTheAbovePaymentTo: "恐れ入りますが、上記の金額を期日までにお振込みください。",
PleaseSure: "必ずご確認ください：",
PleaseUseTheFollowingCreditCard: "ご案内：下記のクレジットカードのみご利用可能です",
PleaseVerifyThatYouHaveAFaceIDForLogin: "ログインのためFace ID認証を行ってください",
PleaseVerifyThatYouHaveATouchIDForLogin: "ログインのためTouch ID認証を行ってください",
PointYourFaceAtTheFrontCameraOfYourPhone: "フロントカメラに顔を向けてください",
PoliciesServices: "ポリシーとサービス",
Policy_1: "ポリシー",
PolicyAddress: "保険送付先住所",
PolicyNoColon: "証券番号：",
PopularDestinations: "人気の目的地",
PopularFilters: "人気の条件",
PopularRoutes: "人気のルート",
Pptimization: "おすすめプラン",
Precautions: "注意事項",
Preferential: "お得な特典",
Preferential_1: "適用可能な特典",
PremiumHotel: "ハイクラス",
PremiumHotel_1: "ハイクラス",
Prepay: "事前払い",
Prepayments: "前払金",
PreQuantifier: "/人",
PressVoice: "押したまま録音",
Preview: "プレビュー",
PreviewNotSupportedAndIsCopy: "プレビュー非対応です。クリップボードにコピーしました。ブラウザで開いてください。",
Price: "料金",
Price1000_1300: "¥1,000-1,300",
Price1300_1800: "¥1,300-1,800",
Price150: "¥150以下",
Price150_300: "¥150～300",
Price300_450: "¥300–450",
Price400: "¥400以下",
Price400_700: "¥400–700",
Price450_600: "¥450–600",
Price600_1000: "¥600～1,000",
Price700_1000: "¥700～1,000",
Price_1: "参考運賃",
Price_2: "星評価・価格",
PriceCeiling: "上限価格",
PriceDetails: "料金内訳",
PriceHighest: "高→低",
PriceHighToLow: "価格：高→低",
PriceHotel: "客室料金",
PriceLowest: "低→高",
PriceLowToHigh: "価格：低→高",
PriceOver1000: "1000元以上",
PriceOver1800: "1800元以上",
PriceRating: "価格／星評価",
PriceRating_1: "価格／ダイヤモンド評価",
PriceSingleChoice: "価格（単一選択）",
Print: "印刷",
PriorityHighPrice: "高価格優先",
PriorityHighRating: "高評価優先",
PriorityLowPrice: "最安値優先",
PrivacyNumberProtection: "番号隠蔽保護",
PrivacyPolicy: "プライバシーポリシー",
ProceedToBind: "連携する",
Processing: "未処理",
ProcessingCompleteTime: "処理完了日時",
ProcessingNotes: "手続きに関する注意事項",
ProcessingProcedure: "手続きの流れ",
ProcessingTime: "処理時間",
ProcessingTime_1: "手続き期間",
ProduceDesc: "商品仕様",
ProduceName: "商品名",
Product: "商品",
ProductDesc: "商品詳細",
ProductExperience: "プロダクト体験",
ProductId: "商品ID",
ProductIntroduction: "商品紹介",
ProductOverview: "商品概要",
ProductUseRuleDes: "利用規約",
Progress: "進行中",
PromptDateHotel: "選択された日付はホテル現地の時間です。",
PromptDatePrice: "選択された日付は出発地の時間です。価格は変動するため、最終確定料金が適用されます。",
ProportionOfContractedHotelStarLevelTransactions: "契約ホテル星評価別取引額比率",
ProportionOfHotelRoomNightsInAgreement: "契約ホテル契約間夜数比率",
ProportionOfNetTransactionPrice: "純取引額比率",
ProportionOfRCTimes: "RC割合",
PullToRefresh: "引っ張って更新",
PullUpLoadMore: "読み込んでさらに表示",
Punctuality: "定時運航率",
PutTheQRCodeIntoTheBox: "枠内にQRコードを合わせてください。自動的にスキャンされます。",
QrCode: "QRコード",
QRCodeHasExpired: "QRコードの有効期限が切れています",
Quantity: "チケット枚数",
Quarterly: "四半期",
QueryConditions: "検索条件",
QueryNotJurisdiction: "閲覧権限がありません",
QueryQuoteErrors: "見積もりの取得に失敗しました",
QueryRange: "検索範囲",
QueryResultOfTheCurrentCity: "現在の都市の検索結果",
QueryType: "検索タイプ",
QuickSelection: "クイック選択",
RankInformation: "差旅規程情報",
RankManagement: "差旅規程管理",
RankName: "差旅規程名",
Rating: "星・ダイヤモンドクラス",
RatingHighToLow: "星評価：高い順",
RatingLowToHigh: "星評価：低い順",
RatingMultipleChoice: "星評価（複数選択可）",
RCContent: "RC内容",
RCManagement: "RC管理",
RCType: "RCタイプ",
Read: "既読",
Reapply: "再申請",
Reason: "理由",
ReasonForNotSelectingTheCheapestFlight: "最安値便を選択しない理由",
ReasonForNotSelectingTheLowestPrice: "最安値を選択しない理由",
ReasonForRejection: "却下理由",
ReasonForTheRefundTicket: "払い戻し理由の種類",
ReasonForTicketIssueFailure: "発券失敗の理由",
ReasonForTravelRankingViolation: "規程違反の理由",
ReasonsForBusiness: "出張目的",
ReBook: "再予約",
ReceiveMode: "受取方法",
RecentlyVisited: "最近見た項目",
RecentSearches: "検索履歴",
Recharge: "チャージ",
RechargeAmount: "チャージ金額",
Recommend: "おすすめ",
Recommend_1: "おすすめ情報",
RecommendCabinPrice: "同一便のおすすめプラン：",
Recommended: "おすすめ順",
RecommendedFlights: "おすすめ便",
RecommendedTransferFlights: "おすすめの乗り継ぎ便",
RecommendForYou: "あなたへのおすすめ",
RecommendReason: "推奨理由",
RedirectFailedTryOtherMethod: "決済画面へ正常に遷移しない場合は、方法2または方法3をお試しください。",
RedirectToDiDiCarHailing: "DiDi配車サービスへ移動",
ReElection: "クラス変更",
RefreshFlight: "フライト情報を更新",
RefreshPageTip_1: "承認ステータスが変更されました。ページを更新して最新情報を取得してください。",
RefreshPrices: "料金を更新",
RefreshQrCode: "QRコードを更新",
RefreshRetry: "ページを更新して再度お試しください。",
RefreshSucceed: "更新が完了しました",
Refund: "払い戻し",
Refund_1: "払い戻し",
RefundAmount: "返金額",
RefundAmountPendingApproval: "返金額承認待ち",
RefundApprovalFlow: "払い戻し承認フロー",
RefundCertificate: "払い戻し証明書",
RefundChangeAndBaggageInstructions: "変更・払い戻しおよび手荷物規定",
RefundDetails: "返金明細",
RefundFailed: "払い戻し失敗",
RefundFee: "払い戻し手数料",
Refunding: "払い戻し手続き中",
RefundInstructions: "払い戻し規定",
RefundOrChangeExplain: "変更・払い戻し規定",
RefundOrder: "払い戻し申請",
RefundOrderDate: "払い戻し申請日",
RefundOrderDetails: "払い戻し詳細",
RefundOrderNumber: "払い戻し注文番号",
RefundOrderReason: "払い戻し理由",
RefundOrderTime: "払い戻し申請日時",
RefundPassenger: "払い戻し対象搭乗者",
RefundPolicy: "払い戻し規定",
RefundRate: "払戻率",
RefundReason: "払い戻し理由",
RefundSucceed: "払い戻し完了",
RefundTicket: "払戻し",
RefundTrip: "払い戻し対象区間",
Regard: "フォロー",
RegardEmployees: "フォロー中",
RegardFailed: "フォローに失敗しました",
RegardSuccess: "フォローしました",
Register: "新規登録",
Register_1: "登録情報",
Register_2: "携帯電話認証",
Register_3: "審査待ち",
RegisterNow: "今すぐ登録",
RegisterSuccess: "担当者より追ってご連絡いたしますので、お電話がつながる状態でお待ちください。よろしくお願いいたします。",
ReimbursementVoucher: "経費精算伝票",
ReissueInvoice: "請求書の再発行",
Reject: "却下",
Rejected: "差し戻し",
RelationAccount: "アカウント連携",
RelationLogin: "連携してログイン",
RelationToHOMSOM: "ログインアカウントを連携してください",
ReleaseImmediateLoad: "離して読み込み",
ReleaseImmediateRefresh: "離して更新",
ReleaseSendSlideUpCancel: "離して送信、上にスワイプしてキャンセル",
ReleaseToCancel: "指を離してキャンセル",
ReleaseVoice: "指を離して送信",
Relevance: "関連付け",
Relocate: "現在地を再取得",
RemainingEnterpriseCodePayPrefix: "企業コード決済の残り時間：",
RemainingSubmitTicketIssuePrefix: "発券依頼の残り時間：",
Remarks: "備考",
ReminderYouCanImportFrequentTravelerInFrequentTravelerManagement: "ヒント：「常旅客管理」で情報をインポートして常旅客を追加することも可能です。",
RemovalFailedPleaseTryAgainLater: "削除に失敗しました。しばらく経ってから再度お試しください。",
RemoveFrequentTraveller: "この常旅客を削除",
RemoveFromTheTiedList: "連携解除",
RemoveSuccessful: "削除しました",
RemovetheCostCenter: "コストセンターを削除",
RemoveTheDepartment: "部門を削除",
RemoveTheEmployee: "従業員を削除",
RemoveTheNonEmployee: "外部ユーザーを削除",
RemoveTheRC: "RCを削除",
RemoveThisFrequentContact: "よく使う連絡先を削除",
RenovationYears: "改装年",
ReportName: "レポート名",
ReportTotal: "合計",
ReQuery: "再検索",
RequiredChoose: "必須",
RequiredChooseArrivalCityAddressDesc: "(必須) 出張中の経由都市をすべて追加してください",
RequiredChoosePleaseChoose: "(必須) 選択してください",
RequiredChooseUneditable: "(必須) 編集不可",
RequiredDocuments: "必要書類",
RequiredFill: "必須",
RequiredFillPleaseFill: "(必須) 入力してください",
RequiredFillPleaseFillOrChoose: "(必須) 入力または選択してください",
RequiredFillUneditable: "(必須) 編集不可",
RequiredReadingForBook: "お役立ち情報",
RequiredReadingForChange: "変更規定",
RequiredReadingForHotel: "予約前の注意事項",
RequiredReadingForRefund: "払い戻し規定",
RequiredReadingForTrainChange: "変更規定",
ReReserveSeat: "座席を再確保する",
ReScan: "再スキャン",
Reschedule: "変更申請",
Rescheduled: "変更",
Rescheduling: "日程変更",
ReschedulingApprovalFlow: "変更承認フロー",
ReschedulingFee: "航空会社変更手数料",
ReschedulingReason: "変更理由",
ReSearch: "再検索",
Reselect: "再選択",
Reselect_1: "往路を再選択",
ReselectFlight: "フライトを再選択",
ReSelectPrice: "価格を再選択",
Resend: "再送信",
ResendConfirmationMessage: "確認内容を再送信",
ResendPleaseWait: "再送信中、しばらくお待ちください...",
ResendReimbursementVoucher: "領収書を再送信",
ReservationBeforeDidi: "滴滴（Didi）で配車を利用する前に、用车预订单（配車申請書）の入力が必要です。利用方法がご不明な場合は、",
ReservationOrder: "申請書",
ReserveApproverNameColon: "予備承認者：",
ReserveCar: "配車予約",
ReserveNow: "今すぐ予約",
ReserveSeat: "座席を確保する",
ReserveUseCar: "配車予約",
Reset: "リセット",
ResetFilter: "クリア",
ResetPassword: "パスワード再設定",
ResetPwdSuccess: "予約パスワード再設定完了。戻ってお支払いを続けてください",
ResetUsingBoundEmail: "登録済みのメールアドレスで再設定",
ResetUsingBoundPhoneNumber: "登録済みの携帯電話番号で再設定",
Result: "検索結果",
RetrieveByEmail: "メールアドレスで探す",
RetrieveByMobile: "携帯電話番号で探す",
RetrievePassword: "パスワードをお忘れの方",
RetrievePasswordByMobile: "携帯電話番号で探す",
Retry: "再試行",
Return: "復路",
ReturnAndChangeInstructions: "変更・払戻規定",
ReturnColon: "復路：",
ReturnDate: "復路出発日",
ReturnFilter: "復路条件絞り込み",
ReVetting: "再申請",
RevisedFlightInformation: "変更後のフライト情報：",
ReviseTheDifference: "運賃差額",
RideInfo: "乗車情報",
RMBNight: "元/1泊",
RoleDescription: "説明",
RoleDetail: "ロール詳細",
RoleManagement: "ロール管理",
RoleName: "ロール名",
Room: "客室",
Roomer: "宿泊者",
RoomerDetails: "宿泊者情報",
RoomerName: "宿泊者氏名",
RoomFees: "部屋代",
RoomNight: "部屋数・泊数",
RoomsAndGuests: "部屋数・人数",
RoomType: "部屋タイプ",
RoomTypeDetails: "詳細",
RoomTypeRemarks: "部屋に関する特記事項",
RoundTrip: "往復",
Route: "路線",
RouteType_1: "片道 / 往復",
RUB: "RUB",
Rules: "ルール",
SafetyAlarmRequired: "緊急通報機能のご利用にあたって",
SafetyManage: "セキュリティ管理",
SafetyReminder: "シートベルトを着用し、安全運転にご協力ください。お降りの際は、お忘れ物のないようご注意ください。",
SalesPrice: "販売価格",
SameLevelApprover: "並列承認者",
SameStationTransfer: "同駅乗り換え",
Save: "保存",
Save_2: "変更を保存",
Save_3: "節約額",
SaveFailed: "保存に失敗しました",
SaveFailedFromCode: "QRコードの保存に失敗しました",
SaveInfo: "情報を保存",
SaveOrderError: "予約の保存に失敗しました。フライト検索画面に戻り、再度選択してください。",
SaveQRCode: "QRコードを保存",
SaveSucceed: "保存しました",
SaveSucceedToPhotoLibary: "アルバムに保存しました",
SavingAnalysisofBookinginAdvance: "早期予約による節約分析",
SavingAndMissedSaving: "削減効果分析",
Savings: "節約額",
SavingsLosses: "削減と損失",
ScaleLevel_1: "1万〜3万",
ScaleLevel_2: "3万〜10万",
ScaleLevel_3: "10万〜30万",
ScaleLevel_4: "30万〜100万",
ScaleLevel_5: "100万超",
ScanAndLogin: "スキャンログイン",
ScanCodeLogin: "QRコードログイン",
ScannedAccountVerification12306: "12306アカウントのオンライン核验（本人確認）が必要です。予約手続きを進めるため、以下のリンクより核验を完了させてください。",
ScannedOCchoose: "または一覧から選択",
ScanQrByAlipay: "AlipayでQRコードをスキャンして支払いを完了してください",
ScanQRCodePay: "QRコードで支払い",
ScanSuccessfully: "スキャンに成功しました",
ScanTheQRCode: "QRコードをスキャン",
Schedule: "時刻表",
ScheduleConflictTip: "予定重複アラート",
ScheduledItinerary: "手配済み旅程",
ScheduleTip: "ご注意：実際の運行状況を基準としてください。駅のアナウンスや掲示板をご確認ください。",
Search: "検索",
Search_1: "検索",
Search_2: "検索",
Search_3: "検索",
SearchCanBeRescheduled: "変更可能便を検索",
SearchFlight: "フライト検索",
SearchForMoreCities: "他の都市を検索",
SearchHistory: "検索履歴",
SearchHistory_1: "検索履歴",
SearchHotel: "ホテル検索",
Searching: "検索中...",
SearchThisArea: "このエリアを検索",
SearchTrain: "列車検索",
Seat: "座席",
SeatInfo: "座席指定情報",
SeatNumber: "座席番号",
SeatSelectionDepartingTrip: "座席指定（往路）",
SeatSelectionReturnTrip: "座席指定（復路）",
SeatSelectionSucceed: "座席を指定しました",
SecondClass: "2等席",
SecondStep: "ステップ2",
SecurityAlarmDesc: "危険に遭遇した場合は、速やかに110番通報してください。",
SecurityAssistant: "セキュリティアシスタント",
SecurityCenter: "セキュリティセンター",
SecurityCode: "セキュリティコード",
See: "最安値を見る",
SeeAll: "すべて表示",
Select: "選択済み",
SelectAddressOnMap: "地図から住所を選択",
SelectAll: "すべて選択",
SelectApprover: "承認者を選択",
SelectAtLeastOneColumn: "エクスポートする項目を少なくとも1つ選択してください。",
SelectCabin: "クラスを選択",
SelectCarPlatform: "配車プラットフォームを選択",
SelectCarScene: "利用シーンを選択",
SelectCarUsageSceneRequired: "会社の規定に基づき、利用シーンを選択してください。",
SelectCity: "都市を選択",
SelectCityWithAirport: "空港のある都市を選択してください",
SelectConfirmationOrder: "確認書を選択",
SelectContact: "連絡先を選択",
SelectCustomItems: "カスタム項目を選択",
SelectDate: "日付を選択",
SelectDeparting: "往路を選択",
SelectDriverContactObject: "ドライバーの連絡対象を選択してください",
Selected: "選択",
Selected_1: "選択済み",
SelectedAddress: "場所を選択",
SelectedAsGoing: "往路として選択",
SelectedFlight_1: "選択済みのフライト",
SelectedFlights: "フライト選択済み",
SelectedFlightsForYou: "おすすめのフライト",
SelectedPassengers: "搭乗者選択済み",
SelectedPassengerVehicle: "乗車人数選択済み",
SelectEmployees: "従業員を選択",
SelectEnglishSurname: "英語の姓を選択してください",
SelectFlight: "フライトを選択",
SelectFlightChangeInfo: "変更するフライト情報を選択",
SelectFlightChangeStep1: "01. 変更する搭乗者を選択",
SelectFlightChangeStep2: "02. 変更するフライトを選択",
SelectFlightChangeStep3: "03. 変更後の日程を選択",
SelectFlightOnline: "チェックインするフライトを選択",
SelectFlightRefund: "払い戻すフライトを選択",
SelectFlightRefundInfo: "払い戻すフライト情報を選択",
SelectFlightRefundStep1: "01. 払い戻す搭乗者を選択",
SelectFlightRefundStep2: "02. 払い戻すフライトを選択",
SelectFlightRescheduling: "変更するフライトを選択",
SelectFollowUser: "フォローするユーザーを選択してください",
SelectFromTheAlbum: "アルバムから選択",
SelectInAlipayCashier: "アリペイレジ画面内で選択してください",
SelectInvoicingType: "請求書の種類を選択",
Selection: "座席指定",
SelectionResult: "座席指定結果",
SelectLanguage: "言語選択",
SelectOneWay: "片道",
SelectOrderExportFields: "出力項目の選択",
SelectPassengers: "乗客選択",
SelectPolyphone: "正しい読みを選択",
SelectReimbursementVoucher: "精算書類の選択",
SelectReport: "レポート選択",
SelectReturn: "復路",
SelectTheCardExpirationMonth: "月を選択",
SelectTheCardExpirationYear: "年を選択",
SelectTheNumberOfRooms: "部屋数を選択",
SelectThePassenger: "搭乗者を選択",
SelectThePassengerVehicle: "乗客を選択",
SelectTheReasonForTheRefundTicket: "払い戻し理由の選択",
SelectTheRescheduleType: "変更種別の選択",
SelectTheStartingPointAndDestination: "出発地・到着地を選択",
SelectTrain: "列車を選択",
SelectTrainChangeInfo: "変更情報の選択",
SelectTrainChangeStep1: "変更する乗客を選択",
SelectTrainChangeStep2: "変更する旅程を選択",
SelectTrainRefundInfo: "払い戻し情報の選択",
SelectTrainRefundStep1: "払い戻しする乗客を選択",
SelectTrainRefundStep2: "払い戻しする旅程を選択",
SelectTrainRescheduling: "変更する旅程を選択",
SelectYourCabin: "クラス選択",
SelectYourSeatDeparting: "往路便の選択",
SelectYourSeatReturn: "復路便の座席選択",
Self: "本人",
SelfPay: "自己負担",
SelfServiceChange: "本人のチケット変更",
SelfServiceRefund: "本人のチケット払い戻し",
Send: "送信",
SendATo12306: "12306へ送信",
SendCancelOrderEmail: "キャンセル完了メールを送信",
SendCancelOrderSms: "キャンセル完了SMSを送信",
SendDistressMessage: "緊急SOS送信",
SendEmail: "メールで送信",
SendEmailOrPhone: "携帯・メールへ送信",
SendFailure: "送信失敗",
SendingLXD: "Travel Beansを贈る",
SendMail: "メール送信",
SendMailSuccessfullyPleaseCheckTheMailboxToResetThePassword: "メールを送信しました。受信トレイを確認してパスワードを再設定してください。",
SendMoneyToTheFollowingAccount: "下記口座へお振込みください",
SendSMS: "以下宛てに送信しました：",
SendSMS_1: "認証SMSを送信しました。確認コードを入力してください。",
SendSMS_2: "SMS送信",
SendSMSNotification: "SMS通知を送信",
SendSucceed: "送信成功",
SendToEmail: "メールで送信",
SendVerificationCode: "認証コード送信",
SendVerificationCode12306: "SMSで「666」を12306宛てに送信",
SeniorApprover: "直属の上司",
SerialNumber: "取引番号",
Service: "サポート",
Service_1: "オペレーター対応",
ServiceAgreement: "利用規約",
ServiceFee: "サービス手数料",
ServiceLife: "有効期間",
SetAsDefaultContact: "デフォルト連絡先に設定",
SetAsStaff: "従業員に設定",
SetBookingPwd: "予約パスワード設定",
SetCompanyAddress: "会社住所を設定",
SetEmergencyContact: "緊急連絡先を設定",
SetHomeAddress: "自宅住所を設定",
SetNewPassword: "新しいパスワードを設定",
SetNewPhoneNumber: "新しい電話番号を設定",
SetPwdSuccess: "予約パスワード設定完了。戻ってお支払いを続けてください",
SetPwdTipBeforeCorpPay: "貴社規定により、企業支払いをご利用の前に予約パスワードを設定してください",
SetSuccessfully: "設定しました",
Setting: "設定",
SettlementMethod: "精算方法",
SettlementPeriod: "精算サイクル",
SettleNow: "即時精算",
SGD: "シンガポール・ドル",
SharedFlight: "コードシェア便",
SharePDF: "PDFを共有",
ShareWithFriends: "友達に共有",
ShippingAddress: "配送先住所",
ShowAvailableTicketsOnly: "空席のみ",
ShowMoreSuppliers: "サービス提供会社をもっと見る",
ShowTheFrontOfYourFace: "顔の正面を表示してください",
SigningPolicy: "変更・振替規定",
SignOut: "ログアウト",
SignOut_1: "ログアウト",
SignResultTimeout: "契約結果の確認がタイムアウトしました。手動で認可結果を取得するか、再試行してください。",
SignSuccess: "契約が完了しました",
Skip: "スキップ",
SkipLogin: "ログインせずに予約",
SliderDrag: "右へスライドしてパズルを完成",
SlideUpToSeeMore: "上にスワイプして続きを表示",
SlideYourFingerUp: "上にスワイプして送信をキャンセル",
Smoke: "喫煙",
SMS: "SMS認証",
SMSVerification: "SMS認証",
SnatchCodeWarn_1: "列車オプションを複数選択すると予約成功率が高まります。",
SnatchCodeWarn_2: "当初は最高運賃を請求いたしますが、航空券発行後に差額を自動返金いたします。",
SnatchInfo: "抢票情報",
SnatchSeatsWarn_1: "・座席を複数選択すると成功率が高まります。",
SnatchSeatsWarn_2: "・一時的に最高料金を請求いたしますが、最終価格がそれより低い場合は差額を返金いたします。",
SnatchTicket: "抢票",
SnaTchTicketDetails: "抢票詳細",
SoldOut: "満席",
SorryCantFind: "検索結果はありません",
SorryNoCabinAvailable: "空席なし",
SorryNoFilterFlight: "該当するフライトが見つかりませんでした。",
SorryNoFilterTrain: "該当する列車の時刻表が見つかりませんでした。",
SorryNoMatchingFlight: "該当するフライトはありません。",
SorryNoMatchingHotel: "該当ホテルなし",
SorryNoMatchingRoom: "該当する客室タイプが見つかりません",
SorryNoMatchingTrain: "該当する列車が見つかりません",
SorryNoSearchFlight: "予約可能なフライトはありません",
SorryNoSearchTrain: "予約可能な列車はありません",
SorryThePageYouVisitedDoesNotExist: "ページが見つかりません",
Sort: "並び替え",
SortDepartureEarlyToLate: "出発時間（早い順）",
SortDepartureLateToEarly: "出発時間（遅い順）",
SortPrice: "価格順",
SortPriceHighToLow: "価格（高い順）",
SortPriceLowToHigh: "価格（安い順）",
SortRecommend: "おすすめ順",
SortTime: "時間順",
SpecialLineForTravelConsultants: "出張コンシェルジュ専用窓口",
SpecialOffer: "特価",
SpecificRequirements: "特別要望",
Spending: "経費",
Staff: "従業員",
StaffAdd: "従業員を追加",
StaffNo: "社員番号",
StarComfort: "3つ星",
StarComfort_1: "3ダイヤ",
StarEconomic: "2つ星以下",
StarEconomic_1: "2ダイヤ以下",
StarLuxury: "5つ星",
StarLuxury_1: "5ダイヤ",
StarPremium: "4つ星",
StarPremium_1: "4ダイヤ",
StarRating: "星級",
Start: "開始",
StartDate: "開始日",
StartVerification: "照合開始",
StationDropOff: "駅送り",
StationName: "名称",
StationPickup: "駅迎え",
StationTransferService: "駅送迎サービス",
StatisticalBillNumber: "集計請求番号",
StatisticalDate: "統計日",
StatisticalDimension: "集計軸",
StatisticalMethod: "統計範囲",
StatisticsByUnit: "組織別",
Status: "状況",
Stay: "滞在",
StayDuration: "滞在時間",
Stayed: "訪問済み",
StepOneCopyShareCodeOpenAlipay: "1. コードをコピーし、Alipayを開く",
StepOneOpenAlipay: "1. Alipayを開く",
StepOneOpenAlipayScan: "1. Alipayを開き、「スキャン」をタップ",
StepTwoClickAgreeAndUse: "2. 「同意して利用する」をタップ",
StillLeave: "それでも離れる",
Stop: "経由",
StopInfo: "経由情報",
StowMoreSuppliers: "サプライヤーを折りたたむ",
SubmissionDate: "提出日",
SubmissionTime: "提出日時",
Submit: "送信",
Submit_2: "送信",
SubmitAndJumpDidi: "送信してDiDiへ移動",
SubmitAndPay: "送信して支払う",
SubmitOrder: "注文を送信",
SubmitOrderForChange: "変更注文を送信",
SubmitOrderForChange_1: "変更申請を送信",
SubmitOrderPaymentDescription: "注文を送信し、アリペイ企業支払いにてチケットを購入してください",
SubmitSucceed: "送信完了",
Submitted: "送信済み",
SubmittedMaterials: "提出済み資料",
SubmittedOn: "提出日",
SubmittedRefund: "払い戻し申請",
SubmitTicketIssue: "発券を確定する",
SubmitVetting: "承認申請",
Subsidiary: "ポイント明細",
SubwayStation: "地下鉄駅",
SuccessfulPasswordModification: "パスワード変更完了",
SuggestMultipleChoices: "複数選択を推奨",
SuggestUpdateOrClearFilter: "条件を変更またはクリアしてください",
SuperEconomyClass: "プレミアムエコノミー",
SuperiorCostCenter: "親コストセンター",
SuperiorDepartment: "親部門",
SupportImageAndPdfOnly: "画像・PDFのみ対応",
SupportingMixedPayment: "超標付に対応",
Surname: "姓（ピンイン）",
SurnameEgLI: "例：HAN",
SurnameHint: "例：王大偉→WANG",
Surplus: "残り",
SwimmingPool: "プール",
SwipeVerification: "スライドして認証",
Switch: "切替",
SwitchAccount: "アカウント切替",
SwitchAccountGo: "アカウントを切り替えて続行",
SwitchAndAccess: "切り替えてアクセス",
SwitchPerson: "個人に切替",
SwitchPersonAccount: "個人アカウントに切替",
SwitchUnit: "組織切替",
SwitchUnitAccount: "法人アカウントに切替",
SyncDate: "同期日",
SystemApproval: "システム承認",
SystemBusy: "システムが混み合っています。しばらくしてからお試しください。",
SystemPermissionCamera: "カメラ権限を有効にしてください",
SystemPermissionDevice: "ストレージ権限を有効にしてください",
SystemPermissionInstall: "権限を有効にしてください",
SystemPermissionLocation: "位置情報権限を有効にしてください",
SystemRecommendedPrice: "推奨価格",
SystemRole: "システムロール",
TakeAPicture: "写真を撮る",
TakeOffTimeAnalysis: "出発時間帯分析",
TakesOff: "出発",
TalkAboutYourSuggestionOrProblem: "ご意見・ご要望をお聞かせください",
Taxi: "タクシー",
TaxIdOnlyEnglishOrNumbers: "納税者番号は英字または数字のみ入力できます",
TaxpayerIDNumber: "納税者番号",
TaxRegisterAddress: "税務登録住所",
TeamLink: "チームリンク",
TeamQRcode: "チームQRコード",
Telephone: "電話",
TemplateApprovalByDesignatedApprover: "承認フローは予約時に選択した指定承認者に従います",
TemplateBound: "他のテンプレートに紐付け済み",
TemplateName: "テンプレート名",
TemplateNotes: "テンプレート備考",
ThankYouForYourFeedback: "フィードバックありがとうございます",
THB: "タイ・バーツ",
TheApplicationFormYouHaveSelectedNotSupportRoundTripSwitching: "選択した申請書は往復切替に対応していません",
TheCarryingRegulationsFor: "航空機へのリチウム電池・モバイルバッテリー持ち込み規定",
TheCityHasBeenSelected: "選択済みの都市",
TheCodeValueIsEmpty: "コード値が空です",
TheCurDatCanExcTheNexTriDatPleGoBacToTheHomPagToModify: "現在の日付は次回の出張日を超えることはできません。ホーム画面に戻って修正してください",
TheCurrentDeviceIsLockedOrNotBiometricEnabled: "デバイスがロックされているか、生体認証が有効になっていません",
TheCurrentDeviceSupportsFaceID: "Face IDが利用可能です。有効にしますか？",
TheCurrentDeviceSupportsTouchID: "指紋ログインが利用可能です。有効にしますか？",
TheCurrentLogin: "現在ログイン中",
TheCurrentNetworkIsNotAvailable: "ネットワークを利用できません",
TheCurrentNetworkIsNotAvailable_1: "ネットワークを利用できません。接続状況をご確認ください",
TheCurrentOrderHasBeenSplitIntoMultipleOrdersPleaseGoToTheOrderListToView: "この注文は複数の注文に分割されました。注文一覧をご確認ください",
TheCurrentOrderIsAPersonalPaymentOrder: "個人支払い注文です。承認後、速やかにお支払いのうえ発券してください",
TheCurrentOrderRequiresPersonalPayment1: "個人支払いが必要です。支払い完了後に発券されます",
TheCurrentOrderRequiresPersonalPayment2: "個人支払いが必要です。支払い完了後に確認されます",
TheCurrentPointsAreNotEnoughToExchangeThisItem: "この商品と交換するポイントが不足しています",
TheCurrentServiceNeedsToUseLocation: "位置情報機能の利用が制限されています。設定から許可してください。",
TheCurrentTimeIsNotAvailableForAppointments: "指定の時間帯は予約を受け付けておりません。",
TheDriverIsGoingToTheDestination: "ドライバーが目的地へ向かっています",
TheDriverWillContactThePassenger: "ドライバーから乗客に連絡いたします。",
TheEmailNotificationHasBeenTurnedOn: "メール通知機能が有効になりました。メールアドレスを入力してください。",
TheFlightCombinationYouSelectedCannotBeReserved: "選択されたフライトの組み合わせは予約できません。区間ごとに分けて予約してください。",
TheFlightHasInsufficientTickets: "該当便の空席が不足しています。別のフライトを選択してください。",
TheFollowingTimesAreLocalTime: "全ての日程は現地時間です",
TheHotelPicturesAreForReferenceOnly: "*ホテルの写真はイメージです。実際のお部屋の状況を優先します。*",
TheItineraryYouSelectedNotMatchTheApplicationForm: "選択された行程が申請書の内容と一致しません。",
TheLengthOfTheViolationOfTheTravelRankCannotExceedXWords: "規程違反の理由は50文字以内で入力してください。",
TheLoadingFailedTryAgain: "読み込みに失敗しました。再度お試しください。",
TheLowestLogicalFareIsSuggestedAccordingToTheTravelPolicyOfYourCompany: "社内規程に基づき、最安値フライトの予約を推奨します。",
TheLowestPriceForDomesticAirTicketIsNotSelected: "国内線航空券で最安値が選択されていません。理由を選択してください。",
Theme: "特徴",
TheNetworkSignalIsPoor: "通信環境が不安定です。しばらく経ってから再度お試しください。",
TheNewPassword: "新しいパスワード",
TheNewVersionIsOnlinePleaseUpdateToTheLatestVersion: "新バージョンがリリースされました。最新バージョンにアップデートしてください。",
TheNumberOfTheTicket: "発券番号",
TheOrderConfirmedAndProofOfSuccessfulBookingFollowingMethods: "予約が確定しました。以下の方法で予約確認書を取得できます。",
TheOrderIncludesAirfare: "「次へ」をタップすると、以下の内容を確認し、同意したものとみなされます：",
TheOrderIncludesRescheduledPassengers: "この注文には変更手続き済みの乗客が含まれています。",
TheOrderIsForIndividualPaymentOrders: "この注文は個人決済の予約です。変更手続きについては、担当の出張コンサルタントにお問い合わせいただくか、4006-123-123までお電話ください。",
TheOrderIssuedAndProofOfSuccessfulBookingFollowingMethods: "発券が完了しました。以下の方法で航空券確認書を取得できます。",
TheOrderIssuedAndProofOfSuccessfulBookingFollowingMethodsForTrain: "発券が完了しました。以下の方法で鉄道チケット確認書を取得できます。",
ThePeriodOfValidity: "有効期間",
ThePeriodOfValidityTips: "例：2025年6月の場合、「0625」と入力してください",
ThePhoneNumberIsTheSameAsTheCurrentlyBoundMobilePhoneNumber: "この電話番号は現在連携されている番号と同じです。",
TheRailwayBureauStipulatesThatTicketsMustBeSoldByRealName: "鉄道局の規定により、チケット購入には実名登録が必要です。",
ThereAreOtherFlightsAtTheSameTime: "同時帯に別のフライトが予約されています。このまま続行しますか？",
TheReasonForExceedingTheStandardCannotExceedXWords: "規定超過の理由は50文字以内で入力してください。",
TheRefundFeeIsBeingApprovalByTheFlightCompany: "払戻手数料は航空会社にて審査中です",
TheRefundFeeIsSubjectToTheReviewOfTheAirlineCompany: "実際の払戻手数料は航空会社の審査結果に準じます。",
ThereMustBeNoContactWithTheSamePhoneNumber: "連絡先電話番号が重複するメンバーを登録することはできません。",
ThereNoAvailableRoomTypesForBooking: "現在ご予約いただけるお部屋タイプがございません。",
ThereNoAvailableRoomTypesForBookingForChangeFilter: "条件に合うお部屋タイプが見つかりませんでした。条件を変更してお試しください。",
TheRescheduleType: "変更タイプ",
TheReschedulingFeeIsBeingApprovalByTheFlightCompany: "変更手数料は航空会社にて審査中です",
TheReschedulingFeeIsSubjectToTheReviewOfTheAirline: "実際の変更手数料は航空会社の審査結果に準じます。",
TheRoomerIDNumberCannotBeRepeated: "宿泊者の身分証明書番号が重複しています。",
TheRoomIsReservedAllNight: "お部屋は終日キープされますが、14:00前にご到着の場合、ご案内までにお時間をいただく場合があります。",
TheSpecificPriceIsSubjectToTheReview: "*詳細な料金は12306のシステム確定情報に準じます。",
TheSpecificRefundAndChangeRulesShallBeSubjectToTheDateOfTheTicketIssue: "具体的な変更・払戻規定は航空会社の審査結果に準じます。",
TheSubmissionFailedPleaseTryAgainLater: "送信に失敗しました。しばらく経ってから再度お試しください。",
TheSysteIsBusyPleaseReOperate: "システムが混み合っています。もう一度操作を行ってください。",
TheSystemIsBusyPleaseTryAgainLater: "システムが混み合っています。しばらく経ってから再度お試しください。",
TheTakeoffAndLandingLocalTime: "出発・到着時刻はすべて現地時間です。",
TheTicketYouChooseIsVeryCloseToTheDepartureTime: "選択された列車の発車時刻が迫っています。安全検査、実名確認、改札手続きのための十分な時間を確保してください。出発直前のため、発券に失敗するリスクがあります。スケジュールに影響が出ないよう、確定通知を必ずご確認ください。",
TheTicketYouChooseIsVeryCloseToTheDepartureTimeChange: "選択された列車の発車時刻が迫っています。安全検査、実名確認、改札手続きのための十分な時間を確保してください。出発直前のため、変更手続きに失敗するリスクがあります。スケジュールに影響が出ないよう、確定通知を必ずご確認ください。",
TheTotalBudgetAmountHasChanged: "総予算額が変更されました。",
TheValidityPeriodHasExpired: "有効期限切れ",
TheValidityPeriodHasExpiredByReplace: "身分証明書の有効期限が切れています。別の証明書を選択するか、更新してから再度ご予約ください。",
ThinkAgain: "戻る",
ThinkCompleted: "考え完了",
Thinking: "考え中",
ThirdPartyBinding: "サードパーティアカウント連携",
ThirdPartyRelation: "アカウント連携",
ThirdStep: "ステップ3",
ThisInformationIsForReferenceOnlyIfThereIsAnyChangePleaseReferToTheStationAnnouncement: "*この情報はあくまで参考です。変更が生じた場合は駅の案内をご確認ください。",
TicketAmount: "発券金額",
TicketBarrier: "改札口",
TicketBarrierWaitingPlace: "改札口/待合場所",
TicketBookingAuthority: "国内線航空券出張基準",
TicketChangeRefund: "変更・払い戻し状況",
TicketContent: "券面内容",
TicketFare: "運賃",
TicketingMail: "発券完了メール",
TicketingSMS: "発券完了通知SMS",
TicketingSucceed: "発券完了",
TicketNumber: "航空券番号",
TicketPricesHaveChanged: "運賃変動",
TicketRestrictions: "変更・払い戻し規定",
TicketRestrictionsArrow: "変更・払い戻し規定 >",
TicketRestrictionsCancellationBaggage: "変更・払い戻し規定 | 手荷物",
TicketRestrictionsCancellationBaggageArrow: "変更・払い戻し規定 > 手荷物 >",
TicketRestrictionsRule: "変更・払い戻し規則",
Tickets_1: "/枚",
TigerRobot: "Xiaohu Robot",
Time: "交換期間",
Time_1: "時刻",
TimeConsuming: "所要時間",
TimeConsumingLeast: "所要時間（短い順）",
TimeConsumingMost: "所要時間（長い順）",
TimeDeparture: "出発時間",
TimeHighToLow: "時間：遅い順",
TimeLowToHigh: "時間：早い順",
TimeRange: "時間帯",
Tips: "ご注意",
Tips_1: "【ご注意】",
Tips_2: "ご注意",
TipsColon: "ご注意：",
TMS: "Homsom Hotel TMS",
TMSOnline: "Homsom Hotel TMS Online",
ToApply: "申請する",
ToBeConfirmed: "確認待ち",
ToBeIssued: "未請求",
ToBetterYourBusinessTripExperience: "出張中により上質なホテルをご利用いただくために",
ToChoose: "選択する",
Today: "本日",
ToDo: "未対応",
ToEnsureThatThePassengerInformationIsCorrect: "乗客情報の正確性を確保するため、案内に従って確認を行ってください。",
ToEnsureTheSecurityOfTheAccount: "アカウントの安全を守るため、ご本人による操作であることをご確認ください。",
ToGuarantee: "保証手続きへ",
ToGuaranteeAmount: "保証金額",
ToModify: "変更する",
Tomorrow: "明日",
Tomorrow_1: "翌日",
Top5Cities: "上位5都市",
Top5CostCenterExpense: "コストセンター別支出トップ5",
Top5DeptsExpenses: "部門別支出トップ5",
Top5DestinationsbyExpense: "目的地別支出トップ5",
TopFiveModels: "車種別支出トップ5",
ToSetUp: "設定へ",
Total: "合計",
Total_1: "往復合計金額：",
Total_3: "往復合計金額",
TotalAmount: "合計金額",
TotalAmount_1: "総消費額",
TotalAmountOfCarUsed: "車利用合計金額",
TotalAmountOfTrainTicket: "鉄道合計金額",
TotalAmountPendingApproval: "承認待ち合計金額",
TotalBudget: "総予算",
TotalBudgetAmount: "総予算額",
TotalBudgetRMB: "総予算（CNY）",
TotalDuration: "合計所要時間",
TotalMileage: "総走行距離",
TotalMissedSaving: "損失合計",
TotalNumberOfPeople: "総人数",
TotalOrderAmount: "注文総額",
TotalPrice: "合計",
TotalPriceIncludingTax: "税・手数料込み",
TotalPriceIncludingTax_1: "税・手数料込み合計金額",
TotalPriceNoTax: "税抜き価格",
TotalPriceNoTax_1: "往復合計金額（税別）",
TotalPriceNoTax_2: "複数旅行の合計金額（税別）",
TotalPriceTax: "税込価格",
TotalPriceTax_1: "往復合計金額（税込）",
TotalPriceTax_2: "複数旅行の合計金額（税込）",
TotalSaving: "節約額合計",
ToTravel: "出発前",
TouchIDIsNotEnabled: "端末の指紋認証が有効になっていません",
TouchIDIsOnlyValidForTheMachine: "指紋認証は本端末でのみ有効です",
TouchIDLogin: "指紋認証ログイン",
TourismConference: "観光・旅行",
Traffic: "アクセス",
Train: "列車",
TrainAccount: "12306アカウント",
TrainAccountIdVerify: "12306本人確認",
TrainAccountIdVerifySuccess: "本人確認が完了しました",
TrainAccountLogin12306: "12306にログイン",
TrainAccountName: "ユーザー名",
TrainAccountPwd: "パスワード",
TrainAccountPwd12306: "12306アカウント・パスワード",
TrainAccountSubmitCheck: "認証を送信",
TrainApplication: "列車チケット申請",
TrainBookPermission: "鉄道チケット予約権限",
TrainChanged: "列車の運行情報が変更されている可能性があります。再度検索してください。",
TrainDetails: "列車詳細",
TrainNumber: "列車番号",
TrainOrders: "列車予約履歴",
TrainPickupDropoff: "駅送迎",
TrainPreferQuietCoach: "静音車両を希望",
TrainQuietCoachKey: "静音車両",
TrainRank: "列車出張規定",
TrainSeatHoldingDefaultDesc: "12306のログイン状態およびロックされた注文情報を確認しています。結果が反映されるまで1〜3分ほどかかりますので、少々お待ちください。",
TrainSnatchCode: "希望列車",
TrainSnatchDate: "希望日程",
TrainSnatchDeadline: "期限",
TrainSnatchSeats: "希望座席",
TrainStation: "鉄道駅",
TrainTicket: "列車",
TrainTicketChange: "列車予約変更",
TrainTicketConfirmation: "列車予約確認",
TrainTicketFare: "列車運賃",
TrainTicketLatitude: "列車チケットのデータ緯度",
TrainTicketRefund: "列車払い戻し",
TrainTicketsYouSearchedFor: "最近検索した列車",
TrainType: "列車種別",
Transfer: "乗り継ぎ",
TransferToAnotherStation: "発着駅違い乗り継ぎ",
TransportationAccommodation: "交通・宿泊",
TravelApplication: "出張申請",
TravelApplicationCode: "出張申請番号",
TravelBooking: "出張予約",
TravelCard: "マイレージカード",
TravelControl: "出張管理・制限",
TravelDataAnalysis: "出張データ分析",
TravelDate: "出発日",
Traveler: "搭乗者・宿泊者",
Traveler_1: "出張者",
TravelerDetails: "搭乗者詳細",
TravelerName: "氏名",
TravelerNameDesc: "身分証明書と同じ表記で入力してください。",
TravelerType: "旅客タイプ",
TravelPolicy: "出張規定",
TravelPositioning: "出張規定グループ",
TravelPurpose: "出張目的",
TravelReminder: "出張のご案内",
TravelReminderColon: "出張のご案内：",
TravelReport: "出張レポート",
TravelSecurity: "旅行保険・補償",
TravelStandard: "出張規定",
TravelStandard_1: "マイ出張規定",
TravelTime: "出発時間",
TravelType: "出張種別",
Trip: "旅程",
TripAssistantDesc: "出張アシスタントは申請書に基づいて行程を作成できます",
TripIncludeLegalHoliday: "行程に法定祝日が含まれています。",
TripType: "行程タイプ",
TryAgain: "再試行",
TryAgain_1: "再試行",
TryAIFillApplication: "AIに出張申請を記入してもらう",
TWD: "TWD",
TwinBed: "ツイン",
Type: "タイプ",
Type_1: "理由タイプ",
TypeOfQuestionRequired: "お問い合わせの種類（必須）",
TypeOfTrip: "出張の種類",
UnableToBookTheCurrentAgreementPriceProduct: "申し訳ございません。搭乗者が航空会社のホワイトリストに含まれていないため、現在の契約運賃商品をご予約いただけません。",
UnableToLocateCurrentCity: "現在地を取得できません",
UnbindSuccessfully: "解除しました",
UnbindTitle: "連携解除",
Unbound: "未連携",
UnboundApprover: "承認者が設定されていません",
UnboundCustomization: "カスタム項目が設定されていません",
UnboundEmployees: "未連携従業員",
UnboundTemplate: "テンプレート未設定",
UnderOneYearOld: "1歳未満",
UnderTheCurrentCostCenterNoCostCenter: "現在のコストセンター配下にサブコストセンターはありません。",
Uneditable: "編集不可",
Unfilled: "未入力",
Unfinished: "未終了",
Unfold: "展開",
UnhookYourFingersAndCancelSend: "指を離して送信をキャンセル",
UnissuedTicketAmount: "未発券金額",
Unit: "企業・団体",
UnitAbbreviation: "会社略称",
UnitAccount: "企業アカウント",
UnitEntry: "企業ポータル",
UnitLogo: "会社ロゴ",
UnitManagement: "企業管理",
UnitName: "会社名",
UnitNumber: "会社ID",
UnitNumberOrUnitName: "会社IDまたは会社略称",
Unknown: "不明",
Unmodifiable: "変更不可",
Unselected: "未選択",
UnStaffAdd: "外部担当者の追加",
Unsubmitted: "未提出",
Untie: "連携解除",
Update: "今すぐ更新",
Update_1: "更新する",
UpdateSearchWhenPullingMap: "地図を移動して再検索",
Upgrading: "更新中...",
UploadCertificate: "証明書類をアップロード",
UploadedCertificate: "証明書アップロード済み",
UploadFile: "ファイルをアップロード",
UrbanCivision: "都市区分",
USD: "米ドル",
UseCarCity: "利用都市",
UseCarDate: "利用日",
UsedForCheckingInAtTheHotelFrontDeskOrForProcessingDestinationVisas: "ホテルのチェックインやビザ申請の際に必要となります。",
UseLxd: "利用",
UserCanceled: "ユーザーキャンセル",
UserName: "ユーザー名",
UserNameEmailMobile: "12306ユーザー名/メール/携帯番号",
UseRules: "利用規約",
UseTheCarImmediately: "今すぐ呼ぶ",
UseTravelCardTipsEnsureIdentityMatch: "・フリークエントトラベラーカードに登録されている身分証明書が、搭乗時に使用する身分証明書と一致していることをご確認ください。",
UseTravelCardTipsMilesDecidedByAirline: "・実際のマイレージおよびポイントの積算は、航空会社の規定に準じます。",
UseTravelCardTipsNoAutoMilesAccumulation: "このフライトはマイレージ積算の対象外です。",
UseTravelCardTipsPartialFlightsNotSupport: "・この旅程の一部のフライトでは、マイレージの積算ができません。",
UsingTheAppFaceRecognitionIsMoreAccurateAndFaster: "アプリのご利用で、顔認証がよりスピーディーかつ正確になります",
UsingTheLastestVersion: "最新バージョンを使用中です。",
ValidPeriod: "有効期限",
VehicleDisinfection: "車両消毒済",
VehicleTrack: "走行ルート",
VerificationCode: "認証コード",
VerificationCodeAgain: "認証コードを再送",
VerificationCodeAgain_1: "再取得",
VerificationCodeCheck: "SMS認証コードを入力してください",
VerificationCodeCheckFail: "認証コードが正しくありません",
VerificationCodeCoped: "認証コードをコピーしました",
VerificationCodeCopiedSuccessful: "コピーしました",
VerificationCodeFailedToSend: "認証コードの送信に失敗しました",
VerificationCodeGet: "コードを取得",
VerificationCodeHasBeenSent: "認証コードを送信しました",
VerificationFail: "認証失敗",
VerificationInProgress: "認証中",
VerificationPass: "認証済み",
VerificationPassLoginSuccess: "認証が完了しました。ログインしています...",
VerificationSucceeded: "認証に成功しました",
VerificationSuccessful: "認証成功",
VerifiedPhoneNumber: "認証済み携帯番号",
VerifyUsingMail: "メールで認証",
VerifyUsingPhoneNumber: "携帯番号で認証",
VerifyVehicleBeforeBoarding: "ご乗車前に車両情報をご確認ください。",
VersionNumber: "バージョン",
VersionUpdate: "バージョン更新",
ViewAllStaff: "全従業員の閲覧",
ViewBookPermissions: "閲覧・予約権限",
ViewComments: "コメントを見る",
ViewComments_1: "クチコミを見る",
ViewConfirmNumber: "確認書を表示",
ViewDesignatedDepart: "指定部門を閲覧可能",
ViewDesignatedStaff: "指定従業員を閲覧可能",
ViewDetailedProcedure: "詳細プロセスを表示",
ViewDirectTicket: "直行便チケットを表示",
ViewElectronicPolicy: "保険証券を表示",
ViewHelpDocs: "ヘルプドキュメント",
ViewHistoricalApplys: "過去の申請",
ViewHistoricalOrders: "過去の注文履歴",
ViewHistoryChat: "チャット履歴",
ViewItineraryTrack: "旅行履歴",
ViewMoreCountriesOrRegions: "その他の国・地域を表示",
ViewMoreFlights: "航空券を更に表示",
ViewMoreHotel: "ホテルをもっと見る",
ViewMoreTrains: "その他の列車を見る",
ViewMoreTransferSchemes: "乗り継ぎオプションを表示",
ViewOnlySelf: "所有者のみ閲覧可",
ViewOrder: "詳細を見る",
ViewPermissions: "権限を表示",
ViewReimbursementVoucher: "経費精算書類を表示",
ViewReservation: "予約内容を表示",
ViewRoomType: "客室タイプを表示",
ViewSample: "サンプルを表示",
ViewTheBigMap: "画像を拡大",
ViewTheLowestPrice: "最安値のフライト",
ViewTravelApplicationForm: "出張申请書を表示",
ViolationOfBusTravelRank: "バスポリシー違反の理由",
ViolationOfCarTravelRank: "車両ポリシー違反の理由",
ViolationOfHomsomTravelStandardsNotSelectable: "規定違反のため選択不可",
ViolationOfHomsomTravelStandardsSelectedReason: "規定違反 — 理由を選択してください：",
ViolationOfHotelTravelRank: "ホテルポリシー違反の理由",
ViolationOfMealsTravelRank: "食事ポリシ一違反の理由",
ViolationOfRank: "規定外",
ViolationOfRankDetail: "規定外の詳細",
ViolationOfTrainTravelRank: "鉄道ポリシー違反の理由",
ViolationOfTravelRank: "出張規定違反",
VirtualNumberProtection: "携帯電話番号の漏洩を防ぐための仮想番号保護",
Visa: "ビザ",
VisaCountryOrRegion: "ビザ対象国・地域",
VisaDetails: "ビザの詳細",
VisaIssuanceEmail: "ビザ発給メール",
VisaIssuanceShortMessage: "ビザ発給通知SMS",
VisaOrder: "ビザ注文一覧",
VisaSubmissionEmail: "ビザ申請メール",
VisaSubmissionShortMessage: "ビザ申請通知SMS",
VisaType: "ビザの種類",
VoiceTooShort: "録音時間が短すぎます",
VoidApplicationForm: "無効化申請書",
VoidedFailed: "無効化に失敗しました",
VoidedSuccessfully: "無効化に成功しました",
VoluntaryRefund: "自己都合による払い戻し",
VoluntaryRefundDesc: "お客様都合による払い戻し（航空会社の退改規定に基づきの手数料が適用されます）",
VoluntaryRefundExplain: "自己都合による払い戻しの説明",
VoluntaryReschedule: "自己都合による変更",
VoluntaryRescheduleDesc: "お客様都合による変更（航空会社の退改規定に基づきの手数料が適用されます）",
VoluntaryRescheduleExplain: "自己都合による変更の説明",
Voucher: "クーポン",
WaitingForConfirmation: "確認待ち",
WarmTipsWhitelistedEmployees: "注：ホワイトリスト内の従業員は承認不要です。",
WarmTipTheModificationIsNotSupportedForTheTimeBeing: "注：現在変更はサポートされていません。変更が必要な場合は、専任コンサルタントまでご連絡ください。",
Wechat: "WeChat",
WeChat_Limit_1: "ミニプログラムの制限により、Homsomアプリまたはウェブサイトで操作を行ってください。",
WechatByAccount: "WeChat Workアカウント",
WechatByUser: "WeChat Work 従業員連携",
WechatIsNotInstalled: "WeChatがインストールされていません",
WechatNotSupportDDPleaseUseAppOrH5: "WeChatミニプログラムではDidi配車サービスをサポートしていません。アプリまたはH5からご予約ください。",
WechatNotSupportOnlineCheckInPleaseOpenOnPcOrApp: "WeChatミニプログラムではオンラインチェックインをサポートしていません。PC、アプリ、またはH5をご利用ください。",
WechatPay: "WeChat Pay",
WeekFri_1: "金",
WeekMon_1: "月",
WeekSat_1: "土",
WeekSun_1: "日",
WeekThur_1: "木",
WeekTues_1: "火",
WeekWed_1: "水",
Welcome: "こんにちは、ようこそ！",
WelcomeBackChat: "おかえりなさい。新しいトピックについてご説明いたします。",
WelcomeToDidi: "DiDiへようこそ",
WelcomeToHOMSOM: "Homsomへようこそ",
WelcomeToHumanCustomerService: "ライブチャットへようこそ",
WelcomeToLogin: "ようこそ",
WelcomeToLoginHomsom: "Homsomへようこそ",
WelcomeToUseIt: "ようこそ",
WhatIsEnterpriseCode: "企業コードとは？",
WhereWouldYouLikeToGo: "目的地を入力してください",
WhetherToAcceptTheSeatlessTicket: "選択した座席が満席の場合、立ち席/座席なしチケットを受け入れますか？",
WhetherToConfirmTheDeletionOfThisFavoriteContact: "この登録済みの連絡先を削除してもよろしいですか？",
WhetherToConfirmThePasswordChange: "パスワードを変更してもよろしいですか？",
WhetherToConfirmTheRefund: "払い戻しを希望しますか？",
WhetherToSendARefundEmail: "払い戻しメールを送信しますか？",
WhetherToSendARefundEmail_1: "払い戻しメールを送信",
WhetherToSendARefundSuccessfulMail: "払い戻し完了メールを送信しますか？",
WhetherToSendARefundSuccessfulMail_1: "払い戻し完了メールを送信",
WhetherToSendARefundSuccessfulSMS: "払い戻し完了SMSを送信しますか？",
WhetherToSendARefundSuccessfulSMS_1: "払い戻し完了SMSを送信",
WhyOpenEnterpriseCode: "企業コードを開通するメリット",
WhyOpenEnterpriseCodeDescription: "企業コードを開通すると、鉄道きっぷの予約時に「因公付（Homsom）」をご利用いただけます。代金はHomsomの企業Alipay口座から直接決済されるため、従業員による立て替えの必要がありません。",
Window_1: "窓側",
WindowType: "窓",
Withdrawal: "出金・払戻",
WriteReasonCode: "理由コードを入力",
YearOnYear: "前年同期比",
Yesterday: "前日",
Yesterday_1: "昨日",
YouAlsoHaveUnselectedPassengers: "座席未指定の乗客がいます。すべての座席を選択してから注文を送信してください。",
YouAreUsingAggregationPlatform: "アグリゲーションプラットフォームを利用中",
YouAreUsingDiDiPlatform: "DiDiプラットフォームを利用中",
YouCanDoTheFollowing: "利用可能な操作",
YouCannotSelectContactsWithTheSamePhoneNumberAtTheSameTime: "同じ電話番号の連絡先を同時に複数選択することはできません。",
YouCanOnlyGetSMSVerificationCodesFor3MobilePhoneChecksPerDay: "*携帯電話番号確認のSMS認証コードは1日3回まで取得可能です。",
YouCanOpenItInMySettingSecurityManager: "「アカウント」＞「設定」＞「セキュリティ管理」で有効にできます。",
YouCanUseFaceIDVerification: "有効にすると、Face IDを使用して素早くログインできます。",
YouCanUseTouchIDVerification: "有効にすると、指紋認証（Touch ID）を使用して素早くログインできます。",
YouHaveACarOrderInProgress: "進行中の配車注文があります。",
YouHaveToDoFaceRecognitionAlone: "顔認証は必ずお一人で行ってください。",
YouHaveUnselectedPassengersPleaseSubmitAfterSeatSelection: "座席未指定の乗客がいます。すべての座席を選択してから送信してください。",
YouNeedToPayViaAlipay: "Alipayでお支払いを完了してください",
YouNotCompletedTheTrainTicketIdentityVerification: "鉄道チケットの本人確認が完了していません。今すぐ確認しますか？",
YourApplyHasNotBeenFilledOut: "出張申請が完了していません。このページを離れてもよろしいですか？",
YourCompanyAllowsYouToPayTheExtraAmountForAnOutPolicyHotelByCreditCardWeChatOrAlipay: "規定超過分は個人負担となり、WeChat PayまたはAlipayで支払うことができます。",
YourCurrentLoginAccountNeedsMobilePhoneNumberVerification: "現在ログインしているアカウントは携帯電話番号による本人確認が必要です。",
YourDateOfBirthGenderNationalityAndIDCardDoNotMatch: "生年月日、性別、国籍が身分証明書と一致しないため、修正されました。",
YourDateOfBirthGenderNationalityAndIDCardDoNotMatch_1: "生年月日、性別、国籍が身分証明書と一致しないため",
YourExclusiveTravelConsultant: "専属差旅アドバイザー",
YourHotelGroupMembershipCard: "ホテルグループ会員カード",
YourOrderHasNotBeenCompletedOut: "注文が完了していません。このページを離れてもよろしいですか？",
YourOrderHasNotBeenFilledOut: "注文が完了していません。このページを離れてもよろしいですか？",
YourPhoneNumberHasNotBeenRegisteredYet: "この携帯電話番号は登録されていません。",
YourStayIsTooLongTheFlightAndPriceInformationMayChangeAndTheLatestPrice: "セッションの有効期限が切れました。空席状況や料金が変更された可能性があるため、最新の情報を再検索しています...",
YourTravelCard: "マイレージカード",
YouWill: "出発地：",
YouWillFrom: "出発地：",
About: "≈",
And: "と",
Avg: "平均",
B: "公",
BackTag: "復路",
Below: "次へ",
Book: "予約",
By: "経由",
Change_1: "変更",
CN: "中",
Copy: "部",
Cross: "経由",
D: "始発",
E: "終点",
EN: "英",
Female: "女性",
First: "第",
Floor: "階",
From: "から",
GoTag: "往路",
Home_1: "自宅",
In: "イン",
Male: "男性",
Month: "月",
NoHistoryChat: "チャット履歴がありません。質問してみましょう。",
None: "なし",
Original: "元",
Out: "アウト",
P: "私",
Page: "ページ",
QuantifierHotel: "室",
QuantifierNight: "泊",
QuantifierPeople: "人",
R: "払戻",
Rest: "休憩",
RMB: "元",
Save_1: "節約",
ScoreByComments: "点",
Snatch: "獲得",
Stop_1: "経由",
Tax: "税",
Tickets: "枚",
To: "〜",
TrainAvailable: "空席あり",
TrainQuietCoach: "静",
Transfer_1: "乗換",
Unit_1: "個",
Upper: "上段",
WeekFri: "金",
WeekMon: "月",
WeekSat: "土",
WeekSun: "日",
WeekThur: "木",
WeekTues: "火",
WeekWed: "水",
Window: "窓",
Work: "出勤",
Year: "年",
You: "本人",
AccountProtocol_2_x: "ご提供いただいた氏名、携帯電話番号、身分証明書番号は、12306アカウントのパスワード再設定および本人確認に利用されます。詳細は%a$をご確認ください。",
AccountProtocol_3_x_x: "「鉄道旅客チケット実名制管理办法」に基づき、列車チケットおよび関連サービスのご利用には、有効かつ正確な身分証明書情報の提供が必要です。この情報はチケット購入、乗車、変更／払い戻し、領収書発行等に利用されます。サービスに影響が出ないよう正確な情報をご入力ください。当社は暗号化により個人情報を保護し、取引処理に必要な第三者にのみ提供します。詳細は%a$%b$をご確認ください。",
ActualTotalPrice_x: "実費：%a$",
AddDay_x: "+%a$日",
Adults_1_x: "大人 %a$名",
Adults_Children_x_x: "大人 %a$名 子供 %b$名",
Adults_x: "大人 %a$名",
Age_x: "%a$歳",
AIAssistantIntro_x: "私は%a$のAI旅行アシスタントです。",
AirportDropOff_x: "%a$ 空港送り",
AirportPickup_x: "%a$ 空港迎え",
AllTime_x: "所要時間：約 %a$",
AllTime_x_x: "%a$、所要時間約 %b$",
ApplicationContent_x: "申請内容：%a$",
Approval_x: "%a$ 承認",
ApprovalTimeoutNoticeTime: "承認タイムアウト通知時間：%a$分",
AreYouSureToDelete_x: "%a$を削除しますか？",
AreYouSureToRemove_x: "この%a$を削除しますか？",
AreYouSureYouWantToGiveUpTheInformationChange_x: "%a$の情報が変更されています。変更を破棄しますか？",
AToB_x_x: "%a$ から %b$",
AttachFileUpload_x: "あと%a$個アップロード可能",
Available_x: "%a$ 利用可能",
Baby_1_x: "幼児 %a$名",
Baby_x: "幼児 %a$名",
BackWeek_x: "%a$に戻る",
BaggageAllowance_x: "手荷物規定：%a$",
BasicInformationIsIncompletePleaseEdit_x: "%a$の基本情報が不完全です。編集してください",
BecomeDue_x: "%a$に有効期限切れ",
BedWide_x_x: "幅：%a$ x %b$",
BindMembershioFor_X: "%a$会員カードを連携",
BindPerson_x: "%a$名連携済み",
BookDesignated_x: "指定の%a$向けに予約",
BookPwdRemainingAttempts_x: "残り入力回数：%a$回。予約パスワードを忘れた場合はパスワード再取得を行ってください。",
Budget_1_x: "%a$予算",
Budget_x: "%a$予算",
Business_x: "%a$ (出張)",
CanAccommodateUpToXPeople_x: "1室あたり最大%a$名まで宿泊可能",
CanOnlySelectUpToXGuest_x: "1室あたり最大%a$名まで選択可能です",
CanOnlySelectUpToXpassengers_x_x: "最大%a$個の%b$まで選択可能です",
CanPeopleStaying_x: "定員%a$名",
CarUseEndDate_x: "配車利用終了日は%a$まで延長可能です",
CarUseStartDate_x: "配車利用開始日は%a$まで前倒し可能です",
ChangeStationWarn_1_x_x: "出発駅が%a$から%b$に変更されました。続行しますか？",
ChangeStationWarn_2_x_x: "到着駅が%a$から%b$に変更されました。続行しますか？",
ChangeStationWarn_x_x_x_x: "出発駅が%a$から%b$へ、到着駅が%c$から%d$へ変更されました。続行しますか？",
ChangeTheNumberOfPeople_x: "搭乗者が%a$に変更されました。必要に応じて手動で変更してください。",
ChangeTheNumberOfRoomsAndPeople_x_x: "宿泊人数が%a$室%b$名に変更されました。必要に応じて手動で変更してください。",
ChangeTo_x: "%a$に変更",
ChargebackNumber_x: "払戻番号 %a$",
CheckIn_x: "チェックイン：%a$",
CheckInCheckOut_x_x_x: "チェックイン：%a$、チェックアウト：%b$、%c$泊",
CheckInDate_x: "チェックイン日は%a$まで前倒し可能です",
CheckInToCheckoutNight_x_x_x: "%a$ 〜 %b$（%c$泊）",
CheckInToCheckoutNight_x_x_x_x_x: "チェックイン：%a$ %b$、チェックアウト：%c$ %d$、%e$泊",
CheckInToCheckoutNightAndRoom_x_x_x_x: "%a$～%b$ · %c$泊 %d$室",
CheckInToCheckoutNightAndRoomAndRoom_x_x_x_x_x: "%a$～%b$ · %c$泊 %d$室 · %e$",
CheckOut_x: "%a$ チェックアウト",
CheckOutDate_x: "チェックアウト日は%a$まで延長可能です",
Children_1_x: "子供%a$名",
Children_x: "子供 %a$",
ChName_x: "中国語名：%a$",
ChNameToPinyin_x: "「%a$」をピンインに変換",
Choose_x: "%a$を選択してください",
ChooseAtLeastXPeople_x: "宿泊者を少なくとも%a$名選択してください。",
ChooseAtMostContact_x: "連絡先は最大%a$名まで選択できます。",
ChooseUpToXPeople_x: "宿泊客は最大%a$名まで選択できます。",
CNYStart_x: "%a$～",
CompanyAndPersonalPayment_1_x_x: "会社支給：%a$、個人負担：%b$",
CompanyAndPersonalPayment_x_x: "会社：%a$ 個人：%b$",
ConfirmFollow_x: "フォロー確認（%a$人）",
ConfirmImportTraveler_x: "インポートの確認（%a$人）",
ConfirmSelectedTraveler_x: "選択の確認（%a$人）",
ContactEmailFormatIsIncorrect_x: "連絡先%a$のメールアドレスの形式が正しくありません。",
ContactInformationOfExclusiveConsultant_x: "専任アドバイザー%a$の連絡先",
ContactMobileFormatIsIncorrect_x: "連絡先%a$の携帯電話番号の形式が正しくありません。",
Contacts_x: "連絡先：%a$",
ContactTheEmailNotificationHasBeenTurnedOn_x: "連絡先%a$のメール通知機能が有効になっています。メールアドレスを入力してください。",
ContactTravelAdvisorOrCall_x: "ご予約は専任の差旅アドバイザーまでご連絡いただくか、%a$までお電話ください。",
ConvertToPinyin_x: "「%a$」をピンインに変換",
CountFormat_x: "%a$個",
CurrencyExplain_x: "通貨：%a$ 大人1名あたりの料金",
CurrentBoundAccountPrefix_x: "現在連携中のアカウント：%a$",
CurrentOrderGeneratedOrder_x: "今回の注文で%a$件のオーダーが作成されました。",
CurrentOrderGeneratedOrderYouNeedToPayInTurn_x: "今回の注文で%a$件のオーダーが作成されました。順にお支払いを行ってください。",
CurrentPhoneNumberTip_x: "現在の携帯電話番号は%a$です。新しい携帯電話番号を入力し、認証を行ってください。",
Departure_x: "%a$ 出発",
DepartureCityAndArrivalCityCannotBeSame_x: "第%a$区間の出発都市と到着都市を同じにすることはできません。",
DepEndDate_x: "出発終了日は%a$まで延長可能です",
DepStartDate_x: "出発開始日は%a$まで前倒し可能です",
DesignatedDepartment_x: "指定された%a$",
DistanceCenter_x_x: "市街地中心%a$から%b$",
DistanceFromYou_x: "現在地から%a$",
DistanceToDestination_x: "目的地から%a$",
Download_x: "%a$をダウンロード",
Downloading_x: "ダウンロード中... %a$%",
EachRoomNeedsToFillIn_x: "各部屋に%a$名入力してください",
EconomyClassDiscountBelow_x: "エコノミークラス（%a$折以下）",
Edit_x: "%a$を編集",
ElectronicInvoiceReissueLimit_x: "電子領収書の再発行は%a$回までです。情報に誤りがないかご確認ください。",
EmailFormatIsIncorrect_x: "%a$のメールアドレスの形式が正しくありません。",
EstimatedWaitingTime_x: "待ち時間の目安：%a$分",
ExclusiveConsultant_x: "専任アドバイザー：%a$",
ExistingStaff_x: "登録済みの社員（%a$）",
FileSizeLimit_x: "%a$MB以下のファイルのみ対応しています。",
FldReward_x: "%a$ 代金豆",
Flight_x: "%a$ フライト",
FlightNo_x: "便名 %a$",
Floor_x: "%a$階",
FlyingTime_x: "フライト時間 %a$",
GoingAndReturnTicket_x_x: "%a$（往路）、%b$（復路）",
GoingTicket_x: "%a$（往路）",
GoTo_x: "%a$へ",
GoToMixedPay_x: "規定超過分個人支払い %a$",
GoToPay_1_x: "支払い %a$",
GoToPay_x: "支払いへ進む %a$",
GoToTheStoreBeforeOClock_x: "%a$までに来店",
GuestRoom_x: "客室 %a$",
Hotel_x: "%a$ ホテル",
HotelChargeByPersonCountTip_x: "%a$は宿泊人数に応じて料金が異なります。大人と子供の正確な人数を入力してください。",
HotelCheckInPost_x: "%a$以降チェックイン",
HotelCheckOutBefore_x: "%a$までにチェックアウト",
HotelFillRoomGuestOptional_1_x: "ルーム%a$宿泊者を入力",
HotelFillRoomGuestOptional_x: "ルーム%a$宿泊者を入力（任意）",
HotelRefundRoomNight_x_x: "%a$室・%b$泊返金",
IHaveReadAndAgree_x: "%a$に同意します",
Index_x: "%a$行程",
Intergral_x: "%a$ ポイント",
IntergralDeliveryNumber_x: "追跡番号：%a$",
Interval_x: "間隔 %a$",
Inventory_x: "在庫：%a$",
InvoiceDetailsCount_x: "請求書合計：%a$枚",
IsNotAArrivalCity_x: "%a$は到着都市として選択できません",
IsNotADepartureCity_x: "%a$は出発都市として選択できません",
ItineraryInfo_x: "行程情報 %a$",
ItIsNowPastZeroOclock_x: "深夜0時を過ぎました。午前%a$時前にチェックインされる場合は、「本日早朝」チェックインを選択してください。",
JudgeCertificateExpired_x: "%a$ 身分証明書の有効期限が出発日まで6ヶ月未満のため、搭乗できない可能性があります。続行しますか？",
KeySelectedCarTypes_x: "%a$個の車種を選択済",
LengthMustNotExceedXDigits_x_x: "%a$の長さは%b$桁を超えてはなりません",
LevelXAapproval_x: "%a$次承認",
LimitedToXReservation_x: "%a$の予約限定",
LocalTimeOfTheDepartureCity_x: "便名 %a$、出発地の現地時間を選択してください",
Login12306AccountInPerson_x: "ご本人確認を行っているかご確認ください：%a$",
LowestPriceHoursAndTicket_x_x: "前後%a$時間の最安値 %b$/枚",
LxdReward_x: "%a$ Travel Beans",
LxdToCompleteTheOrder_x: "注文完了後に%a$ Travel Beansを獲得できます",
Manage_x: "%a$管理",
MaxOnlyUseFld_x: "代金豆は最大%a$個まで利用可能です",
MaxSelectableOrders_x: "一度に最大%a$枚まで選択可能",
MaxUseFld_x: "最大%a$個の代金豆が利用可能",
MergeIssueReimbursableAmountInfo_x_x_x: "正文 %a$ 枚、変更/払戻件数 %b$ 枚を含みます。一括発行による精算可能額は %c$ です",
Minute_x: "%a$分",
MixedPaymentContent_x_x_x: "予約の総額は%a$です。差旅標準の上限%b$を%c$超えています。超過分を自己負担するか、全額会社支払いを申請するか選択できます。",
MixedPaymentDetails_x_x: "会社が%a$を支払い、差旅標準を超えた分%b$は個人支払いとなります",
MonthsCount: "%a$ヶ月",
MoreAvailable_x: "満%a$元で利用可能",
Name_x: "%a$ 氏名",
NearlyMonthApply_x: "直近%a$ヶ月の申請",
NearlyMonthOrder_x: "直近%a$ヶ月の注文",
New_x: "%a$を追加",
NightsTotalPrice_x: "%a$泊合計料金",
NoMoreApply_x_x: "%a$から%b$までの申请を表示中",
NoMoreOrder_x_x: "%a$から%b$までの注文を表示中",
NoXSegment_1_x: "第%a$区間を選択",
NoXSegment_2_x: "第%a$区間として選択済",
NoXSegment_x: "第%a$区間",
OnlyAlternativeTrainsCanBeSelectedAtMost_x: "代替列車は最大%a$件まで選択できます。",
OnlyChineseName_x: "%a$は中国語名のみ入力可能です",
OnlyEnglishName_x: "%a$は英語名のみ入力可能です",
OnlySupportsDataWithStatisticalDateSpanOfLessThanYears_x: "検索期間が%a$年以内のデータのみ対応しています。",
OpenedInYear_x: "%a$年開業",
OrderAndAmountSummary_x_x: "計%a$件の注文、請求書発行可能額：%b$",
OrderDetailTotalCount_x: "注文詳細：計%a$枚",
OrderNumber_x: "注文番号 %a$",
OrdersNotSupportOnlineIssuing_x: "現在、%a$件の注文がオンライン請求書発行に対応していません。",
Other_x: "その他：%a$",
PayAtTheStore_x: "現地払い %a$",
PayAtTheStoreAbout_x: "現地払い 約%a$",
PayAtTheStoreTaxesFees_x: "現地払い別途税金・手数料 約%a$",
Pending_x: "承認待ち (%a$)",
People_x: "%a$人",
PeopleStaying_x: "%a$人宿泊",
Personal_x: "%a$(個人)",
PhoneNumberFormatIsIncorrect_x: "%a$の電話番号形式が正しくありません",
Plan_x: "当初の予定 %a$",
PleaseChooseOrInput_x: "%a$を選択または入力してください",
PleaseChooseRouteArrivalCity_x: "第%a$区間の到着都市を選択してください",
PleaseChooseRouteDepartCity_x: "第%a$区間の出発都市を選択してください",
PleaseChooseRouteGoDate_x: "第%a$区間の出発日を選択してください",
PleaseCompleteTheInformation_x: "%a$の情報を入力してください",
PleaseCompleteTheVerificationWithinMinutes_x: "%a$分以内に認証を完了してください。",
PleaseEnter_x: "%a$を入力してください",
PleaseEnterIDNumber_x: "%a$の身分証明書番号を入力してください",
PleaseEnterPhoneNumber_x: "%a$の携帯電話番号を入力してください",
PleaseEnterThe_x: "検索する%a$を入力してください",
PleaseFill_x: "%a$を入力してください",
PleaseFill_x_x: "%a$の%b$を入力してください",
PleaseFillBudget_x: "%a$の予算を入力してください",
PleaseFillIn_x: "%a$名を入力してください",
PleaseFillInEmail_x: "%a$のメールアドレスを入力してください",
PleaseFillInMobile_x: "%a$の携帯電話番号を入力してください",
PleaseFillInTheContactMobilePhoneNumber_x: "連絡先担当者%a$の携帯電話番号を入力してください",
PleaseFillOrChoose_x: "%a$を入力または選択してください",
PleaseReadAndAgreeTo_x: "事前に%a$をお読みいただき、同意してください",
PleaseReselect_x: "%a$を再度選択してください",
PleaseSelect_x: "%a$を選択してください",
PleaseSelect_x_x: "%a$の%b$を選択してください",
PleaseSelectFlightChangeDate_x: "%a$便の変更日を選択してください",
PleaseSelectThePassengerWhoNeedsToRefund_x: "払い戻しを行う%a$を選択してください",
PleaseUploadAttachFile_x: "%a$をアップロードしてください",
PleaseWaitAtLocation_x: "事前に%a$へお越しの上、バスをお待ちください",
PriceOfPerson_x_x: "%a$ x %b$人",
PricePerPerson_x: "%a$/人",
Punctuality_x: "定時運行率%a$",
PurchaseXItemAtMost_x: "お一人様%a$点まで",
QueryDateRange_x_x: "検索期間：%a$ 〜 %b$",
Ready_x: "予定 %a$",
ReasonsForBusiness_x: "出張目的：%a$",
RefundOrderInvoiceAmount_x_x: "计%a$件の払戻、請求書発行可能額：%b$",
RefundOrderNumber_1_x: "払戻番号 %a$",
RefundOrderNumber_x: "払戻番号 %a$",
ReimbursementVoucher_x: "%a$ 領収書等添付伝票",
Remaining_1_x: "残り %a$ 件",
Remaining_x: "残り %a$ 枚",
RemainingCount_x: "残り %a$ 個",
RemainingRoom_x: "残り %a$ 室",
RemainingUseLxd_x: "%a$ 個（1 Travel Bean = 1 RMB）",
RemainRoom_x: "残り %a$ 室",
RemoveThe_x: "この%a$を削除",
RenovatedInYear_x: "%a$年改装",
RequiredChoose_x: "%a$名を選択してください",
RequiredFill_x: "%a$ 必須",
Resend_x: "再送信 (%a$秒)",
ResendAfterXSeconds_x: "%a$秒後に再送信",
ResendPleaseWait_x: "再送信中、しばらくお待ちください %a$",
ReturnEndDate_x: "復路到着予定日は%a$まで延長可能",
ReturnStartDate_x: "復路出発予定日は%a$まで前倒し可能",
ReturnTicket_x: "%a$ (復路)",
RMB_x: "%a$ 元",
RMBPrice_x_x: "¥%a$-%b$",
RMBPriceOver_x: "¥%a$ 以上",
RMBPriceUnder_x: "¥%a$ 以下",
Room_x: "%a$室",
RoomAdult_x_x: "%a$ 室, 大人 %b$ 名",
RoomAdult_x_x_x: "%a$ 室, 大人 %b$ 名, 子供 %c$ 名",
RoomAndNight_x_x: "%a$ 室, %b$ 泊",
RoomGuest_x: "ルーム%a$宿泊者",
RoomNight_x_x: "%a$ 室 %b$ 泊",
RoomNightPrice_x_x: "%a$ 室 · %b$ 泊",
RoomNoXAtLeastChooseOneRoomer_x: "部屋%a$: 宿泊者を少なくとも1名選択してください。",
RouteDepartDateCannotBeLessThanLastRoute_x_x: "第%a$区間の出発時間は第%b$区間の出発时间より前に設定することはできません。",
SchemIndex_x: "プラン %a$",
SchemIndexSelect_x: "プラン %a$（選択中）",
Search_1_x: "%a$ を検索",
SecondAfter_x: "%a$秒後",
SeeAll_x: "すべての価格（%a$件）を表示",
Segment_x: "第 %a$ 区間",
Select_1_x: "選択済み: %a$",
Select_x: "%a$ を選択",
Selected_Train_codes_x: "選択済みの候補列車: %a$件",
Selected_x_x: "選択済み: %a$ 個の %b$",
SelectedOrderCount_x: "選択済みの注文: %a$件",
SelectedRoomTip_x: "ルーム%a$を選択済み",
SelectedTraveler_x: "選択済み: %a$名",
SendSMS_x: "%a$宛てに認証SMSを送信しました。認証コードを入力してください。",
SendTo12306_x: "12306に「%a$」を送信",
SendVerificationCodeTo12306ByMobilePhoneUpToTimesPerDay_x_x: "携帯電話番号%a$から12306宛てに認証コード「%b$」を送信してください（1日最大3回まで）。",
ServiceFeePerPerson_x: "サービス料: %a$/名",
ShareDescPaymentOnBehalf_x: "恒順商旅で%a$を予約しました。代理支払いをお願いします。",
ShareTitlePaymentOnBehalf_x: "%a$から代理支払いの依頼が届いています",
SnatchDeadline_x: "発車 %a$ 前",
SnatchDeadlineHour_x: "発車 %a$ 時間前",
SnatchDeadlineMinute_x: "発車 %a$ 分前",
SorryCouldNotFindIt_x: "「%a$」に関するコンテンツが見つかりませんでした。",
SorryThereAreNoSearchResultsFor_x: "「%a$」の検索結果はありません。",
StationDropOff_x: "%a$ 送客",
StationPickup_x: "%a$ 送迎",
StatisticsBy_x: "%a$別",
Stay_1_x_x: "%a$で %b$ 滞在",
Stay_2_x_x: "乗り継ぎ %a$ 滞在 %b$",
Stay_3_x_x: "経停%a$ 滞在%b$",
Stay_x: "%a$ 滞在",
Stop_1_x: "経由 %a$",
Stop_2_x: "経由地 %a$ ヶ所",
Stop_x: "経由 %a$",
Superior_x: "上長：%a$",
TakesOff_x: "%a$ 出発",
TakesOffArrival_x_x: "%a$ 到着、%b$ 出発",
TaxPrice_x: "税：%a$",
TemplateCustomItemApproval_x: "承認フローは予約時に選択された%a$により決定されます。",
TheAgeOfTheChild_x: "%a$番目の子供の年齢",
TheDateOfDepartureCannotBeEarlierThanThePreviousProcess_x: "%a$の出発日は前の行程より前の日付に設定できません。",
TheIdentityOfPassengerXHasNotBeenVerified_x: "乗車人（%a$）の身元情報確認待ち",
TheNextPageIsNotUnderOuControl_x: "これより外部ページへ遷移します。ご注意ください。%a$",
TheVerificationCodeHasBeenSentTo_1_x: "認証コードを%a$に送信しました",
TheVerificationCodeHasBeenSentTo_x: "認証コードを%a$に送信しました",
ThisOrderUseFld_x: "本予約に %a$ 代金豆 をご利用いただけます",
ThisOrderUseLxd_x: "本予約に %a$ Travel Beans をご利用いただけます",
ThJourneyIsXAndIsExpectedToTakeXMinutes_x_x: "総距離 %a$ km、所要時間約 %b$ 分",
TicketRestrictions_x: "変更・払戻 %a$〜",
TicketRestrictions_x_x: "変更・払戻 %a$%b$〜",
Tickets_x: "%a$ 枚",
TimesFormat_x: "%a$ 回",
Tomorrow_x: "翌日 %a$",
Total_x: "計 %a$",
TotalAmount_x: "合計金額：%a$",
TotalCabinInfo_x: "合計 %a$ 件のフライト情報",
TotalDuration_x: "総所要時間：%a$",
TotalNights: "%a$ 泊",
TotalNights_1: "合計 %a$ 泊",
TotalOfDay_x: "%a$ 日間",
TotalPiece_x: "合計 %a$ 点",
TotalPrice_x: "合計料金：%a$",
TotalTrip_x: "(合計 %a$ 行程)",
TrainPreferQuietCoach_x: "%a$座席を優先選択",
TrainTicketSmsVerification_x_x_x: "乗車人（%a$）に、30分以内に携帯番号 %b$ から12306宛てにショートメッセージ「%c$」を送信して確認を行うようお伝えください。",
Transfer_1_x: "%a$経由",
Transfer_2_x: "乗り継ぎ %a$ 回",
Transfer_3_x: "%a$で乗り換え",
Transfer_Stop_x_x: "乗り継ぎ %a$ 回、経由地 %b$ ヶ所",
Transfer_x: "乗り継ぎ %a$",
Traveler_x: "出張者：%a$",
TripInfo_x_x_x: "%a$がサービスを提供。総距離 %b$ km、所要時間 %c$ 分。",
UnbindConfirmationMessage_x: "連携を解除すると、%a$クイックログインなどの関連サービスが利用できなくなります。本当に解除しますか？",
Unit_1_x: "%a$部",
Unit_x: "x %a$部",
Unit_x_x: "%a$ × %b$部",
UnitNumber_x: "部門コード: %a$",
UnusedTicketTitle_x: "搭乗者：%a$ 様は対象路線の未使用航空券をお持ちです。変更手続きにより現在の行程を予約できます。予約する場合は【変更する】ボタンをクリックしてください。",
UseLxd_x: "最大 %a$ Travel Beans まで利用可能",
UseTheCar_x: "%a$ 車両手配",
ValidationCertificateInformationNotPassed_x: "%a$の身分証明書確認に失敗しました",
VerificationCodeAgain_1_x: "認証コードを送信しました。届かない場合は、%a$",
VerificationCodeAgain_x: "認証コードを送信しました。届かない場合は、%a$して再取得してください。",
ViewDesignated_x: "指定された%a$を表示",
ViewOtherPrices_x: "他 %a$ 件の価格を見る",
ViolationOfRankReason_x: "出張規定違反の理由：%a$",
VoiceMaxDuration_x: "音声の最長送信時間：%a$s",
WaitingTime_x: "待ち時間: %a$",
Welcome_x: "ようこそ、%a$様",
Welcome_x_x: "%a$: ようこそ、%b$様",
WholeRoute_x: "全行程 %a$",
XFormatIsIncorrect_x: "%a$の形式が正しくありません",
XHoursBeforeAndAfterTheLowestPrice_x: "前後 %a$ 時間の最安値",
XIDIsWrong_x: "(%a$) 身分証明書確認失敗",
XIsUnderXyearsOld_x: "%a$ 12歳未満",
XOfFlight_x: "フライト %a$",
XTrips_x: "計 %a$ 便",
Year_x: "%a$年",
YourPassengersAreFullToDelete12306_x: "12306の乗客登録数が上限に達しています。今回の予約を完了するには乗客を %a$ 名削除してください。",
YuanStart_x: "¥%a$ 〜",
}